'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _objectWithoutProperties = _interopDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var _taggedTemplateLiteral = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteral'));
var React = require('react');
var React__default = _interopDefault(React);
var utils = require('@startlibs/utils');
var polished = require('polished');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));
var reactRouterDom = require('react-router-dom');
var core = require('@startlibs/core');
var _slicedToArray = _interopDefault(require('@babel/runtime/helpers/slicedToArray'));
var _assign = _interopDefault(require('lodash/fp/assign'));
var _get = _interopDefault(require('lodash/fp/get'));
var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var _uniqueId = _interopDefault(require('lodash/fp/uniqueId'));
var _max = _interopDefault(require('lodash/fp/max'));
var _identity = _interopDefault(require('lodash/fp/identity'));
var _isString = _interopDefault(require('lodash/fp/isString'));
var _without = _interopDefault(require('lodash/fp/without'));
var _toConsumableArray = _interopDefault(require('@babel/runtime/helpers/toConsumableArray'));
var _isObject = _interopDefault(require('lodash/fp/isObject'));
require('@startlibs/components');
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _isFunction = _interopDefault(require('lodash/fp/isFunction'));
var _assertThisInitialized = _interopDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _set = _interopDefault(require('lodash/fp/set'));
var _pullAt = _interopDefault(require('lodash/fp/pullAt'));
var _map = _interopDefault(require('lodash/fp/map'));
var ReactDOM = _interopDefault(require('react-dom'));
var reactIs = require('react-is');
var mitt = _interopDefault(require('mitt'));
require('lodash/fp');
var _typeof = _interopDefault(require('@babel/runtime/helpers/typeof'));
var createEmotion = _interopDefault(require('create-emotion'));

var IconComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IconComponent, _React$Component);

  function IconComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, IconComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(IconComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {};
    return _this;
  }

  _createClass(IconComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var icon = this.props.icon;

      if ((this.props.theme.svgIcons || {})[icon]) {
        this.props.theme.svgLoader(icon).then(function (i) {
          return _this2.setState({
            Svg: i.default
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          children = _this$props.children,
          theme = _this$props.theme,
          clickable = _this$props.clickable,
          customIcon = _this$props.customIcon,
          colorSet = _this$props.colorSet,
          color = _this$props.color,
          rest = _objectWithoutProperties(_this$props, ["icon", "children", "theme", "clickable", "customIcon", "colorSet", "color"]);

      if ((theme.svgIcons || {})[icon]) {
        if (this.state.Svg) {
          return React__default.createElement(this.state.Svg, rest);
        } else {
          return null;
        }
      }

      return React__default.createElement("span", rest, theme.icons[icon] || customIcon && icon, children);
    }
  }]);

  return IconComponent;
}(React__default.Component);

var Icon = styled__default(styled.withTheme(IconComponent)).withConfig({
  displayName: "Icon",
  componentId: "wsq54u-0"
})(["font-family:'", "' !important;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;user-select:none;", ""], function (props) {
  var _props$theme;

  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.iconFont;
}, function (props) {
  return props.clickable && "\n    cursor: pointer;\n    &:hover {\n      opacity: 0.85;\n    }\n  ";
});

var Link = reactRouterDom.Link;

var Loading = styled__default.div.withConfig({
  displayName: "Loading",
  componentId: "sc-5t5spc-0"
})(["z-index:1;", " border-style:solid;border-radius:50%;flex-shrink:0;width:", "px;height:", "px;border-width:", "px;animation:spin 0.6s linear infinite;", " @keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"], function (props) {
  return props.white ? styled.css(["border-color:rgba(255,255,255,0.4);border-top-color:", ";"], props.color || 'rgba(255,255,255,0.9)') : styled.css(["border-color:rgba(0,0,0,0.1);border-color:", ";border-top-color:", ";"], props.color ? polished.transparentize(0.85, props.color) : polished.transparentize(0.85, utils.getColor("main")(props)), props.color || utils.getColor("main"));
}, function (props) {
  return props.size || 26;
}, function (props) {
  return props.size || 26;
}, function (props) {
  return props.borderWidth || 4;
}, function (props) {
  return props.absolute && "\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      right: 0;\n      left: 0;\n      margin: auto;\n    ";
});

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 51%;\n  transform: translateY(-50%);\n  right: 1rem;\n  font-size: 12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var DropdownIcon = utils.styledExtend(Icon)(_templateObject());
var LockIcon = styled__default(Icon).withConfig({
  displayName: "Button__LockIcon",
  componentId: "qe54pl-0"
})(["position:absolute;bottom:10px;right:.75rem;left:auto;top:auto;font-size:18px;"]);
var focus = styled.css([":after{content:'';pointer-events:none;position:absolute;top:-3px;right:-3px;left:-3px;bottom:-3px;border-radius:", ";border:2px solid rgba(0,0,0,0.15);}"], function (props) {
  return props.rounded ? '100px' : '9px';
});
var Button = styled__default(React__default.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "button" : _ref$type,
      locked = _ref.locked,
      color = _ref.color,
      alpha = _ref.alpha,
      success = _ref.success,
      alert = _ref.alert,
      warning = _ref.warning,
      highlight = _ref.highlight,
      light = _ref.light,
      hover = _ref.hover,
      white = _ref.white,
      icon = _ref.icon,
      onlyIcon = _ref.onlyIcon,
      small = _ref.small,
      withDropdown = _ref.withDropdown,
      onlyDropdown = _ref.onlyDropdown,
      outline = _ref.outline,
      dashed = _ref.dashed,
      textOnly = _ref.textOnly,
      isLoading = _ref.isLoading,
      isLoadingIcon = _ref.isLoadingIcon,
      dark = _ref.dark,
      _ref$innerAs = _ref.innerAs,
      Wrapper = _ref$innerAs === void 0 ? 'button' : _ref$innerAs,
      className = _ref.className,
      children = _ref.children,
      rounded = _ref.rounded,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 1 : _ref$tabIndex,
      focused = _ref.focused,
      noFocus = _ref.noFocus,
      colorSet = _ref.colorSet,
      concealed = _ref.concealed,
      concealedModule = _ref.concealedModule,
      buttonRef = _ref.buttonRef,
      props = _objectWithoutProperties(_ref, ["type", "locked", "color", "alpha", "success", "alert", "warning", "highlight", "light", "hover", "white", "icon", "onlyIcon", "small", "withDropdown", "onlyDropdown", "outline", "dashed", "textOnly", "isLoading", "isLoadingIcon", "dark", "innerAs", "className", "children", "rounded", "tabIndex", "focused", "noFocus", "colorSet", "concealed", "concealedModule", "buttonRef"]);

  return React__default.createElement(Wrapper, _extends({
    ref: ref || buttonRef,
    tabIndex: tabIndex,
    className: className + ' styled-button',
    type: Wrapper === 'button' ? type : ''
  }, props), icon && React__default.createElement(Icon, {
    icon: icon
  }), isLoadingIcon && React__default.createElement(Loading, {
    white: !light && !outline && !dashed && !white,
    size: small ? '10' : '18',
    borderWidth: small ? '2' : '3'
  }), (withDropdown || onlyDropdown) && !locked && React__default.createElement(DropdownIcon, {
    icon: "arrow-down"
  }), locked && React__default.createElement(LockIcon, {
    icon: "lock"
  }), children, isLoading && React__default.createElement(Loading, {
    white: !light && !outline && !dashed && !white,
    absolute: true,
    size: small && '16',
    borderWidth: small && '3'
  }));
})).withConfig({
  displayName: "Button",
  componentId: "qe54pl-1"
})(["vertical-align:top;border:0;font-size:12px;border-radius:", ";background:", ";color:white;min-width:8rem;font-weight:500;display:inline-block;line-height:16px;text-align:center;padding:10px 1.25rem;outline:none;cursor:pointer;position:relative;text-decoration:none;user-select:none;flex-shrink:0;:hover{background:", ";}:active{background:", ";}", " ", " + .styled-button{margin-left:1rem;}", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.rounded ? '100px' : '6px';
}, utils.getColor, function (props) {
  return polished.darken(0.05, utils.getColor(props, true));
}, function (props) {
  return polished.darken(0.08, utils.getColor(props, true));
}, function (props) {
  return props.nowrap && "\n    white-space: nowrap;\n  ";
}, function (props) {
  return !props.noFocus && !props.isLoading && styled.css([":focus{", "}", ""], focus, function (props) {
    return props.focused && focus;
  });
}, function (props) {
  return props.hasErrors && styled.css([":after{content:'';pointer-events:none;position:absolute;top:-4px;right:-4px;left:-4px;bottom:-4px;border-radius:", ";border:3px solid ", ";}"], function (props) {
    return props.rounded ? '100px' : '9px';
  }, function (props) {
    return polished.transparentize(0.7, utils.getColor("alert")(props));
  });
}, function (props) {
  return props.icon && styled.css(["display:inline-flex;align-items:center;justify-content:center;min-width:3rem;min-height:3rem;", "{font-size:23px;margin-right:8px;margin-left:-4px;pointer-events:none;line-height:0;}"], Icon);
}, function (props) {
  return props.onlyIcon && styled.css(["padding:0;", "{margin:0;}"], Icon);
}, function (props) {
  return props.small && styled.css(["font-size:12px;padding:4px 1rem;min-width:2rem;min-height:2rem;", " ", ""], props.icon && styled.css(["", "{font-size:18px;margin-right:5px;margin-left:-5px;line-height:0.9;}"], Icon), props.onlyIcon && styled.css(["padding:0;", "{margin:0;}"], Icon));
}, function (props) {
  return props.big && styled.css(["font-size:14px;padding:13px 1.75rem;min-height:42px;"]);
}, function (props) {
  return props.withDropdown && styled.css(["padding-right:2.25rem;text-align:left;"]);
}, function (props) {
  return props.onlyDropdown && styled.css(["", "{right:50%;transform:translate(50%,-50%);}"], DropdownIcon);
}, function (props) {
  return props.light && styled.css(["background:", ";color:", ";:hover{background:", ";}:active{background:", ";}"], utils.getColor('bluishGray'), utils.getColor('gray120'), function (props) {
    return polished.darken(0.05, utils.getColor('bluishGray')(props));
  }, function (props) {
    return polished.darken(0.08, utils.getColor('bluishGray')(props));
  });
}, function (props) {
  return props.lightAlert && styled.css(["background:", ";color:", ";:hover{background:", ";}:active{background:", ";}"], function (props) {
    return polished.transparentize(0.88, utils.getColor("alert")(props));
  }, utils.getColor('alert'), function (props) {
    return polished.transparentize(0.85, utils.getColor("alert")(props));
  }, function (props) {
    return polished.transparentize(0.82, utils.getColor("alert")(props));
  });
}, function (props) {
  return props.lightWarning && styled.css(["background:", ";color:", ";:hover{background:", ";}:active{background:", ";}"], function (props) {
    return polished.transparentize(0.84, polished.darken(0.05, utils.getColor('warning')(props)));
  }, function (props) {
    return polished.darken(0.05, utils.getColor('warning')(props));
  }, function (props) {
    return polished.transparentize(0.78, polished.darken(0.05, utils.getColor('warning')(props)));
  }, function (props) {
    return polished.transparentize(0.76, polished.darken(0.05, utils.getColor('warning')(props)));
  });
}, function (props) {
  return (props.outline || props.dashed || props.textOnly) && styled.css(["color:", ";background:none;", ",", "{color:", ";}:before{content:'';border:1px ", " ", ";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:", ";pointer-events:none;}:hover{background-color:rgba(0,0,0,0.05);}:active{background-color:rgba(0,0,0,0.08);}:focus{:before{box-shadow:0 0 0 2px rgba(0,0,0,0.1);", "}:after{content:none;}}"], props.white ? 'white' : props.highlight ? utils.getColor('main') : 'rgba(0,0,0,0.6)', Icon, DropdownIcon, props.white ? 'white' : props.highlight ? utils.getColor('main') : 'rgba(0,0,0,0.5)', props.outline ? 'solid' : props.dashed ? 'dashed' : '', props.white ? 'white' : props.highlight ? utils.getColor('main') : 'rgba(0,0,0,0.35)', props.rounded ? '100px' : '6px', props.textOnly && 'content: none;');
}, function (props) {
  return props.alpha && styled.css(["background:rgba(0,0,0,0.45);:hover{background:rgba(0,0,0,0.50);}:active{background:rgba(0,0,0,0.55);}"]);
}, function (props) {
  return props.white && !props.outline && !props.dashed && styled.css(["color:", ";background:#FFFFFF;:hover{background:", ";}:active{background:", ";}"], utils.getColor('main'), polished.darken(0.05, '#FFFFFF'), polished.darken(0.08, '#FFFFFF'));
}, function (props) {
  return props.isLoading && styled.css(["color:transparent !important;pointer-events:none;", "{visibility:hidden;}"], Icon);
}, function (props) {
  return props.isLoadingIcon && styled.css(["pointer-events:none;", "{visibility:hidden;}", "{left:10px;position:absolute;}"], Icon, Loading);
}, utils.media.mobile(_templateObject2(), function (props) {
  return !props.small && !props.onlyIcon && styled.css(["padding:13px 1.5rem;font-size:13px;"]);
}, function (props) {
  return !props.small && props.onlyIcon && styled.css(["min-width:3.5rem;min-height:3.5rem;"]);
}, function (props) {
  return props.withDropdown && styled.css(["padding-right:2.5rem;", "{right:14px;}"], DropdownIcon);
}), utils.media.max(359)(_templateObject3(), function (props) {
  return !props.small && !props.onlyIcon && !props.onlyDropdown && styled.css(["min-width:0;"]);
}), function (props) {
  return props.fullwidth && "\n    width: 100%;\n  ";
}, utils.customTheme("Button"));

Button.a = function (props) {
  return React__default.createElement(Button, _extends({}, props, {
    className: props.className,
    innerAs: "a"
  }));
};

Button.Link = function (props) {
  return React__default.createElement(Button, _extends({}, props, {
    className: props.className,
    innerAs: Link
  }));
};

var OnClickLoadingButton = function OnClickLoadingButton(_ref) {
  var _onClick = _ref.onClick,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["onClick", "children"]);

  var loading = core.useToggle();
  return React__default.createElement(Button, _extends({
    isLoading: loading.isOpen
  }, props, {
    onClick: function onClick(e) {
      return loading.wait(_onClick(e));
    }
  }), children);
};

var TextButton = styled__default(function (_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      alert = _ref.alert,
      children = _ref.children,
      _ref$innerAs = _ref.innerAs,
      Wrapper = _ref$innerAs === void 0 ? 'div' : _ref$innerAs,
      props = _objectWithoutProperties(_ref, ["className", "isLoading", "alert", "children", "innerAs"]);

  return React__default.createElement(Wrapper, _extends({
    className: className
  }, props), children, " ", isLoading && React__default.createElement(Loading, {
    size: 14,
    borderWidth: 3
  }));
}).withConfig({
  displayName: "TextButton",
  componentId: "sc-1eydmhc-0"
})(["display:inline-block;font-weight:500;font-size:13px;color:", ";cursor:pointer;text-decoration:none;:hover,:active{color:", ";}", "{display:inline-block;margin-left:0.25rem;vertical-align:-3px;}", " & ~ &{margin-left:1rem;}"], function (props) {
  return props.alert ? utils.getColor('alert') : utils.getColor('main');
}, function (props) {
  return props.alert ? polished.darken(0.1, utils.getColor("alert")(props)) : polished.darken(0.1, utils.getColor("main")(props));
}, Loading, function (props) {
  return props.nowrap && "\n    white-space: nowrap;\n  ";
});

TextButton.a = function (props) {
  return React__default.createElement(TextButton, _extends({}, props, {
    className: props.className,
    innerAs: "a"
  }));
};

TextButton.Link = function (props) {
  return React__default.createElement(TextButton, _extends({}, props, {
    className: props.className,
    innerAs: Link
  }));
};

var ErrorBoundary =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ErrorBoundary).call(this, props));
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        this.setState({
          hasError: false
        });
      }

      if (this.props.resetOn !== prevProps.resetOn) {
        this.setState({
          hasError: false
        });
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(e, info) {
      var error = e && e.stack;

      if (e === null || e === void 0 ? void 0 : e.notFound) {
        return;
      }

      try {
        if (!e || !e.stack) {
          JSON.stringify(e);
        }
      } catch (exception) {
        error = e.toString();
      }

      if (!/bot|spider|crawl/i.test(window.navigator.userAgent)) {
        utils.postFetcher("/log/errorBoundary", {
          error: error,
          info: info
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          Error = _this$props.Error,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["Error", "children"]);

      var _this$state = this.state,
          hasError = _this$state.hasError,
          error = _this$state.error;

      if (hasError) {
        // You can render any custom fallback UI
        return React__default.createElement(Error, _extends({}, props, {
          error: error,
          fixed: function fixed() {
            return _this2.setState({
              hasError: false,
              error: null
            });
          }
        }));
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true,
        error: error
      };
    }
  }]);

  return ErrorBoundary;
}(React__default.Component); // StartlibsProvider.registerInternal('ErrorBoundary',ErrorBoundary)

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["test"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var getMargins = function getMargins(domNode) {
  var _window$getComputedSt = window.getComputedStyle(domNode),
      marginTop = _window$getComputedSt.marginTop,
      marginLeft = _window$getComputedSt.marginLeft,
      marginBottom = _window$getComputedSt.marginBottom,
      marginRight = _window$getComputedSt.marginRight,
      paddingTop = _window$getComputedSt.paddingTop;

  return {
    marginTop: marginTop,
    marginLeft: marginLeft,
    marginBottom: marginBottom,
    marginRight: marginRight,
    paddingTop: paddingTop
  };
};

var getParentProperties = function getParentProperties(parentNode) {
  if (!parentNode) return {};

  var _window$getComputedSt2 = window.getComputedStyle(parentNode),
      marginTop = _window$getComputedSt2.marginTop,
      marginLeft = _window$getComputedSt2.marginLeft,
      marginBottom = _window$getComputedSt2.marginBottom,
      marginRight = _window$getComputedSt2.marginRight,
      paddingBottom = _window$getComputedSt2.paddingBottom,
      paddingTop = _window$getComputedSt2.paddingTop;

  return {
    parentStyle: {
      marginTop: marginTop,
      marginLeft: marginLeft,
      marginBottom: marginBottom,
      marginRight: marginRight,
      paddingBottom: paddingBottom,
      paddingTop: paddingTop
    },
    parentNode: parentNode
  };
};

var toPosition = function toPosition(domNode) {
  var parentRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : domNode.offsetParent ? domNode.offsetParent.getBoundingClientRect() : {
    top: 0,
    left: 0
  };

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      allowFixed = _ref.allowFixed,
      finalPosition = _ref.finalPosition,
      withMargins = _ref.withMargins;

  if (!allowFixed && domNode.style.position === 'fixed' || domNode.style.display === 'none') return;

  var _domNode$getBoundingC = domNode.getBoundingClientRect(),
      left = _domNode$getBoundingC.left,
      top = _domNode$getBoundingC.top,
      height = _domNode$getBoundingC.height,
      width = _domNode$getBoundingC.width;

  var margins = withMargins ? getMargins(domNode) : {}; // const {offsetLeft, offsetTop} = domNode

  return _objectSpread({
    domNode: domNode,
    nextSibling: domNode.nextSibling,
    top: finalPosition ? domNode.offsetTop : top - parentRect.top,
    left: finalPosition ? domNode.offsetLeft : left - parentRect.left,
    height: height,
    width: width
  }, getParentProperties(domNode.parentNode), margins);
};

var sumWithPx = function sumWithPx() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.map(parseFloat).reduce(function (a, b) {
    return a + b;
  }, 0) + 'px';
};

var childMAp = function childMAp(childs, fn) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = childs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var c = _step.value;
      fn(c);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var defaultAnimationMaker = utils.animationTiming('0.25s ease-out');
var defaultEnterAnimation = utils.oneWayAnimation('opacity: 0;', 'opacity: 1;');
var defaultSwitchAnimation = utils.oneWayAnimation("opacity: 1;", "opacity: 0;", "opacity: 0;");
var SHORT_ANIMATIONS = {
  fadeIn: defaultEnterAnimation
};
var b = styled.createGlobalStyle(_templateObject$1());

var applyDefault = function applyDefault(k) {
  return SHORT_ANIMATIONS[k] || k;
};

var formatAnimation = function formatAnimation(animationName
/* array or string or fn with array or string*/
, animationTimer
/* string or fn */
, reverse) {
  var animationMaker = typeof animationTimer === 'string' ? function (k) {
    return k + ' ' + animationTimer;
  } : animationTimer;
  var animationNameExecuted = typeof animationName === 'function' ? animationName() : animationName;
  var keyframes = [].concat(typeof animationNameExecuted === 'string' ? animationNameExecuted.split(',') : animationNameExecuted);

  var applyReverse = function applyReverse(k) {
    return reverse ? k + ' reverse' : k;
  };

  return keyframes.map(function (k) {
    return b && applyReverse(k.trim().indexOf(' ') < 0 ? animationMaker(k) : applyDefault(k));
  }).join(', ');
};

var cloneWrapper = function cloneWrapper(element) {
  var cloned = element.cloneNode(true);
  var tempWrapper = document.createElement('div');
  [].slice.call(cloned.childNodes).forEach(function (c) {
    return tempWrapper.append(c);
  });

  var _window$getComputedSt3 = window.getComputedStyle(element),
      display = _window$getComputedSt3.display,
      width = _window$getComputedSt3.width,
      height = _window$getComputedSt3.height,
      padding = _window$getComputedSt3.padding,
      borderLeftWidth = _window$getComputedSt3.borderLeftWidth,
      borderRightWidth = _window$getComputedSt3.borderRightWidth,
      borderBottomWidth = _window$getComputedSt3.borderBottomWidth,
      borderTopWidth = _window$getComputedSt3.borderTopWidth;

  Object.assign(tempWrapper.style, {
    display: display,
    width: sumWithPx(width, '-' + borderLeftWidth, '-' + borderRightWidth),
    height: sumWithPx(height, '-' + borderBottomWidth, '-' + borderTopWidth),
    padding: padding,
    position: 'absolute',
    top: 0,
    left: 0
  });
  return tempWrapper;
};

var morphingEndEvents = new Map();
var morphTime = new Map();
var continueSwitchCallbacks = new Map();

var continueSwitchOnClone = function continueSwitchOnClone(oldWrapper) {
  return function (newWrapper) {
    var prevOldClone = oldWrapper.querySelector('.JS-old-snap');
    var prevNewClone = oldWrapper.querySelector('.JS-new-snap');
    var oldClone = newWrapper.querySelector('.JS-old-snap');
    var newClone = newWrapper.querySelector('.JS-new-snap');
    oldClone.style.animationDelay = getDelays(prevOldClone, oldClone.style.animation);
    newClone.style.animationDelay = getDelays(prevNewClone, newClone.style.animation);
    morphTime.set(oldClone, morphTime.get(prevOldClone));
    morphTime.set(newClone, morphTime.get(prevNewClone));
    oldClone.addEventListener('animationend', oldClone.remove);
    newClone.addEventListener('animationend', finishSwitchNew(newClone, newWrapper));
    continueSwitchCallbacks.delete(oldWrapper);
    continueSwitchCallbacks.set(newWrapper, continueSwitchOnClone(newWrapper));
  };
};

var finishSwitchNew = function finishSwitchNew(clone, wrapper) {
  return function () {
    clone.remove();
    var newChildren = [].slice.call(wrapper.children);
    childMAp(newChildren, function (c) {
      if (c.dataset) {
        c.style.opacity = c.dataset.prevOpacity || '';
      }
    }); // wrapper.style.willChange = ''

    continueSwitchCallbacks.delete(wrapper);
  };
};

var supportsEvent = "onanimationend" in HTMLElement.prototype;
var morph = function morph(node, animation, callback) {
  if (!animation) {
    return;
  }

  var _ref2 = morphingEndEvents.get(node) || [],
      _ref3 = _slicedToArray(_ref2, 2),
      cachedAnimation = _ref3[0],
      cachedCallback = _ref3[1];

  var oldAnimation = cachedAnimation || node.style.animation;
  morphTime.set(node, Date.now());
  var didNotStartPromise = Promise.race([new Promise(function (res) {
    return node.addEventListener('animationstart', res);
  }), new Promise(function (res, rej) {
    return setTimeout(rej, supportsEvent ? 1000 : 200);
  })]);
  node.style.animation = animation;

  if (!cachedCallback) {
    var end = function end(_ref4) {
      var target = _ref4.target;
      if (target !== node) return;
      morphTime.delete(node);
      morphingEndEvents.delete(node);
      node.removeEventListener('animationend', end);
      callback && callback();
      node.style.animation = oldAnimation;
    };

    didNotStartPromise.catch(function () {
      return end({
        target: node
      });
    });
    node.addEventListener('animationend', end);
    morphingEndEvents.set(node, [oldAnimation, end]);
  }
};

var hasClientRectChanged = function hasClientRectChanged(oldSnap, newSnap) {
  return !['top', 'left', 'height', 'width'].every(function (_) {
    return oldSnap[_] === newSnap[_];
  });
};

var getClientRectAnimation = function getClientRectAnimation(oldSnap, newSnap) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      skipTransform = _ref5.skipTransform,
      smallJumpFix = _ref5.smallJumpFix;

  if (oldSnap && newSnap && hasClientRectChanged(oldSnap, newSnap)) {
    var _oldSnap$parentStyle, _newSnap$parentStyle, _oldSnap$parentStyle2, _newSnap$parentStyle2;

    var node = newSnap.domNode;
    var offsetLeft = node.offsetLeft,
        offsetTop = node.offsetTop,
        scrollHeight = node.scrollHeight,
        clientHeight = node.clientHeight,
        scrollWidth = node.scrollWidth,
        clientWidth = node.clientWidth;
    var scrollTop = node.parentNode && node.parentNode.scrollTop || 0;
    var scrollLeft = node.parentNode && node.parentNode.scrollLeft || 0;
    var left = oldSnap.left - offsetLeft + scrollLeft;
    var top = oldSnap.top - offsetTop + scrollTop;
    var deltaHeight = oldSnap.height - newSnap.height;
    var heightFix = '';
    var finalPadding = '';

    if (deltaHeight > 0) {
      var _window$getComputedSt4 = window.getComputedStyle(node),
          paddingBottom = _window$getComputedSt4.paddingBottom;

      finalPadding = 'padding-bottom:' + paddingBottom + ';';
      heightFix = "padding-bottom: ".concat(sumWithPx(deltaHeight, paddingBottom) + (smallJumpFix || 0), ";");
    }

    var overflowFix = scrollHeight > clientHeight || scrollWidth > clientWidth ? "overflow: hidden;" : "";
    var transform = (left !== 0 || top !== 0) && !skipTransform ? "transform: translate(".concat(left, "px,").concat(top, "px);") : '';
    var parentPaddingTopDelta = (parseInt((_oldSnap$parentStyle = oldSnap.parentStyle) === null || _oldSnap$parentStyle === void 0 ? void 0 : _oldSnap$parentStyle.paddingTop) || 0) - (parseInt((_newSnap$parentStyle = newSnap.parentStyle) === null || _newSnap$parentStyle === void 0 ? void 0 : _newSnap$parentStyle.paddingTop) || 0);
    var parentPaddingBottomDelta = (parseInt((_oldSnap$parentStyle2 = oldSnap.parentStyle) === null || _oldSnap$parentStyle2 === void 0 ? void 0 : _oldSnap$parentStyle2.paddingBottom) || 0) - (parseInt((_newSnap$parentStyle2 = newSnap.parentStyle) === null || _newSnap$parentStyle2 === void 0 ? void 0 : _newSnap$parentStyle2.paddingBottom) || 0);
    var oldMarginTop = (parseInt(oldSnap.marginTop) || 0) + parentPaddingTopDelta;
    var oldMarginBottom = (parseInt(oldSnap.marginBottom) || 0) + parentPaddingBottomDelta;
    var oldTransform = node.style.transform;
    return [utils.oneWayAnimation("\n        ".concat(transform, "\n        ").concat(heightFix, "\n        ").concat(overflowFix, "\n        margin-top: ").concat(oldMarginTop, "px;\n        margin-bottom: ").concat(oldMarginBottom, "px;\n        width: ").concat(oldSnap.width, "px;\n        height: ").concat(Math.max(0, oldSnap.height + (smallJumpFix || 0)), "px;\n        "), "\n        ".concat(finalPadding, "\n        ").concat(oldTransform ? "transform:".concat(oldTransform, ";") : '', "\n        ").concat(overflowFix, "\n        margin-top:").concat(parseInt(newSnap.marginTop) || 0, "px;\n        margin-bottom:").concat(parseInt(newSnap.marginBottom) || 0, "px;\n        width: ").concat(newSnap.width, "px;\n        height: ").concat(Math.max(0, newSnap.height + (smallJumpFix || 0)), "px;\n        "))];
  } else {
    return [];
  }
};

var getClientRectAnimationForSwitch = function getClientRectAnimationForSwitch(oldSnap, newSnap) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      skipTransform = _ref6.skipTransform;

  if (hasClientRectChanged(oldSnap, newSnap)) {
    var _node$parentNode, _node$parentNode2;

    var node = newSnap.domNode;
    var offsetLeft = node.offsetLeft,
        offsetTop = node.offsetTop,
        scrollHeight = node.scrollHeight,
        clientHeight = node.clientHeight,
        scrollWidth = node.scrollWidth,
        clientWidth = node.clientWidth;
    var scrollTop = ((_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : _node$parentNode.scrollTop) || 0;
    var scrollLeft = ((_node$parentNode2 = node.parentNode) === null || _node$parentNode2 === void 0 ? void 0 : _node$parentNode2.scrollLeft) || 0; // get margin-bottom

    var prevBorder = node.style.border;
    node.style.border = '1px solid transparent';
    var borderHeight = node.clientHeight;
    node.style.border = prevBorder; // get negative margin top

    var prevPadding = newSnap.paddingTop;
    var nonPaddingFixTop = newSnap.clonedNode.getBoundingClientRect().top;
    var topWithPaddingFix = nonPaddingFixTop;

    if (!parseInt(prevPadding)) {
      node.style.paddingTop = '1px';
      topWithPaddingFix = newSnap.clonedNode.getBoundingClientRect().top;
      node.style.paddingTop = '';
    }

    var newSnapNegativeTopMarginDelta = topWithPaddingFix - nonPaddingFixTop;
    var newSnapBottomMarginDelta = clientHeight - borderHeight;
    var left = oldSnap.left - offsetLeft + scrollLeft;
    var top = oldSnap.top - offsetTop + scrollTop - newSnapNegativeTopMarginDelta;
    var deltaHeight = oldSnap.height - newSnap.height;
    var heightFix = '';
    var finalPadding = '';

    if (deltaHeight > 0) {
      var _window$getComputedSt5 = window.getComputedStyle(node),
          paddingBottom = _window$getComputedSt5.paddingBottom;

      finalPadding = 'padding-bottom:' + paddingBottom + ';';
      heightFix = "padding-bottom: ".concat(sumWithPx(deltaHeight, paddingBottom), ";");
    }

    var overflowFix = scrollHeight > clientHeight || scrollWidth > clientWidth ? "overflow: hidden;" : "";
    var transform = (left !== 0 || top !== 0) && !skipTransform ? "transform: translate(".concat(left, "px,").concat(top, "px);") : '';
    var oldTransform = node.style.transform;
    return [utils.oneWayAnimation("\n        ".concat(transform, "\n        ").concat(heightFix, "\n        ").concat(overflowFix, "\n        width: ").concat(oldSnap.width, "px;\n        height: ").concat(oldSnap.height, "px;\n        "), "\n        ".concat(finalPadding, "\n        ").concat(oldTransform ? "transform:".concat(oldTransform, ";") : '', "\n        ").concat(overflowFix, "\n        width: ").concat(newSnap.width, "px;\n        height: ").concat(newSnap.height - newSnapBottomMarginDelta, "px;\n        "))];
  } else {
    return [];
  }
};

var willPlaySwitch = function willPlaySwitch(oldSnap, newSnap, _ref7) {
  var switchIn = _ref7.switchIn,
      switchOut = _ref7.switchOut,
      switchAnimation = _ref7.switchAnimation,
      timing = _ref7.timing,
      _ref7$transformHeight = _ref7.transformHeight,
      transformHeight = _ref7$transformHeight === void 0 ? _identity : _ref7$transformHeight;
  var realWrapper = newSnap.domNode;
  var newChildren = [].slice.call(realWrapper.children); // realWrapper.style.willChange = 'width,height,margin-top;'

  if (realWrapper.firstChild) {
    realWrapper.insertBefore(oldSnap.clonedNode, realWrapper.firstChild);
    realWrapper.insertBefore(newSnap.clonedNode, realWrapper.firstChild);
  } else {
    realWrapper.append(oldSnap.clonedNode);
    realWrapper.append(newSnap.clonedNode);
  }

  oldSnap.clonedNode.className = oldSnap.clonedNode.className + ' JS-old-snap';
  newSnap.clonedNode.className = newSnap.clonedNode.className + ' JS-new-snap'; // newSnap.clonedNode.style.willChange = 'width,height,opacity'
  // oldSnap.clonedNode.style.willChange = 'width,height,opacity'

  var realWrapperRect = realWrapper.getBoundingClientRect();
  var resizeToNew = utils.oneWayAnimation("\n    overflow: hidden;\n    width: ".concat(oldSnap.width, "px;\n    height: ").concat(oldSnap.height, "px;\n    "), "\n    overflow: hidden;\n    width: ".concat(newSnap.clonedNode.style.width, ";\n    height: ").concat(utils.callIfFunction(transformHeight, newSnap.clonedNode.style.height, realWrapperRect), ";\n    "));
  childMAp(newChildren, function (c) {
    if (c.dataset && !c.dataset.noFlip) {
      if (c.style.opacity) {
        c.dataset.prevOpacity = c.style.opacity;
      }

      c.style.opacity = '0';
    }
  });
  childMAp([].slice.call(oldSnap.clonedNode.children), function (c) {
    if (c.dataset && c.dataset.noFlip) {
      c.style.opacity = '0';
    }
  });
  var resizeOld = oldSnap.width > newSnap.width || oldSnap.height > newSnap.height ? [resizeToNew] : [resizeToNew];
  var resizeNew = oldSnap.width < newSnap.width || oldSnap.height < newSnap.height ? [resizeToNew] : [resizeToNew];
  return function () {
    morph(oldSnap.clonedNode, formatAnimation([].concat(switchOut || switchAnimation, resizeOld), timing), function () {
      return oldSnap.clonedNode.remove();
    });
    newSnap.clonedNode.style.opacity = '0';
    continueSwitchCallbacks.set(realWrapper, continueSwitchOnClone(realWrapper));
    morph(newSnap.clonedNode, formatAnimation([formatAnimation(switchIn || switchAnimation, timing, !switchIn)].concat(resizeNew), timing), finishSwitchNew(newSnap.clonedNode, realWrapper));
  };
};

var getDelays = function getDelays(el, animation) {
  var delayStr = morphTime.get(el) - Date.now() + 'ms';
  return animation.split(',').map(function (_) {
    return delayStr;
  }).join(',');
};

var Snapshoter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Snapshoter, _React$Component);

  function Snapshoter() {
    _classCallCheck(this, Snapshoter);

    return _possibleConstructorReturn(this, _getPrototypeOf(Snapshoter).apply(this, arguments));
  }

  _createClass(Snapshoter, [{
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(oldProps) {
      if (oldProps.on !== this.props.on) {
        console.log('on', 'UHUL');
      } else if (oldProps.moveOn !== this.props.moveOn) {
        console.log('moveOn', 'UHUL');
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Snapshoter;
}(React__default.Component);

var useFlip = function useFlip(_ref8) {
  var on = _ref8.on,
      moveOn = _ref8.moveOn;
  core.useHiddenFill(React__default.createElement(Snapshoter, {
    on: on,
    moveOn: moveOn,
    callback: console.log
  }));
};

var getAnimationNames = function getAnimationNames(animation) {
  return animation.split(',').map(function (_) {
    return _.replace(/\s*(\S+).*/, '$1');
  });
};

var willUseFlip = function willUseFlip() {
  var controlElement = null;
  var morphEnabled = false;

  var disableMorph = function disableMorph() {
    controlElement = null;
    morphEnabled = false;
  };

  var _willUseSharedCallbac = core.willUseSharedCallback(React.useLayoutEffect),
      _willUseSharedCallbac2 = _slicedToArray(_willUseSharedCallbac, 2),
      useRegisterEnter = _willUseSharedCallbac2[0],
      enterChildrenCallback = _willUseSharedCallbac2[1];

  var _willUseSharedCallbac3 = core.willUseSharedCallback(React.useLayoutEffect),
      _willUseSharedCallbac4 = _slicedToArray(_willUseSharedCallbac3, 2),
      useRegisterLeave = _willUseSharedCallbac4[0],
      leaveChildrenCallback = _willUseSharedCallbac4[1];

  var _willUseSharedCallbac5 = core.willUseSharedCallback(React.useLayoutEffect),
      _willUseSharedCallbac6 = _slicedToArray(_willUseSharedCallbac5, 3),
      useRegisterMorph = _willUseSharedCallbac6[0],
      morphChildrenCallback = _willUseSharedCallbac6[1],
      getSize = _willUseSharedCallbac6[2];

  var useEnterAnimation = function useEnterAnimation(ref) {
    var onEnter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEnterAnimation;

    var _ref9 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        onEnterEnd = _ref9.onEnterEnd,
        _ref9$timing = _ref9.timing,
        timing = _ref9$timing === void 0 ? defaultAnimationMaker : _ref9$timing,
        enterEffect = _ref9.enterEffect;

    React.useLayoutEffect(function () {
      if (!morphEnabled && onEnter && ref.current) {
        var el = ref.current;
        var animation = formatAnimation(onEnter, timing);
        var endEffect = utils.callIfFunction(enterEffect, el);
        morph(el, animation, function () {
          utils.callIfFunction(onEnterEnd);
          utils.callIfFunction(endEffect, el);
        });
        enterChildrenCallback(timing);
      }
    }, [onEnter]);
  };

  var useLeaveAnimation = function useLeaveAnimation(ref) {
    var onLeave = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEnterAnimation;

    var _ref10 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        removeRef = _ref10.ref,
        leaveEffect = _ref10.leaveEffect,
        _ref10$timing = _ref10.timing,
        timing = _ref10$timing === void 0 ? defaultAnimationMaker : _ref10$timing,
        _ref10$nestedFlip = _ref10.nestedFlip,
        nestedFlip = _ref10$nestedFlip === void 0 ? false : _ref10$nestedFlip,
        _ref10$events = _ref10.events,
        events = _ref10$events === void 0 ? {} : _ref10$events,
        _ref10$reverse = _ref10.reverse,
        reverse = _ref10$reverse === void 0 ? true : _ref10$reverse;

    React.useLayoutEffect(function () {
      return function () {
        if (onLeave && ref.current) {
          var el = ref.current;
          var animation = formatAnimation(onLeave, timing, reverse); // on leave animations require a clone, as the real node will be intantaneousy removed by react

          leaveChildrenCallback(timing);
          var isNested = utils.callIfFunction(nestedFlip);
          var clone = isNested ? el : el.cloneNode(true);

          utils._s.each(function (callback, type) {
            return clone.addEventListener(type, callback);
          }, events);

          var endEffect = utils.callIfFunction(leaveEffect, clone, el);

          if (removeRef) {
            removeRef.current = clone;
          }

          if (!isNested) {
            el.parentNode.insertBefore(clone, el);
          } // sometimes the clone may need to trigger events (usual case: onmouseover to reopen the element)
          // allow clone to be continued by another animation


          controlElement = clone; // the animation

          var animate = function animate() {
            morph(clone, animation, function () {
              clone.remove();
              disableMorph();
              utils.callIfFunction(endEffect, clone, el);
            });
          }; // wait for current animation to end and then animate


          if (clone.style.animation) {
            var maxAnimationTime = _max((clone.style.animationDuration.split(",") || ["0.25s"]).map(function (s) {
              return parseFloat(s.trim() || "0.25") * (s.indexOf("m") > 0 ? 1 : 1000);
            }));

            var timeoutRef = {};

            var animationEnd = function animationEnd(e) {
              clearTimeout(timeoutRef.current || -1);
              clone.removeEventListener('animationend', animationEnd);
              clone.animationDelay = '';
              e === null || e === void 0 ? void 0 : e.stopImmediatePropagation();
              setTimeout(animate, 1);
            };

            timeoutRef.current = setTimeout(animationEnd, maxAnimationTime);
            clone.addEventListener('animationend', animationEnd);
            clone.style.animationDelay = getDelays(el, clone.style.animation);
          } else {
            animate();
          }
        }
      };
    }, [onLeave]);
  };

  var useMorphAnimation = function useMorphAnimation(ref) {
    var ready = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var _ref11 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref11$timing = _ref11.timing,
        timing = _ref11$timing === void 0 ? defaultAnimationMaker : _ref11$timing;

    React.useLayoutEffect(function () {
      if (ready && controlElement && ref.current) {
        // const controlElement =getControlElement()
        var el = ref.current;
        var animation = utils.oneWayAnimation("opacity:".concat(window.getComputedStyle(controlElement).opacity, ";"), "opacity: 1");

        var oldSnap = _objectSpread({}, toPosition(controlElement, undefined, {
          allowFixed: true
        }), {
          clonedNode: cloneWrapper(controlElement)
        });

        var newSnap = _objectSpread({}, toPosition(el, undefined, {
          allowFixed: true
        }), {
          clonedNode: cloneWrapper(el)
        });

        var rectAnimation = getClientRectAnimation(oldSnap, newSnap);
        morph(newSnap.domNode, formatAnimation(rectAnimation.concat(animation), timing), disableMorph);
        morphChildrenCallback(function (executeAnimation) {
          return executeAnimation(timing);
        });

        if (rectAnimation.length) {
          willPlaySwitch(oldSnap, newSnap, {
            switchAnimation: defaultSwitchAnimation,
            timing: timing
          })();
        }

        controlElement.remove();
        disableMorph();
      }

      return function () {
        morphEnabled = true; // continue existing switch animation on the clone

        if (continueSwitchCallbacks.has(ref.current)) {
          continueSwitchCallbacks.get(ref.current)(controlElement);
        }
      };
    }, [ready]);
  };

  var useNestedEnterAnimation = function useNestedEnterAnimation(ref, onEnter) {
    var _ref12 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        timing = _ref12.timing;

    useRegisterEnter(function (parentTiming) {
      var el = ref.current;
      var animation = formatAnimation(onEnter, timing || parentTiming);
      morph(el, animation);
      return getAnimationNames(animation);
    });
  };

  var useNestLeaveAnimation = function useNestLeaveAnimation(ref, onLeave) {
    var _ref13 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        timing = _ref13.timing,
        events = _ref13.events;

    useRegisterLeave(function (parentTiming) {
      var el = ref.current;
      var animation = formatAnimation(onLeave, timing || parentTiming);
      morph(el, animation);
      return getAnimationNames(animation);
    });
  };

  var willUseNestedMorphAnimation = function willUseNestedMorphAnimation() {
    var morphId = _uniqueId('JS-');

    return function (ref) {
      React.useLayoutEffect(function () {
        var _ref$current;

        if ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.dataset) {
          ref.current.dataset.morphId = morphId;
        }
      });
      var executeAnimation = core.useConstant(function (timing) {
        var prev = controlElement.querySelector("[data-morph-id='".concat(morphId, "']"));
        var next = ref.current;

        if (next.dataset) {
          next.dataset.noFlip = true;
        }

        next.style.opacity = '1';
        var prevPos = prev.getBoundingClientRect();
        var nextPos = next.getBoundingClientRect();
        var originalTransform = next.style.transform || '';
        var deltaX = Math.round(nextPos.left - prevPos.left);
        var deltaY = Math.round(nextPos.top - prevPos.top);
        var newLeft = deltaX > 0 ? -deltaX : -deltaX;
        var animation = utils.oneWayAnimation("\n          transform: translate(".concat(newLeft, "px,").concat(deltaY, "px) ").concat(originalTransform, ";\n        "), "\n          transform: translate(0,0) ".concat(originalTransform, ";\n        "));
        morph(next, formatAnimation(animation, timing));
      });
      useRegisterMorph(executeAnimation);
    };
  };

  return [[useEnterAnimation, useLeaveAnimation, useMorphAnimation], [useNestedEnterAnimation, useNestLeaveAnimation], willUseNestedMorphAnimation];
};
var willUseFlipSwitch = function willUseFlipSwitch() {
  var oldSnap = null;

  var getTempWrapper = function getTempWrapper(parent) {
    var positionConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var tempWrapper = cloneWrapper(parent);
    return _objectSpread({}, toPosition(parent, undefined, positionConfig), {
      clonedNode: tempWrapper
    });
  };

  return function (ref, onEnter, onLeave) {
    var _ref14 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref14$timing = _ref14.timing,
        timing = _ref14$timing === void 0 ? defaultAnimationMaker : _ref14$timing,
        _ref14$switchAnimatio = _ref14.switchAnimation,
        switchAnimation = _ref14$switchAnimatio === void 0 ? defaultSwitchAnimation : _ref14$switchAnimatio,
        effect = _ref14.effect;

    React.useLayoutEffect(function () {
      if (oldSnap && ref.current) {
        var newSnap = getTempWrapper(ref.current, {
          withMargins: true
        });
        var switchToPlay = _identity;

        if (oldSnap.clonedNode) {
          switchToPlay = willPlaySwitch(oldSnap, newSnap, {
            switchIn: utils.callIfFunction(onEnter),
            switchOut: utils.callIfFunction(onLeave),
            switchAnimation: utils.callIfFunction(switchAnimation),
            timing: timing
          });
        }

        var animation = getClientRectAnimationForSwitch(oldSnap, newSnap);
        var endEffect = utils.callIfFunction(effect, oldSnap.clonedNode, newSnap.clonedNode, ref.current);
        switchToPlay();
        morph(newSnap.domNode, formatAnimation(animation, timing), function () {
          return utils.callIfFunction(endEffect, oldSnap.clonedNode, newSnap.clonedNode);
        });
      }

      return function () {
        oldSnap = getTempWrapper(ref.current, {
          withMargins: true
        });
      };
    }, []);
  };
};

var _willUseFlip = willUseFlip(),
    _willUseFlip2 = _slicedToArray(_willUseFlip, 1),
    _willUseFlip2$ = _slicedToArray(_willUseFlip2[0], 2),
    useFlipEnter = _willUseFlip2$[0],
    useFlipLeave = _willUseFlip2$[1];
var useFlipAnimation = function useFlipAnimation(ref, onEnterOrBoth) {
  var onLeaveOrIgnore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var onEnter = utils.ifUndefined(onEnterOrBoth && onEnterOrBoth.onEnter, onEnterOrBoth);
  var onLeave = utils.ifUndefined(onEnterOrBoth && onEnterOrBoth.onLeave, onLeaveOrIgnore);
  useFlipEnter(ref, onEnter, config);
  useFlipLeave(ref, onLeave === true ? onEnter : onLeave, _objectSpread({}, config, {
    reverse: onLeave === true
  }));
};

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    padding: ", ";\n  "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var dialogFadeInDown = utils.oneWayAnimation('opacity: 0; transform: translateY(50px);', 'opacity: 1; transform: translateY(0);');

var _twoWayAnimation = utils.twoWayAnimation('opacity: 0;', 'opacity: 1;'),
    _twoWayAnimation2 = _slicedToArray(_twoWayAnimation, 2),
    dialogModalIn = _twoWayAnimation2[0],
    dialogModalOut = _twoWayAnimation2[1];
var Modal = styled__default.div.withConfig({
  displayName: "DialogContainer__Modal",
  componentId: "wendlg-0"
})(["position:fixed;top:0;bottom:0;left:0;right:0;will-change:opacity;background-color:rgba(0,0,0,0.7);"]);
var ModalContainer = styled__default.div.withConfig({
  displayName: "DialogContainer__ModalContainer",
  componentId: "wendlg-1"
})(["position:fixed;top:0;bottom:0;left:0;right:0;"]);
var DialogCenter = styled__default.div.withConfig({
  displayName: "DialogContainer__DialogCenter",
  componentId: "wendlg-2"
})(["@supports (position:sticky){will-change:transform,opacity;&.JS-wc-off{will-change:auto;}}display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:", ";overflow-x:hidden;position:fixed;top:0;bottom:0;left:0;right:0;align-items:center;", " ", ""], function (props) {
  return props.withScroll ? "scroll" : "hidden";
}, utils.media.desktop(_templateObject$2(), function (props) {
  return props.fullscreen ? '1rem' : '3rem 0.5rem;';
}), utils.media.mobile(_templateObject2$1(), function (props) {
  return props.fullscreenOnMobile ? '0' : '0.5rem';
}));
var PopupSlot = styled__default(core.Slot).withConfig({
  displayName: "DialogContainer__PopupSlot",
  componentId: "wendlg-3"
})(["position:absolute;left:0;top:0;width:100%;"]);
var RelativeSlot = styled__default(core.Slot).withConfig({
  displayName: "DialogContainer__RelativeSlot",
  componentId: "wendlg-4"
})(["width:100%;position:absolute;"]);
var editableSelector = 'textarea,input,[contenteditable]';
var focusableSelector = 'button,a,' + editableSelector;
var shouldPreventResolvers = [];
var shouldPreventDialogPop = Promise.resolve();
var preventDialogPop = function preventDialogPop(cb) {
  shouldPreventDialogPop = shouldPreventDialogPop.then(function () {
    new Promise(function (res) {
      shouldPreventResolvers.push(res);
      cb();
    });
  });
};
var waitForPop = function waitForPop() {
  return shouldPreventDialogPop;
};

var preventDialogPopState = function preventDialogPopState(e) {
  var resolver = shouldPreventResolvers.shift();

  if (resolver) {
    e.stopImmediatePropagation();
    resolver();
  }
};

window.addEventListener("popstate", preventDialogPopState);

var fixPosition = function fixPosition(query, fn) {
  var elements = document.querySelectorAll(query);

  if (elements.length) {
    Array.prototype.slice.call(elements).forEach(fn);
  }
};

var openLayers = 0;
var fakedScrollTop = 0;
var isFakeScrolled = function isFakeScrolled() {
  return openLayers > 0 && fakedScrollTop > 0;
};
var removeWindowScroll = function removeWindowScroll(opening, keepDisabledScroll) {
  if (opening) {
    openLayers = Math.max(openLayers + 1, 1);

    if (openLayers > 1) {
      return;
    }
  } else {
    openLayers = Math.min(openLayers - 1, 0);

    if (openLayers < 0) {
      return;
    }
  }

  var finishReset = function finishReset(marginRight, scrollTop) {
    // body.style.paddingRight = marginRight + 'px'
    window.scroll(window.scrollLeft || window.scrollX || 0, scrollTop);

    if (keepDisabledScroll) {
      return;
    }

    fixPosition('.navbar,.JS-fix-dialog-scroll', function (n) {
      if (opening) {
        var _window$getComputedSt = window.getComputedStyle(n),
            right = _window$getComputedSt.right;

        n.style.right = parseInt(right) + marginRight + 'px';
      } else {
        n.style.right = null;
      }
    });
    fixPosition('.JS-fix-dialog-scroll-transform', function (n) {
      if (marginRight) {
        n.style.transform = window.getComputedStyle(n).transform + " translateX(-".concat(marginRight / 2, "px)");
      } else {
        n.style.transform = null;
      }
    });
    window.requestAnimationFrame(function () {
      return window.dispatchEvent(new CustomEvent('resize', {
        detail: {
          dialog: true
        }
      }));
    });
  };

  var body = document.body;
  var bodyWidth = body.offsetWidth;

  if (opening) {
    var scrollTop = window.pageYOffset;
    fakedScrollTop = scrollTop;

    if (keepDisabledScroll) {
      body.style.overflowY = 'scroll';
    } else {
      body.style.overflow = 'hidden';
    }

    var marginRight = body.offsetWidth - bodyWidth;
    body.style.position = 'fixed';
    body.style.top = -scrollTop + "px";
    body.style.left = '0';

    if (!keepDisabledScroll) {
      body.style.right = marginRight + 'px';
    } else {
      body.style.right = '0';
    }

    finishReset(marginRight, scrollTop);
  } else {
    fakedScrollTop = 0; // setTimeout(() => {

    var _scrollTop = parseInt(body.style.top);

    body.style.overflow = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    finishReset(0, -_scrollTop); // },250)
  }
};

var _willUseLayers = core.willUseLayers(React__default.useLayoutEffect),
    _willUseLayers2 = _slicedToArray(_willUseLayers, 2),
    useDialogLayers = _willUseLayers2[0],
    getDialogLayersSize = _willUseLayers2[1];
var DialogContainer = React.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      title = _ref.title,
      closeDialog = _ref.closeDialog,
      closeOnClick = _ref.closeOnClick,
      dontRefocus = _ref.dontRefocus,
      onConfirm = _ref.onConfirm,
      prev = _ref.prev,
      next = _ref.next,
      form = _ref.form,
      noFormWrap = _ref.noFormWrap,
      withFormWrap = _ref.withFormWrap,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'Dialog' : _ref$placement,
      DialogErrorContent = _ref.DialogErrorContent,
      customHref = _ref.customHref,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? dialogFadeInDown : _ref$animation,
      animationTiming = _ref.animationTiming,
      animationLeaveEffect = _ref.animationLeaveEffect,
      animationEnterEffect = _ref.animationEnterEffect,
      skipKeys = _ref.skipKeys,
      fullscreenOnMobile = _ref.fullscreenOnMobile,
      _ref$confirmChanges = _ref.confirmChanges,
      confirmChanges = _ref$confirmChanges === void 0 ? true : _ref$confirmChanges,
      skipDom = _ref.skipDom,
      modalRef = _ref.modalRef,
      skipCheckFocus = _ref.skipCheckFocus,
      autoComplete = _ref.autoComplete;
  var dialogRef = core.useEnsureRef(forwardedRef);
  var prevActiveElement = core.useRefState(document.activeElement);
  var modal = core.useEnsureRef(modalRef);
  var modalScroll = React.useRef();
  var mouseDownInModal = core.useRefState();
  var previousHash = core.useRefState(window.location.hash);

  var _useDialogLayers = useDialogLayers({
    onFirst: function onFirst() {
      waitForPop().then(function () {
        if (customHref && encodeURI(customHref) === window.location.hash) {
          window.history.replaceState(history.state, '', window.location.pathname);
          window.history.pushState({
            dialog: true
          }, '', customHref);
        } else {
          window.history.pushState({
            dialog: true
          }, '', window.location.href + (customHref || ""));
        }
      }); // clearPreventDialogPop()

      if (document.body.scrollHeight === document.body.clientHeight) {
        modal.current.style.overflowY = "scroll";

        if (modalScroll.current) {
          modalScroll.current.style.overflowY = "scroll";
        }
      } // resetNavbar(true)

    },
    onEmpty: function onEmpty() {
      if (_get('dialog', window.history.state) === true || customHref && window.location.hash === encodeURI(customHref)) {
        preventDialogPop(function () {
          return window.history.back();
        });
      }

      if (document.body.scrollHeight > document.body.clientHeight) {
        if (modalScroll.current) {
          modalScroll.current.style.overflowY = "hidden";
        }
      } else if (modal.current) {
        modal.current.style.overflowY = "scroll";
      }

      removeWindowScroll(false);
    }
  }),
      _useDialogLayers2 = _slicedToArray(_useDialogLayers, 2),
      layerIndex = _useDialogLayers2[0],
      _useDialogLayers2$ = _useDialogLayers2[1],
      isTop = _useDialogLayers2$.isTop,
      getSize = _useDialogLayers2$.getSize;

  var confirmCloseDialog = function confirmCloseDialog() {
    if (form && form.getHasChanged() && confirmChanges) {
      form.confirm().then(closeDialog);
    } else {
      utils.callIfFunction(closeDialog);
    }
  };
  /*
    useEffect(() => () => {
      setTimeout(() => {
        if (window.location.hash === previousHash.get() && _.get('dialog', window.history.state) === true) {
          console.log("???")
        }
      }, 100)
    }, [])*/


  var pastFirstTime = React__default.useRef();
  React.useEffect(function () {
    if (customHref && window.location.hash !== customHref) {
      // if (pastFirstTime.current) {
      waitForPop().then(function () {
        if (window.location.hash) {
          window.history.replaceState({
            dialog: true
          }, '', customHref);
        } else {
          window.history.pushState({
            dialog: true
          }, '', customHref);
        }
      }); // } else {
      //   window.history.pushState({dialog: true}, '', customHref)
      //   pastFirstTime.current = true
      // }

      previousHash.set(encodeURI(customHref));
    }
  }, [customHref]);
  React.useEffect(function () {
    window.addEventListener('keydown', checkKey);
    window.addEventListener('focusin', checkFocus);
    window.addEventListener('popstate', checkHistory);
    return function () {
      window.removeEventListener('keydown', checkKey);
      window.removeEventListener('focusin', checkFocus);
      window.removeEventListener('popstate', checkHistory);

      if (!dontRefocus && document.body.contains(prevActiveElement.get()) && prevActiveElement.get().matches(focusableSelector)) {
        setTimeout(function () {
          return prevActiveElement.get().focus();
        }, 0);
      }
    };
  }, []);

  var checkHistory = function checkHistory(e) {
    if (!isTop()
    /* || (previousHash.get() !== window.location.hash && !customHref)*/
    ) return;

    if (_get('dialog', window.history.state) !== true) {
      window.history.pushState({
        dialog: true
      }, '', window.location.href);
    }

    confirmCloseDialog();
  };

  var checkFocus = function checkFocus(e) {
    if (!isTop() || skipCheckFocus) return;

    if (modal.current && !e.target.closest('.' + modal.current.className.split(' ').join('.'))) {
      var nextTab = modal.current.querySelector('[tabindex]');
      if (nextTab) nextTab.focus();
    }
  };

  var checkKey = function checkKey(e) {
    var _e$target, _e$target$className, _e$target2;

    if (!isTop() || skipKeys || ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$className = _e$target.className) === null || _e$target$className === void 0 ? void 0 : _e$target$className.indexOf("JS-dialog-skip-evts")) >= 0 || ((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.closest(".JS-dialog-skip-evts"))) return;

    if (modal.current && e.shiftKey && e.keyCode === 9 && modal.current.querySelector('[tabindex]') === document.activeElement) {
      e.preventDefault();
      var prevTab = [].slice.call(modal.current.querySelectorAll('[tabindex]')).reduce(function (acc, el) {
        return el.tabIndex >= acc.tabIndex ? el : acc;
      }, {
        tabIndex: -1
      });
      if (prevTab && prevTab.focus) prevTab.focus();
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      confirmCloseDialog();
    } else if (e.key === 'Enter') {
      if (e.target) {
        var target = e.target.closest(focusableSelector + ',div');
        if (target && (target.tagName.toLowerCase() !== 'input' || target.form || target.type.toLowerCase() === 'file') && target.matches(focusableSelector)) return;
      }

      e.preventDefault();
      e.stopPropagation();

      if (onConfirm) {
        onConfirm();
      } else if (form) {
        form.submitForm();
      }
    } else if (!e.target.matches(editableSelector)) {
      if (e.key === 'ArrowLeft' && prev) {
        prev();
      } else if (e.key === 'ArrowRight' && next) {
        next();
      }
    }
  };

  var checkClick = function checkClick(e) {
    if (closeOnClick && e.target === e.currentTarget && mouseDownInModal.get()) {
      confirmCloseDialog();
    }

    mouseDownInModal.set(false);
  };

  var mouseDown = function mouseDown(e) {
    mouseDownInModal.set(e.target === e.currentTarget);
  };

  var usingForm = withFormWrap || form && !noFormWrap;
  useFlipAnimation(dialogRef, animation, true, {
    nestedFlip: !skipDom,
    onEnterEnd: function onEnterEnd() {
      if (getSize() === 1) {
        removeWindowScroll(true);
      }

      if (document.body.scrollHeight === document.body.clientHeight) {
        modal.current.style.overflowY = "none";
      }

      if (modalScroll.current) {
        modalScroll.current.style.overflowY = "scroll";
      }
    },
    leaveEffect: animationLeaveEffect,
    enterEffect: animationEnterEffect,
    timing: animationTiming
  });
  useFlipAnimation(modal, !skipDom && utils.identityOpacityFrames, true, {
    timing: animationTiming
  });
  var content = React__default.createElement(React__default.Fragment, null, React__default.createElement(PopupSlot, {
    name: 'Popup-' + layerIndex
  }), React__default.createElement(ErrorBoundary, {
    title: utils.callIfFunction(title),
    closeDialog: closeDialog,
    Error: DialogErrorContent
  }, utils.callIfFunction(children, {
    confirmCloseDialog: confirmCloseDialog
  }, dialogRef, fullscreenOnMobile)));
  return React__default.createElement(core.Fill, {
    name: placement
  }, skipDom ? content : React__default.createElement(React__default.Fragment, null, React__default.createElement(AnimatedModal, {
    timing: animationTiming
  }), React__default.createElement(ModalContainer, {
    ref: modal
  }, React__default.createElement(DialogCenter, {
    autoComplete: autoComplete,
    className: "JS-has-wc",
    withScroll: getSize() > 1,
    fullscreenOnMobile: fullscreenOnMobile,
    ref: modalScroll,
    as: usingForm ? 'form' : undefined,
    onClick: checkClick,
    onSubmit: usingForm ? function () {} : undefined,
    onMouseDown: mouseDown
  }, content))));
});
var AnimatedModal = React__default.forwardRef(function (_ref2, ref) {
  var timing = _ref2.timing,
      nestedFlip = _ref2.nestedFlip,
      enterEffect = _ref2.enterEffect,
      leaveEffect = _ref2.leaveEffect,
      _ref2$modalIn = _ref2.modalIn,
      modalIn = _ref2$modalIn === void 0 ? dialogModalIn : _ref2$modalIn,
      _ref2$modalOut = _ref2.modalOut,
      modalOut = _ref2$modalOut === void 0 ? dialogModalOut : _ref2$modalOut,
      props = _objectWithoutProperties(_ref2, ["timing", "nestedFlip", "enterEffect", "leaveEffect", "modalIn", "modalOut"]);

  var modal = core.useEnsureRef(ref);
  useFlipAnimation(modal, modalIn, modalOut, {
    timing: timing,
    nestedFlip: nestedFlip,
    leaveEffect: leaveEffect,
    enterEffect: enterEffect
  });
  return React__default.createElement(Modal, _extends({}, props, {
    ref: modal
  }));
});

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n      flex-wrap: wrap;\n      > * {\n        flex-basis: 47%;\n      }\n    "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n      display: flex;\n      flex-wrap: nowrap;\n      margin-left: -", "rem;\n      margin-right: -", "rem;\n      margin-top: -", "rem;\n      > * {\n        flex-basis: 0;\n        flex-grow: 1;\n        margin-left: ", "rem;\n        margin-right: ", "rem;\n        margin-top: ", "rem;\n      }\n    "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var getMarginFromFieldChild = function getMarginFromFieldChild(props) {
  if (!props.last) return 0;
  var fields = React__default.Children.toArray(props.children).filter(function (c) {
    return c.type.displayName === "Field" || c.type.displayName === "EnhancedInput";
  });
  if (!fields.length) return 0;
  var lastField = fields.slice(-1)[0];
  return '-' + utils.getMargin(props.theme.Field.margins)(lastField.props);
};

var splitColumnMargins = {
  small: 0.5,
  'default': 1,
  big: 2
};
var SplitColumnsContainer = styled__default.div.withConfig({
  displayName: "SplitColumnsContainer",
  componentId: "sc-1h4sw88-0"
})(["margin-bottom:", "rem;", " ", ""], getMarginFromFieldChild, function (props) {
  return styled.css(["", ""], utils.media.min(props.viewportMinWidth || 0)(_templateObject$3(), function (props) {
    return utils.getMargin(splitColumnMargins)(props) / 2;
  }, function (props) {
    return utils.getMargin(splitColumnMargins)(props) / 2;
  }, function (props) {
    return utils.getMargin(splitColumnMargins)(props);
  }, function (props) {
    return utils.getMargin(splitColumnMargins)(props) / 2;
  }, function (props) {
    return utils.getMargin(splitColumnMargins)(props) / 2;
  }, function (props) {
    return utils.getMargin(splitColumnMargins)(props);
  }));
}, function (props) {
  return props.twoColumnsBelowVW && styled.css(["", ""], utils.media.max(props.twoColumnsBelowVW)(_templateObject2$2()));
});
var fixDoubledLastMarginBottom = function fixDoubledLastMarginBottom(children) {
  var last = React__default.Children.count(children) - 1;

  function processChild(child, i) {
    if (i === last && child && child.type && child.type.displayName === SplitColumnsContainer.displayName) {
      return React__default.cloneElement(child, {
        last: true
      });
    }

    return child;
  }

  if (!Array.isArray(children) || children.length === 0) {
    return processChild(children, 0);
  }

  while ((!children[last] || children[last] && children[last].type && children[last].type.displayName === "Errors") && last > 0) {
    last--;
  }

  return React__default.Children.map(children, processChild);
};

var _twoWayAnimation$1 = utils.twoWayAnimation('opacity:0;', 'opacity:1;'),
    _twoWayAnimation2$1 = _slicedToArray(_twoWayAnimation$1, 2),
    loadingEnter = _twoWayAnimation2$1[0],
    loadingLeave = _twoWayAnimation2$1[1];

var _twoWayAnimation3 = utils.twoWayAnimation('opacity:0; transform:translateY(50%)', 'opacity:1;transform:translateY(0)'),
    _twoWayAnimation4 = _slicedToArray(_twoWayAnimation3, 2),
    onEnter = _twoWayAnimation4[0],
    onLeave = _twoWayAnimation4[1];

var BlockContainer = styled__default.div.withConfig({
  displayName: "LoadingDiv__BlockContainer",
  componentId: "sc-1g7ljba-0"
})(["position:relative;"]);

var FlipDiv = function FlipDiv(_ref) {
  var useAnimation = _ref.useAnimation,
      outerRef = _ref.outerRef,
      _ref$onEnter = _ref.onEnter,
      onEnter = _ref$onEnter === void 0 ? onEnter : _ref$onEnter,
      _ref$onLeave = _ref.onLeave,
      onLeave = _ref$onLeave === void 0 ? onLeave : _ref$onLeave,
      props = _objectWithoutProperties(_ref, ["useAnimation", "outerRef", "onEnter", "onLeave"]);

  var ensuredRef = core.useEnsureRef(outerRef);
  useAnimation(ensuredRef, onEnter, onLeave);
  return React__default.createElement(BlockContainer, _extends({}, props, {
    ref: ensuredRef
  }));
};

var PaddingDiv = styled__default.div.withConfig({
  displayName: "LoadingDiv__PaddingDiv",
  componentId: "sc-1g7ljba-1"
})(["padding:", " 0;"], function (props) {
  return props.height;
});
var LoadingDiv = function LoadingDiv(_ref2) {
  var _ref2$defaultToSuspen = _ref2.defaultToSuspense,
      defaultToSuspense = _ref2$defaultToSuspen === void 0 ? true : _ref2$defaultToSuspen,
      fallback = _ref2.fallback,
      isLoading = _ref2.isLoading,
      className = _ref2.className,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 12 : _ref2$height,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 32 : _ref2$size,
      _ref2$borderWidth = _ref2.borderWidth,
      borderWidth = _ref2$borderWidth === void 0 ? 5 : _ref2$borderWidth,
      children = _ref2.children;
  var flipAnimation = core.useLazyConstant(willUseFlipSwitch);
  var loadingBlock = React__default.createElement(PaddingDiv, {
    height: _isString(height) ? borderWidth : height + 'rem'
  }, React__default.createElement(Loading, {
    autoFocus: true,
    absolute: true,
    size: size,
    borderWidth: borderWidth
  }));
  return React__default.createElement(React__default.Suspense, {
    fallback: React__default.createElement(FlipDiv, {
      key: "loading",
      padded: true,
      onEnter: loadingEnter,
      onLeave: loadingLeave,
      useAnimation: flipAnimation,
      className: className
    }, fallback, loadingBlock)
  }, typeof isLoading === 'boolean' || defaultToSuspense ? isLoading ? React__default.createElement(FlipDiv, {
    key: "loading",
    padded: true,
    onEnter: loadingEnter,
    onLeave: loadingLeave,
    useAnimation: flipAnimation,
    className: className
  }, fallback, loadingBlock) : React__default.createElement(FlipDiv, {
    key: "loaded",
    loaded: true,
    onEnter: loadingEnter,
    onLeave: loadingLeave,
    useAnimation: flipAnimation,
    className: className
  }, children) : children);
};

var TOP_TRIGGER = function TOP_TRIGGER(posInfo, refInfo) {
  // Started sticking.
  if (posInfo.bottom < refInfo.top) {
    return true;
  } // Stopped sticking.


  if (posInfo.bottom >= refInfo.top && posInfo.bottom < refInfo.bottom) {
    return false;
  }
};

var BOTTOM_TRIGGER = function BOTTOM_TRIGGER(posInfo, refInfo) {
  // Started sticking.
  if (posInfo.top > refInfo.bottom) {
    return true;
  }

  if (posInfo.top <= refInfo.bottom && posInfo.top > refInfo.top) {
    return false;
  }
};

var SentinelStyle = styled__default.div.withConfig({
  displayName: "willUseIsSticky__SentinelStyle",
  componentId: "sc-1nsyca-0"
})(["position:absolute;visibility:hidden;height:1px;width:1px;", ""], function (props) {
  return props.addCss;
});
var willUseIsSticky = function willUseIsSticky() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _willUseSharedCallbac = core.willUseSharedCallback(),
      _willUseSharedCallbac2 = _slicedToArray(_willUseSharedCallbac, 2),
      useRegister = _willUseSharedCallbac2[0],
      onChange = _willUseSharedCallbac2[1];

  var _willUseSharedState = core.willUseSharedState(),
      _willUseSharedState2 = _slicedToArray(_willUseSharedState, 3),
      useSharedIsSticky = _willUseSharedState2[0],
      setSharedIsSticky = _willUseSharedState2[2];

  var createObserver = function createObserver(root) {
    return window.IntersectionObserver ? new window.IntersectionObserver(function (records, observer) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = records[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var record = _step.value;
          var targetInfo = record.boundingClientRect;
          var rootBoundsInfo = record.rootBounds;

          if (!rootBoundsInfo) {
            return;
          }

          onChange(targetInfo, rootBoundsInfo, record.target, record.isIntersecting);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }, _objectSpread({
      root: root
    }, options)) : {
      observe: _identity,
      unobserve: _identity
    };
  };

  var observerMap = new Map();

  var getObserver = function getObserver() {
    var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var result = observerMap.get(root);

    if (result) {
      return result;
    }

    var observer = createObserver(root);
    observerMap.set(root, observer);
    return observer;
  };

  var activeObserved = [];

  var resetObservers = function resetObservers() {
    var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var observer = getObserver(root);
    activeObserved.forEach(function (observed) {
      observer.unobserve(observed);
      observer.observe(observed);
    });
  };

  var WithIsSticky = React__default.forwardRef(function (_ref, ref) {
    var className = _ref.className,
        id = _ref.id,
        css = _ref.css,
        children = _ref.children,
        bottom = _ref.bottom,
        root = _ref.root,
        intersection = _ref.intersection,
        onChange = _ref.onChange;
    var ensuredRef = core.useEnsureRef(ref);

    var _useState = React.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isSticky = _useState2[0],
        setIsSticky = _useState2[1];

    useRegister(function (posInfo, refInfo, target, isIntersecting) {
      if (ensuredRef.current === target) {
        var value = intersection ? isIntersecting : bottom ? BOTTOM_TRIGGER(posInfo, refInfo) : TOP_TRIGGER(posInfo, refInfo);

        if (value !== undefined) {
          setIsSticky(value);
          utils.callIfFunction(onChange, value);

          if (!id) {
            setSharedIsSticky(value);
          } else if (value) {
            setSharedIsSticky(id);
          }
        }
      }
    });
    React.useEffect(function () {
      setIsSticky(false);
      getObserver(utils.callIfFunction(root)).observe(ensuredRef.current);
      activeObserved = activeObserved.concat(ensuredRef.current);
      return function () {
        // observer.unobserve(ref.current)
        activeObserved = _without([ensuredRef.current], activeObserved);
      };
    }, []);

    var renderSentinel = function renderSentinel() {
      var css = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return React__default.createElement(SentinelStyle, {
        addCss: css,
        className: className,
        ref: ensuredRef
      });
    };

    return children ? children(renderSentinel, isSticky) : renderSentinel(css);
  });
  return [WithIsSticky, useSharedIsSticky, resetObservers];
};

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    padding: 1.5rem 1.5rem 1.5rem;\n    max-width: 100%;\n    ", ";\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    padding: 1.5rem 1.5rem 0;\n    margin: -1.5rem;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    padding: 1.5rem;\n    margin: -1.5rem;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        min-width: unset;\n        padding-left: 1rem;\n        padding-right: 1rem;\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        bottom: -0.5rem;\n        padding: 0.75rem 1.5rem;\n        margin-bottom: -0.75rem;\n        margin-left: -1.5rem;\n        margin-right: -1.5rem;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        bottom: -3rem;\n        margin-left: -2rem;\n        margin-right: -2rem;\n        margin-bottom: -1rem;\n        padding: 1rem 2rem;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      font-size: 19px;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n        padding-right: 1.5rem;\n      "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n      display: none;\n    "]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    top: 0\n  "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var DialogIcon = styled__default(Icon).withConfig({
  displayName: "Dialog__DialogIcon",
  componentId: "gai4ey-0"
})(["font-size:60px;width:8rem;text-align:center;color:#d2d2d2;right:0;top:1rem;position:absolute;", ""], utils.media.desktop(_templateObject$4()));
var CloseIcon = styled__default(Icon).attrs(_assign({
  icon: 'x'
})).withConfig({
  displayName: "Dialog__CloseIcon",
  componentId: "gai4ey-1"
})(["position:absolute;width:32px;height:32px;font-size:24px;line-height:32px;cursor:pointer;border-radius:50%;text-align:center;color:rgba(0,0,0,0.3);transition:0.2s linear;z-index:1000;top:1rem;right:1rem;&:hover{background-color:rgba(0,0,0,0.075);}"]);
var DialogIllustration = styled__default.img.withConfig({
  displayName: "Dialog__DialogIllustration",
  componentId: "gai4ey-2"
})(["max-width:16rem;position:absolute;right:1rem;bottom:0;", ""], utils.media.mobile(_templateObject2$3()));
var DialogContent = styled__default(function (props) {
  return React__default.createElement("div", props, fixDoubledLastMarginBottom(props.children), props.icon && React__default.createElement(DialogIcon, {
    icon: props.icon
  }), props.illustration && React__default.createElement(DialogIllustration, {
    src: props.illustration
  }));
}).withConfig({
  displayName: "Dialog__DialogContent",
  componentId: "gai4ey-3"
})(["outline:none;width:100%;position:relative;min-height:5rem;", " ", " p{font-size:14px;}"], function (props) {
  return props.icon && styled.css(["padding-right:8rem;min-height:6rem;"]);
}, function (props) {
  return props.illustration && styled.css(["padding-right:15rem;", ""], utils.media.mobile(_templateObject3$1()));
});
var DialogTitle = styled__default.h2.withConfig({
  displayName: "Dialog__DialogTitle",
  componentId: "gai4ey-4"
})(["margin-bottom:1rem;padding-bottom:1rem;", " ", ""], function (props) {
  return props.fixTitleMargin && "\n      padding-bottom: 0;\n    ";
}, utils.media.mobile(_templateObject4()));
var DialogFooter = styled__default.div.withConfig({
  displayName: "Dialog__DialogFooter",
  componentId: "gai4ey-5"
})(["display:block;padding-top:1rem;margin-top:1rem;align-items:stretch;text-align:right;", " ", ""], function (props) {
  return props.sticky && styled.css(["position:sticky;background:white;width:inherit;z-index:50;", " ", " ", ""], utils.media.desktop(_templateObject5()), utils.media.mobile(_templateObject6()), function (props) {
    return props.isSticky && "\n        box-shadow: 0 0px 2px 0 rgba(0,0,0,0.1), 0 0px 5px 1px rgba(0,0,0,0.15);\n      ";
  });
}, utils.media.max(370)(_templateObject7(), Button));
var FooterAuxiliaryContainer = styled__default.div.withConfig({
  displayName: "Dialog__FooterAuxiliaryContainer",
  componentId: "gai4ey-6"
})(["flex-grow:1;align-self:center;display:inline-block;padding-right:1rem;float:left;"]); // THIS IS NEEDED FOR LOADING ANIMATION ON DialogWithImageHeader

var DialogContentWrapper = styled__default(LoadingDiv).withConfig({
  displayName: "Dialog__DialogContentWrapper",
  componentId: "gai4ey-7"
})(["padding:2rem;margin:-2rem;", ""], utils.media.mobile(_templateObject8()));
var DialogAlwaysVisibleDiv = styled__default.div.withConfig({
  displayName: "Dialog__DialogAlwaysVisibleDiv",
  componentId: "gai4ey-8"
})(["padding:2rem 2rem 0;margin:-2rem;", ""], utils.media.mobile(_templateObject9())); // END

var Dialog = styled__default(React__default.forwardRef(function (_ref, outerRef) {
  var className = _ref.className,
      skipWrap = _ref.skipWrap,
      stickyFooter = _ref.stickyFooter,
      fixTitleMargin = _ref.fixTitleMargin,
      skipCloseIcon = _ref.skipCloseIcon,
      isLoading = _ref.isLoading,
      footer = _ref.footer,
      Content = _ref.Content,
      children = _ref.children,
      title = _ref.title,
      illustration = _ref.illustration,
      icon = _ref.icon,
      auxiliarActions = _ref.auxiliarActions,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? true : _ref$container,
      props = _objectWithoutProperties(_ref, ["className", "skipWrap", "stickyFooter", "fixTitleMargin", "skipCloseIcon", "isLoading", "footer", "Content", "children", "title", "illustration", "icon", "auxiliarActions", "container"]);

  var ref = core.useEnsureRef(outerRef);

  var _willUseIsSticky = willUseIsSticky(),
      _willUseIsSticky2 = _slicedToArray(_willUseIsSticky, 1),
      WithIsSticky = _willUseIsSticky2[0];

  var alwaysVisible = function alwaysVisible(confirmCloseDialog) {
    return React__default.createElement(React__default.Fragment, null, props.closeDialog && !skipCloseIcon && React__default.createElement(CloseIcon, {
      className: "JS-dialog-close",
      onClick: confirmCloseDialog
    }), title && React__default.createElement(DialogTitle, {
      fixTitleMargin: true
    }, utils.callIfFunction(title)));
  };

  var content = React__default.createElement(React__default.Fragment, null, Content && React__default.createElement(DialogContent, {
    icon: icon,
    illustration: illustration
  }, utils.callIfFunction(Content)), !Content && children && React__default.createElement(DialogContent, {
    icon: icon,
    illustration: illustration
  }, utils.callIfFunction(children)), Content && children && utils.callIfFunction(children), footer && React__default.createElement(WithIsSticky, {
    bottom: true
  }, function (sentinel, isSticky) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(DialogFooter, {
      isSticky: isSticky,
      sticky: stickyFooter
    }, auxiliarActions && React__default.createElement(FooterAuxiliaryContainer, null, utils.callIfFunction(auxiliarActions)), utils.callIfFunction(footer)), sentinel());
  }));

  var dialog = function dialog(confirmCloseDialog) {
    return React__default.createElement("div", {
      className: className + " JS-has-wc JS-dialog",
      ref: ref
    }, skipWrap ? React__default.createElement(React__default.Fragment, null, alwaysVisible(confirmCloseDialog), content) : React__default.createElement(React__default.Fragment, null, React__default.createElement(DialogAlwaysVisibleDiv, null, alwaysVisible(confirmCloseDialog)), React__default.createElement(DialogContentWrapper, {
      isLoading: isLoading
    }, content)));
  };

  return container ? React__default.createElement(DialogContainer, _extends({}, props, {
    DialogErrorContent: DialogErrorContent,
    ref: ref,
    title: title
  }), function (_ref2) {
    var confirmCloseDialog = _ref2.confirmCloseDialog;
    return dialog(confirmCloseDialog);
  }) : dialog(props.closeDialog);
})).withConfig({
  displayName: "Dialog",
  componentId: "gai4ey-9"
})(["@supports (position:sticky){will-change:transform,opacity;&.JS-wc-off{will-change:auto;}}border-radius:12px;padding:2rem;background-color:white;width:100%;max-width:45rem;margin:auto;position:relative;align-self:baseline;display:block;> h3:first-child{margin-top:0.5rem;}p{line-height:140%;}", " ", " ", ""], utils.media.mobile(_templateObject10(), function (props) {
  return props.fullscreenOnMobile && "\n      border-radius: 0;\n      min-height: 100%;\n    ";
}), function (props) {
  return props.closeDialog && styled.css(["", "{padding-right:2rem;}"], DialogTitle);
}, utils.customTheme('Dialog'));
var ConfirmDialog = function ConfirmDialog(props) {
  return React__default.createElement(Dialog, _extends({}, props, {
    placement: "Confirm-Dialog"
  }), props.children);
};
var DefaultConfirmDialog = function DefaultConfirmDialog(props) {
  return React__default.createElement(core.StartlibsConsumer, null, function (_ref3) {
    var confirmDialogLabels = _ref3.confirmDialogLabels;
    return React__default.createElement(ConfirmDialog, {
      title: confirmDialogLabels.title,
      closeDialog: props.onCancel,
      onConfirm: props.onConfirm,
      footer: React__default.createElement(React__default.Fragment, null, React__default.createElement(Button, {
        onClick: props.onCancel
      }, confirmDialogLabels.cancel), React__default.createElement(Button, {
        hover: "success",
        isLoading: props.isLoading,
        onClick: props.onSaveInstead
      }, confirmDialogLabels.confirm), React__default.createElement(Button, {
        autoFocus: true,
        alert: true,
        onClick: props.onConfirm
      }, confirmDialogLabels.discard))
    }, React__default.createElement("p", null, confirmDialogLabels.content));
  });
};
var DialogErrorContent = function DialogErrorContent(_ref4) {
  var closeDialog = _ref4.closeDialog,
      title = _ref4.title;
  return React__default.createElement(core.StartlibsConsumer, null, function (_ref5) {
    var _ref5$ErrorDialog = _ref5.ErrorDialog,
        title = _ref5$ErrorDialog.title,
        content = _ref5$ErrorDialog.content,
        close = _ref5$ErrorDialog.close;
    return React__default.createElement(Dialog, {
      as: "div"
    }, closeDialog && React__default.createElement(CloseIcon, {
      onClick: closeDialog
    }), title && React__default.createElement(DialogTitle, null, title), React__default.createElement(DialogContent, {
      icon: "warning"
    }, content), React__default.createElement(DialogFooter, null, React__default.createElement(Button, {
      onClick: closeDialog
    }, close)));
  });
};
var DialogError = function DialogError(_ref6) {
  var closeDialog = _ref6.closeDialog;
  return React__default.createElement(core.StartlibsConsumer, null, function (_ref7) {
    var _ref7$ErrorDialog = _ref7.ErrorDialog,
        title = _ref7$ErrorDialog.title,
        content = _ref7$ErrorDialog.content,
        close = _ref7$ErrorDialog.close;
    return React__default.createElement(Dialog, {
      closeDialog: closeDialog,
      title: title
    }, React__default.createElement(DialogErrorContent, {
      closeDialog: closeDialog
    }));
  });
};

var useDialog = function useDialog(dialog) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var toggleCallback = arguments.length > 2 ? arguments[2] : undefined;
  var toggle = core.useToggle(false, toggleCallback);
  core.useFill("Dialog", toggle.isOpen !== false && dialog(toggle.close), [toggle.isOpen].concat(_toConsumableArray(args)));
  return toggle.open;
};
var useDialogWithToggle = function useDialogWithToggle(dialog) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var toggle = core.useToggle();
  core.useFill("Dialog", toggle.isOpen !== false && dialog(toggle), [toggle.isOpen].concat(_toConsumableArray(args)));
  return toggle;
};

var WarningDialog = styled__default(function (_ref) {
  var content = _ref.content,
      footer = _ref.footer,
      withX = _ref.withX,
      closeDialog = _ref.closeDialog,
      leftButton = _ref.leftButton,
      additionalContent = _ref.additionalContent,
      title = _ref.title,
      rightButton = _ref.rightButton,
      className = _ref.className,
      color = _ref.color,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? "warning" : _ref$icon,
      _ref$confirmLabel = _ref.confirmLabel,
      confirmLabel = _ref$confirmLabel === void 0 ? "Entendi" : _ref$confirmLabel,
      noActions = _ref.noActions,
      children = _ref.children;
  return React__default.createElement(Dialog, {
    className: className,
    closeDialog: withX && closeDialog
  }, _isString(icon) ? React__default.createElement(WarningDialogIcon, {
    icon: icon
  }) : icon, title && React__default.createElement(WarningDialogTitle, {
    color: color || icon
  }, title), content && React__default.createElement(Content, {
    noTitle: !title,
    noActions: noActions
  }, content), additionalContent, utils.callIfFunction(leftButton, closeDialog), confirmLabel !== false && React__default.createElement(Button, {
    highlight: true,
    onClick: closeDialog
  }, confirmLabel), utils.callIfFunction(rightButton, closeDialog), utils.callIfFunction(footer, closeDialog), children);
}).withConfig({
  displayName: "WarningDialog",
  componentId: "sc-1jw779e-0"
})(["text-align:center;max-width:36rem;padding:2.5rem;", "{margin:0.5rem !important;}"], Button);
var WarningDialogTitle = styled__default.h3.withConfig({
  displayName: "WarningDialog__WarningDialogTitle",
  componentId: "sc-1jw779e-1"
})(["color:", ";font-weight:500;font-size:20px;"], function (props) {
  return props.color === 'warning' ? utils.getColor('alert') : props.color === 'success' ? utils.getColor('success') : props.color === 'due-date' ? utils.getColor('warning') : utils.getColor('main');
});
var Content = styled__default.div.withConfig({
  displayName: "WarningDialog__Content",
  componentId: "sc-1jw779e-2"
})(["font-size:15px;max-width:27rem;margin:0 auto;line-height:130%;", " ", ""], function (props) {
  return !props.noActions && "\n    margin: 0 auto 1.5rem;\n  ";
}, function (props) {
  return props.noTitle && "\n    font-weight: 500;\n    font-size: 16px;\n  ";
});
var WarningDialogIcon = styled__default(Icon).withConfig({
  displayName: "WarningDialog__WarningDialogIcon",
  componentId: "sc-1jw779e-3"
})(["color:", ";font-size:46px;display:block;margin-bottom:1.25rem;"], function (props) {
  return props.icon === 'warning' ? utils.getColor('alert') : props.icon === 'success' ? utils.getColor('success') : props.icon === 'due-date' ? utils.getColor('warning') : utils.getColor('main');
});
var useWarningDialog = function useWarningDialog() {
  return useDialogWithToggle(function (toggle) {
    return React__default.createElement(WarningDialog, _extends({}, toggle.isOpen, {
      closeDialog: toggle.close
    }));
  });
};

var _willUseSharedState = core.willUseSharedState(),
    _willUseSharedState2 = _slicedToArray(_willUseSharedState, 3),
    useRenderDefaultWarningDialog = _willUseSharedState2[0],
    _setWarningDialog = _willUseSharedState2[2];

var setWarningDialog = function setWarningDialog(_ref2) {
  var _ref2$as = _ref2.as,
      Dialog = _ref2$as === void 0 ? WarningDialog : _ref2$as,
      props = _objectWithoutProperties(_ref2, ["as"]);

  return _setWarningDialog(React__default.createElement(Dialog, _extends({}, props, {
    closeDialog: function closeDialog() {
      return _setWarningDialog(null);
    }
  })));
};
var DefaultWarningDialog = function DefaultWarningDialog() {
  var _useRenderDefaultWarn = useRenderDefaultWarningDialog(),
      _useRenderDefaultWarn2 = _slicedToArray(_useRenderDefaultWarn, 1),
      warningDialog = _useRenderDefaultWarn2[0];

  if (warningDialog) {
    return warningDialog;
  }

  return null;
};

var NotificationContainer = styled__default.div.withConfig({
  displayName: "Notifications__NotificationContainer",
  componentId: "naxsn6-0"
})(["position:fixed;top:0;height:1px;left:0;right:0;text-align:center;"]);
var Notification = styled__default.div.withConfig({
  displayName: "Notifications__Notification",
  componentId: "naxsn6-1"
})(["padding:1rem 4.5rem 1rem 1.5rem;font-size:14px;font-weight:500;border-radius:10px;color:white;text-align:left;background:", ";box-shadow:0 2px 0px 0px rgba(0,0,0,0.1);min-width:12rem;min-height:48px;display:inline-flex;align-items:center;position:relative;top:1rem;", "{color:white;display:inline-block;background-color:rgba(0,0,0,0.1);font-size:18px;width:24px;height:24px;text-align:center;line-height:24px;border-radius:50%;cursor:pointer;position:absolute;top:50%;transform:translateY(-50%);right:1rem;&:hover{background-color:rgba(0,0,0,0.2);}}"], function (props) {
  return utils.getColor(props.type)(props);
}, Icon);

var _willUseSharedState$1 = core.willUseSharedState(),
    _willUseSharedState2$1 = _slicedToArray(_willUseSharedState$1, 3),
    useNotification = _willUseSharedState2$1[0],
    useNotificationRef = _willUseSharedState2$1[1],
    setNotification = _willUseSharedState2$1[2];
var willSetNotification = function willSetNotification(str) {
  return function () {
    return setNotification(str);
  };
};
var animation = utils.oneWayAnimation('opacity:0; transform:translateY(-20px)', 'opacity:1;transform:translate(0)');
var Notifications = function Notifications() {
  var toggle = core.useToggle();

  var _useNotification = useNotification(),
      _useNotification2 = _slicedToArray(_useNotification, 2),
      rawNotification = _useNotification2[0],
      setNotification = _useNotification2[1];

  var _ref = _isObject(rawNotification) ? rawNotification : {
    type: "success",
    msg: rawNotification
  },
      msg = _ref.msg,
      type = _ref.type,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout;

  React.useEffect(function () {
    if (msg) {
      toggle.open();
      setTimeout(toggle.willCloseAfter(timeout), 100);
    }
  }, [msg]);
  React.useEffect(function () {
    if (!toggle.isOpen) {
      setNotification(null);
    }
  }, [toggle.isOpen]);
  return toggle.isOpen && React__default.createElement(core.Fill, {
    name: "Notifications"
  }, React__default.createElement(FlipNotification, {
    type: type
  }, utils.callIfFunction(msg, toggle.close), React__default.createElement(Icon, {
    icon: "x",
    onClick: toggle.close
  })));
};

var FlipNotification = function FlipNotification(props) {
  var ref = React.useRef();
  useFlipAnimation(ref, animation);
  return React__default.createElement(NotificationContainer, {
    ref: ref
  }, React__default.createElement(Notification, _extends({
    id: "js-share-notification"
  }, props)));
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var _willUseSharedState$2 = core.willUseSharedState([]),
    _willUseSharedState2$2 = _slicedToArray(_willUseSharedState$2, 3),
    useNotifications = _willUseSharedState2$2[0],
    setNotifications = _willUseSharedState2$2[2];

var openPersistentNotification = function openPersistentNotification(notification) {
  var newNotification = _objectSpread({
    priority: 0,
    type: "success"
  }, _isObject(notification) ? notification : {
    content: notification
  });

  setNotifications(function (list) {
    var nextIndex = list.findIndex(function (n) {
      return n.priority < newNotification.priority;
    });
    return nextIndex < 0 ? _toConsumableArray(list).concat([newNotification]) : _toConsumableArray(list.slice(0, nextIndex)).concat([newNotification], _toConsumableArray(list.slice(nextIndex)));
  });
  return function () {
    return setNotifications(_without([newNotification]));
  };
};
var animation$1 = utils.oneWayAnimation('opacity:0; transform:translateY(-20px)', 'opacity:1;transform:translate(0)');
var NotificationContainer$1 = styled__default.div.withConfig({
  displayName: "PersistentNotifications__NotificationContainer",
  componentId: "sc-1t7i0dh-0"
})(["position:fixed;top:0;height:0;right:0;z-index:20;"]);
var Notification$1 = styled__default.div.withConfig({
  displayName: "PersistentNotifications__Notification",
  componentId: "sc-1t7i0dh-1"
})(["background:", ";position:relative;border-radius:7px;"], function (props) {
  return polished.transparentize(0.9, utils.getColor(props.type)(props));
});
var NotificationWrapper = styled__default.div.withConfig({
  displayName: "PersistentNotifications__NotificationWrapper",
  componentId: "sc-1t7i0dh-2"
})(["background:white;margin-top:", ";margin-right:0.75rem;margin-left:0.75rem;padding:5px;border-radius:10px;box-shadow:0 0 10px 0 rgba(0,0,0,0.1),0 1px 2px 1px rgba(0,0,0,0.15);max-width:364px;", ""], function (props) {
  return props.marginTop || "4.75rem";
}, utils.printerMedia(_templateObject$5()));

var _willUseSharedState3 = core.willUseSharedState(false),
    _willUseSharedState4 = _slicedToArray(_willUseSharedState3, 3),
    useIsHiddenPersistentNotifications = _willUseSharedState4[0],
    hidePersistentNotifications = _willUseSharedState4[2];
var PersistentNotifications = function PersistentNotifications() {
  var _useNotifications = useNotifications(),
      _useNotifications2 = _slicedToArray(_useNotifications, 2),
      notifications = _useNotifications2[0],
      setNotifications = _useNotifications2[1];

  var _useIsHiddenPersisten = useIsHiddenPersistentNotifications(),
      _useIsHiddenPersisten2 = _slicedToArray(_useIsHiddenPersisten, 1),
      isHidden = _useIsHiddenPersisten2[0];

  if (!notifications.length || isHidden) {
    return null;
  }

  var closeMessage = function closeMessage() {
    return setNotifications(function (list) {
      return list.slice(1);
    });
  };

  var _notifications$ = notifications[0],
      content = _notifications$.content,
      type = _notifications$.type,
      marginTop = _notifications$.marginTop;
  return React__default.createElement(core.Fill, {
    name: "PersistentNotifications"
  }, React__default.createElement(FlipNotification$1, {
    type: type,
    marginTop: marginTop
  }, utils.callIfFunction(content, closeMessage)));
};

var FlipNotification$1 = function FlipNotification(props) {
  var ref = React.useRef();
  useFlipAnimation(ref, animation$1);
  return React__default.createElement(NotificationContainer$1, {
    className: "JS-fix-dialog-scroll",
    ref: ref
  }, React__default.createElement(NotificationWrapper, {
    marginTop: props.marginTop
  }, React__default.createElement(Notification$1, _extends({
    id: "js-share-notification"
  }, props))));
};

var Placeholder = styled__default.span.withConfig({
  displayName: "usePositioning__Placeholder",
  componentId: "sc-1m4912o-0"
})(["top:0;left:0;padding:0 !important;position:absolute;"]);
/*
type Alignment = 'top left' | 'top center' | 'top right' |
  'center left' | 'center center' | 'center right' |
  'bottom left' | 'bottom center' | 'bottom right'

type Collision = 'fit fit' | 'fit flip' | 'fit fitflip' | 'fit none' |
  'flip fit' | 'flip flip' | 'flip fitflip' | 'flip none' |
  'flipfit fit' | 'flipfit flip' | 'flipfit fitflip' | 'flipfit none' |
  'none fit' | 'none flip' | 'none fitflip' | 'none none'
*/

var HORIZONTAL_MAPPING = ['left', 'center', 'right'];
var VERTICAL_MAPPING = ['top', 'center', 'bottom'];
var ARROW_KEY_POSITIONS = {
  left: '0',
  right: '-0',
  top: '0',
  bottom: '-0'
};
var POSITIONING_BOUNDS = {
  left: 0,
  top: 0,
  right: 0,
  bottom: 0
};
var addPositioningBound = function addPositioningBound(key, value) {
  POSITIONING_BOUNDS[key] += value;
  return function () {
    return POSITIONING_BOUNDS[key] -= value;
  };
};

function getPosition(origin, offset, max, originSize, selfSize, originalAlignment, selfAlignment, onCollision, mapping, boundMargin) {
  // 0 pra left ou top, 1/2 pra center, 1 pra right ou bottom
  var originDiff = originSize * (mapping.indexOf(originalAlignment) / 2); // 0 pra left ou top, -1/2 pra center, -1 pra right ou bottom

  var selfDiff = -(selfSize * (mapping.indexOf(selfAlignment) / 2));
  var respectingBounds = boundMargin !== false;
  var upperBound = respectingBounds ? POSITIONING_BOUNDS[mapping[0]] + boundMargin : Number.MIN_SAFE_INTEGER;
  var lowerBound = respectingBounds ? POSITIONING_BOUNDS[mapping[2]] + boundMargin : 0;
  var newPosition = Math.max(upperBound, origin + selfDiff + originDiff + offset);
  var collision = Math.max(-newPosition, newPosition + selfSize - max + lowerBound);

  if (collision > 0 && onCollision !== 'none') {
    if (onCollision.indexOf('flip') >= 0) {
      var flippedPosition = getPosition(origin, -offset, max, originSize, selfSize, originalAlignment, selfAlignment, onCollision.indexOf('fit') >= 0 ? 'fit' : 'none', mapping.slice().reverse(), boundMargin);
      var flippedCollision = Math.max(-flippedPosition[0], flippedPosition[0] + selfSize - max);

      if (collision > 0 && flippedCollision > 0 || flippedPosition[0] < upperBound) {
        return getPosition(origin, offset, max, originSize, selfSize, originalAlignment, selfAlignment, 'fit', mapping, boundMargin);
      }

      return collision < flippedCollision ? [newPosition, 'none'] : [flippedPosition[0], flippedPosition[1] === 'fit' ? 'flipfit' : 'flip'];
    } else {
      return newPosition < upperBound ? [upperBound, 'fitted'] : [Math.max(upperBound, newPosition - collision), collision !== 0 ? 'fit' : 'none'];
    }
  } else {
    return [newPosition, 'none'];
  }
}

var arrowShadow = {
  top: '-1px -1px 2px -1px rgba(0,0,0,.25)',
  right: '1px -1px 2px -1px rgba(0,0,0,.25)',
  bottom: '1px 1px 2px -1px rgba(0,0,0,.25)',
  left: '-1px 1px 2px -1px rgba(0,0,0,.25)'
};

var translate = function translate(position, offset) {
  return (position === 'left' ? '-50%' : position === 'right' ? '50%' : offset) + ',' + (position === 'top' ? '-50%' : position === 'bottom' ? '50%' : offset);
};

var ARROW_DEFAULT_SIZE = 14;
var DefaultArrow = styled__default.div.withConfig({
  displayName: "usePositioning__DefaultArrow",
  componentId: "sc-1m4912o-1"
})(["background-color:#fff;position:absolute;width:", "px;height:", "px;transform:translate(-50%,50%) rotate(45deg);bottom:0;left:50%;box-shadow:", ";"], ARROW_DEFAULT_SIZE, ARROW_DEFAULT_SIZE, arrowShadow.bottom);
var usePositioning = function usePositioning(element, _ref, arrowRefOpt) {
  var _ref$my = _ref.my,
      my = _ref$my === void 0 ? 'top right' : _ref$my,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? '0 0' : _ref$offset,
      _ref$at = _ref.at,
      at = _ref$at === void 0 ? 'bottom right' : _ref$at,
      _ref$onCollision = _ref.onCollision,
      onCollision = _ref$onCollision === void 0 ? 'flip flip' : _ref$onCollision,
      arrow = _ref.arrow,
      _ref$arrowPadding = _ref.arrowPadding,
      arrowPadding = _ref$arrowPadding === void 0 ? 10 : _ref$arrowPadding,
      fill = _ref.fill,
      _ref$useLayers = _ref.useLayers,
      useLayers = _ref$useLayers === void 0 ? true : _ref$useLayers,
      fixed = _ref.fixed,
      onBottom = _ref.bottom,
      onLeft = _ref.left,
      onRight = _ref.right,
      onTop = _ref.top,
      _ref$keepWidth = _ref.keepWidth,
      keepWidth = _ref$keepWidth === void 0 ? true : _ref$keepWidth,
      _ref$boundMargin = _ref.boundMargin,
      boundMargin = _ref$boundMargin === void 0 ? 6 : _ref$boundMargin,
      respectBounds = _ref.respectBounds,
      respectOffsetScroll = _ref.respectOffsetScroll,
      on = _ref.on;
  var placeholder = React.useRef();
  var arrowRef = core.useEnsureRef(arrowRefOpt);

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      positionInfo = _useState2[0],
      setPositionInfo = _useState2[1];

  var setPosition = function setPosition() {
    var _arrowStyle;

    var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (retry > 10) {
      return;
    }

    if (!element.current || !element.current.style || !placeholder.current || !placeholder.current.offsetParent) {
      setTimeout(function () {
        return setPosition(retry + 1);
      }, 100);
      return;
    }

    var usingLayer = respectOffsetScroll || useLayers && getDialogLayersSize() > 0;
    var scrollOwner = usingLayer ? _isFunction(respectOffsetScroll) ? respectOffsetScroll(element.current.offsetParent) : utils.getClosestOffsetScroll(element.current.offsetParent) : {
      scrollTop: window.pageYOffset,
      scrollLeft: window.pageXOffset // console.log({scrollOwner,scrollTop:scrollOwner.scrollTop,pageYOffset:window.pageYOffset})

    };
    var scrollY = !isNaN(scrollOwner.scrollTop) ? scrollOwner.scrollTop : window.pageYOffset;
    var scrollX = !isNaN(scrollOwner.scrollLeft) ? scrollOwner.scrollLeft : window.pageXOffset;

    var getRespectOffsetScrollTopLeft = function getRespectOffsetScrollTopLeft() {
      var _placeholder$current$ = placeholder.current.getBoundingClientRect(),
          top = _placeholder$current$.top,
          left = _placeholder$current$.left;

      var _scrollOwner$getBound = scrollOwner.getBoundingClientRect(),
          scrollOwnerTop = _scrollOwner$getBound.top,
          scrollOwnerLeft = _scrollOwner$getBound.left;

      return {
        top: top - scrollOwnerTop,
        left: left - scrollOwnerLeft
      };
    };

    var _ref2 = respectOffsetScroll ? getRespectOffsetScrollTopLeft() : placeholder.current.getBoundingClientRect(),
        leftPlusBorder = _ref2.left,
        topPlusBorder = _ref2.top;

    var _window$getComputedSt = window.getComputedStyle(placeholder.current.offsetParent),
        borderLeftWidth = _window$getComputedSt.borderLeftWidth,
        borderTopWidth = _window$getComputedSt.borderTopWidth;

    var left = leftPlusBorder - parseInt(borderLeftWidth, 10);
    var top = topPlusBorder - parseInt(borderTopWidth, 10);
    var _placeholder$current$2 = placeholder.current.offsetParent,
        parentOffsetWidth = _placeholder$current$2.offsetWidth,
        parentOffsetHeight = _placeholder$current$2.offsetHeight;
    var _element$current = element.current,
        popupOffsetWidth = _element$current.offsetWidth,
        popupOffsetHeight = _element$current.offsetHeight;

    var _element$current$getB = element.current.getBoundingClientRect(),
        popupCurrentWidth = _element$current$getB.width;

    var _concat$join$split$ma = [].concat(offset).join(' ').split(' ').map(function (_) {
      return Number(_ || 0);
    }),
        _concat$join$split$ma2 = _slicedToArray(_concat$join$split$ma, 2),
        offsetX = _concat$join$split$ma2[0],
        offsetY = _concat$join$split$ma2[1];

    var simplePositioning = [onTop, onRight, onBottom, onLeft].map(function (_) {
      return _ === true ? 'center' : _;
    });
    var simplePositioningIndex = simplePositioning.findIndex(function (_) {
      return _;
    });
    var bodyWidth = document.body.offsetWidth - (usingLayer ? parseInt(getComputedStyle(document.body).paddingRight, 10) : 0);
    var windowHeight = window.innerHeight;

    var _onCollision$split = onCollision.split(' '),
        _onCollision$split2 = _slicedToArray(_onCollision$split, 2),
        verticalCollision = _onCollision$split2[0],
        horizontalCollision = _onCollision$split2[1];

    var _replace$split = [my, 'bottom $', '$ left', 'top $', '$ right'][simplePositioningIndex + 1].replace('$', simplePositioning[simplePositioningIndex]).split(' '),
        _replace$split2 = _slicedToArray(_replace$split, 2),
        verticalMy = _replace$split2[0],
        horizontalMy = _replace$split2[1];

    var _replace$split3 = [at, 'top $', '$ right', 'bottom $', '$ left'][simplePositioningIndex + 1].replace('$', simplePositioning[simplePositioningIndex]).split(' '),
        _replace$split4 = _slicedToArray(_replace$split3, 2),
        verticalAt = _replace$split4[0],
        horizontalAt = _replace$split4[1];

    var _getPosition = getPosition(left, offsetX, bodyWidth, parentOffsetWidth, fill ? parentOffsetWidth : popupOffsetWidth, horizontalAt, horizontalMy, horizontalCollision, HORIZONTAL_MAPPING, !!respectBounds && boundMargin),
        _getPosition2 = _slicedToArray(_getPosition, 2),
        processedLeft = _getPosition2[0],
        collisionH = _getPosition2[1];

    var _getPosition3 = getPosition(top, offsetY, windowHeight, parentOffsetHeight, popupOffsetHeight, verticalAt, verticalMy, verticalCollision, VERTICAL_MAPPING, !!respectBounds && boundMargin),
        _getPosition4 = _slicedToArray(_getPosition3, 2),
        processedTop = _getPosition4[0],
        collisionV = _getPosition4[1];

    var flippedV = collisionV.indexOf('flip') >= 0;
    var flippedH = collisionH.indexOf('flip') >= 0; //arrow

    var arrowSide = Math.abs(VERTICAL_MAPPING.indexOf(verticalMy) - VERTICAL_MAPPING.indexOf(verticalAt)) === 2 ? flippedV ? verticalAt : verticalMy : Math.abs(HORIZONTAL_MAPPING.indexOf(horizontalMy) - HORIZONTAL_MAPPING.indexOf(horizontalAt)) === 2 ? flippedH ? horizontalAt : horizontalMy : '';
    var arrowElement = arrowRef.current;
    var arrowOnVerticalSide = arrowSide === 'left' || arrowSide === 'right';
    var arrowSize = arrowElement ? arrowElement.getBoundingClientRect()[arrowOnVerticalSide ? 'height' : 'width'] : ARROW_DEFAULT_SIZE * Math.sqrt(2);

    var _ref3 = arrowOnVerticalSide ? processArrow(ARROW_KEY_POSITIONS[arrow] || arrow, arrowSize, arrowOnVerticalSide, parentOffsetHeight, popupOffsetHeight, processedTop - top, flippedV) : processArrow(ARROW_KEY_POSITIONS[arrow] || arrow, arrowSize, arrowOnVerticalSide, parentOffsetWidth, popupOffsetWidth, processedLeft - left, flippedV),
        _ref4 = _slicedToArray(_ref3, 2),
        arrowOffset = _ref4[0],
        popupArrowOffset = _ref4[1];

    var maxHeight = window.innerHeight - (POSITIONING_BOUNDS.top + POSITIONING_BOUNDS.bottom) - (respectBounds ? boundMargin * 2 : 0);
    var maxWidth = window.innerWidth - (POSITIONING_BOUNDS.left + POSITIONING_BOUNDS.right) - (respectBounds ? boundMargin * 2 : 0);
    element.current.style.maxHeight = '';

    if (parseInt(window.getComputedStyle(element.current).maxHeight) > maxHeight) {
      element.current.style.maxHeight = maxHeight + 'px';
    }

    if (keepWidth) {
      element.current.style.width = Math.ceil(popupCurrentWidth) + "px";
    } else {
      element.current.style.maxWidth = maxWidth + 'px';
    } // console.log({processedTop,top,offsetY,scrollY})


    element.current.style.top = processedTop + (arrowOnVerticalSide ? popupArrowOffset : 0) + (fixed ? 0 : scrollY) + 'px';
    element.current.style.left = processedLeft + (arrowOnVerticalSide ? 0 : popupArrowOffset) + (fixed ? 0 : scrollX) + 'px';
    var arrowStyle = (_arrowStyle = {
      transform: "translate(".concat(translate(arrowSide, arrowOffset[0] === 'top' || arrowOffset[0] === 'left' ? '-50%' : '50%'), ") rotate(45deg)"),
      bottom: "auto",
      left: "auto"
    }, _defineProperty(_arrowStyle, arrowSide, '0'), _defineProperty(_arrowStyle, "boxShadow", arrowShadow[arrowSide]), _defineProperty(_arrowStyle, arrowOffset[0], arrowOffset[1] + 'px'), _arrowStyle);

    if (arrowRef.current) {
      Object.assign(arrowRef.current.style, arrowStyle);
    }

    setPositionInfo({
      atTop: verticalAt === 'top' && !flippedV || verticalAt === 'bottom' && flippedV,
      atBottom: verticalAt === 'bottom' && !flippedV || verticalAt === 'top' && flippedV,
      atLeft: horizontalAt === 'left' && !flippedH || verticalAt === 'right' && flippedH,
      atRight: horizontalAt === 'right' && !flippedH || verticalAt === 'left' && flippedH,
      fullHeight: popupOffsetHeight > maxHeight,
      fullWidth: popupOffsetWidth > maxWidth,
      arrowSide: arrowSide,
      arrowOffset: arrowOffset,
      arrowStyle: arrowStyle
    });

    if (fill) {
      element.current.style.width = parentOffsetWidth + 'px';
    }

    if (fixed) {
      element.current.style.position = 'fixed';
    }
  };

  React.useLayoutEffect(setPosition, [on]);
  React.useEffect(function () {
    window.addEventListener('portalReposition', setPosition);
    window.addEventListener('stepResize', setPosition);
    window.addEventListener('scroll', setPosition, {
      passive: true
    });
    return function () {
      window.removeEventListener('portalReposition', setPosition);
      window.removeEventListener('stepResize', setPosition);
      window.removeEventListener('scroll', setPosition);
    };
  }, []);

  var processArrow = function processArrow(arrow, arrowSize, onVerticalSide, arrowContainerWidth, popupSize, deltaPopupPosition, flipped) {
    if (!arrow) {
      return ['', 0];
    }

    var margin = arrowPadding + arrowSize / 2;

    var _replace$split5 = (arrow === true ? '50%' : arrow).replace(/(-)?(\d+%)?\s?(-?\d+)?/, '$1:$2:$3').split(':'),
        _replace$split6 = _slicedToArray(_replace$split5, 3),
        invertDirection = _replace$split6[0],
        percent = _replace$split6[1],
        px = _replace$split6[2];

    var invertAndFlipDirection = flipped ? !invertDirection : invertDirection;
    var arrowPosition = onVerticalSide ? invertAndFlipDirection ? 'bottom' : 'top' : invertAndFlipDirection ? 'right' : 'left';
    var fromOriginCorner = arrowPosition === 'left' || arrowPosition === 'top';
    var popupOffset = fromOriginCorner ? deltaPopupPosition : arrowContainerWidth - deltaPopupPosition - popupSize;
    /*   ____________________________
        |      arrow container      |
        |___________________________|
                 ..../\_______
                |    popup   |
                |____________|
         |-------| =  delta popup position (popupOffset)
                 .... = arrowPadding prop,  applies to both sides, moves popup or does nothing
     arrow prop = invert percent px   // relative to arrow container
        invert = -?
        percent = (\d+%)?
        px = (-?\d+)?
     procedure:
      1- position arrow according to container - arrowInitialPos
      2- constrain position inside container - constrainedArrowPosition
      3- move popup according to arrowPadding (margin) - popupDelta
      4- final arrow position, relative to final popup position - finalArrowPosition
     */

    var arrowInitialPos = parseInt(percent || 0, 10) * arrowContainerWidth / 100 + parseInt(px || 0, 10);
    var constrainedArrowPosition = Math.min(Math.max(arrowInitialPos, 0), arrowContainerWidth);
    var arrowPositionRelativeToPopup = fromOriginCorner ? constrainedArrowPosition - popupOffset : arrowContainerWidth - popupOffset - constrainedArrowPosition;
    var popupDelta = arrowPositionRelativeToPopup < margin ? arrowPositionRelativeToPopup - margin : arrowPositionRelativeToPopup > popupSize - margin ? margin + arrowPositionRelativeToPopup - popupSize : 0;
    var finalPopupPosition = fromOriginCorner ? popupOffset + popupDelta : arrowContainerWidth - popupOffset - popupDelta - popupSize;
    return [[arrowPosition, constrainedArrowPosition - finalPopupPosition], popupDelta];
  };

  var arrowElement = arrow && React__default.createElement(DefaultArrow, {
    ref: arrowRef
  });
  var placeholderElement = React__default.createElement(Placeholder, {
    ref: placeholder
  });
  return [positionInfo, placeholderElement, arrowElement];
};

var AbsoluteContainer = styled__default.div.withConfig({
  displayName: "Reposition__AbsoluteContainer",
  componentId: "sc-1rugphp-0"
})(["position:absolute;"]);
var Reposition = React__default.forwardRef(function (_ref, ref) {
  var _ref$slot = _ref.slot,
      slot = _ref$slot === void 0 ? 'Popup' : _ref$slot,
      className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["slot", "className", "onClick", "children"]);

  var popupRef = core.useEnsureRef(ref);

  var _usePositioning = usePositioning(popupRef, rest),
      _usePositioning2 = _slicedToArray(_usePositioning, 2),
      positionInfo = _usePositioning2[0],
      placeholder = _usePositioning2[1];

  var slotName = React.useMemo(function () {
    return getDialogLayersSize() === 0 ? slot : slot + '-' + (getDialogLayersSize() - 1);
  }, []);
  return React__default.createElement(React__default.Fragment, null, placeholder, React__default.createElement(core.Fill, {
    name: slotName
  }, React__default.createElement(AbsoluteContainer, _extends({}, positionInfo, {
    onClick: onClick,
    className: className,
    ref: popupRef
  }), children)));
});

var FlipList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FlipList, _React$Component);

  function FlipList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FlipList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FlipList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.play = function (oldSnap, newSnap) {
      var _newSnap$parent;

      var _this$props = _this.props,
          animation = _this$props.animation,
          insertAnimation = _this$props.insertAnimation,
          removeAnimation = _this$props.removeAnimation,
          onEndAnimation = _this$props.onEndAnimation,
          onStartAnimation = _this$props.onStartAnimation,
          effect = _this$props.effect,
          skipChromeFix = _this$props.skipChromeFix,
          timing = _this$props.timing;
      newSnap.children.forEach(function (newItemSnap) {
        var oldItemSnap = oldSnap.children.get(newItemSnap.domNode);
        if (!oldItemSnap) return;
        var rectAnimation = getClientRectAnimation(oldItemSnap, newItemSnap);
        morph(newItemSnap.domNode, formatAnimation(rectAnimation, timing));
      });

      if (newSnap.children.size > oldSnap.children.size) {
        var newItems = Array.from(newSnap.children.values()).filter(function (item) {
          return !oldSnap.children.has(item.domNode);
        });
        newItems.forEach(function (newItem) {
          morph(newItem.domNode, formatAnimation(insertAnimation || animation, timing, !insertAnimation));
        });
      } else if (newSnap.children.size < oldSnap.children.size) {
        var oldItems = Array.from(oldSnap.children.values()).filter(function (item) {
          return !newSnap.children.has(item.domNode);
        });
        oldItems.forEach(function (oldItem) {
          var reinserted = _this.reinsertSnap(oldItem, oldSnap.scrollTop - newSnap.scrollTop, oldItems);

          if (!reinserted) {
            return;
          }

          new Promise(function (res) {
            morph(oldItem.domNode, formatAnimation(removeAnimation || animation, timing), res);
            setTimeout(res, 1500);
          }).then(function () {
            oldItem.domNode.remove();
          });
        });
      }

      var rectAnimation = getClientRectAnimation(oldSnap.parent, newSnap.parent, {
        skipTransform: true,
        smallJumpFix: _this.props.smallJumpFix
      });

      if ((_newSnap$parent = newSnap.parent) === null || _newSnap$parent === void 0 ? void 0 : _newSnap$parent.domNode) {
        var endEffect = utils.callIfFunction(effect, newSnap.parent.domNode, {
          newSnap: newSnap,
          oldSnap: oldSnap
        });
        utils.callIfFunction(onStartAnimation);
        morph(newSnap.parent.domNode, formatAnimation(rectAnimation, timing), endEffect || onEndAnimation);
      }
    };

    _this.reinsertSnap = function (item, scrollDelta, allChildren) {
      if (item.nextSibling) {
        var _item$nextSibling$par;

        if (!item.nextSibling.parentNode) {
          var next = allChildren.find(function (possible) {
            return item.nextSibling === possible.domNode;
          });

          if (next) {
            return _this.reinsertSnap(_objectSpread({}, item, {
              nextSibling: next.nextSibling
            }), scrollDelta, allChildren);
          }

          return false;
        }

        (_item$nextSibling$par = item.nextSibling.parentNode) === null || _item$nextSibling$par === void 0 ? void 0 : _item$nextSibling$par.insertBefore(item.domNode, item.nextSibling);
      } else {
        item.parentNode.appendChild(item.domNode);
      }

      var _item$domNode$getBoun = item.domNode.getBoundingClientRect(),
          width = _item$domNode$getBoun.width,
          height = _item$domNode$getBoun.height;

      item.domNode.style.left = item.domNode.offsetLeft + 'px';
      item.domNode.style.top = item.domNode.offsetTop - scrollDelta + 'px';
      item.domNode.style.marginTop = 0;
      item.domNode.style.marginLeft = 0;
      item.domNode.style.width = width + 'px';
      item.domNode.style.height = height + 'px';
      item.domNode.style.position = 'absolute';
      return true;
    };

    _this.getParents = function () {
      var node = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
      var parentNode = node.parentNode,
          possibleOffsetParent = node.offsetParent;
      var offsetParent = possibleOffsetParent || (window.getComputedStyle(parentNode).position !== 'static' ? parentNode : parentNode.offsetParent);
      if (!offsetParent) return {};
      var parentRect = offsetParent.getBoundingClientRect();
      return {
        offsetParent: offsetParent,
        parentNode: parentNode,
        parentRect: parentRect
      };
    };

    _this.calculatePositionForAnimation = function () {
      var _this$getParents = _this.getParents(),
          parentRect = _this$getParents.parentRect,
          parentNode = _this$getParents.parentNode,
          offsetParent = _this$getParents.offsetParent;

      if (!offsetParent) return null;
      var children = new Map();
      [].slice.call(parentNode.children).map(function (node) {
        var position = toPosition(node, parentRect, {
          withMargins: true,
          numberOfSiblings: _this.props.numberOfElements || 1
        });

        if (position) {
          children.set(node, position);
        }
      });
      return {
        children: children,
        parent: toPosition(offsetParent, undefined, {
          withMargins: true
        }),
        scrollTop: offsetParent.scrollTop
      };
    };

    return _this;
  }

  _createClass(FlipList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snap) {
      if (snap) {
        var newSnap = this.calculatePositionForAnimation();

        if (newSnap) {
          // se não tiver parentNode, verficar se há uma div sendo offsetParent, body não serve
          this.play(snap, newSnap);
        }
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(oldProps) {
      if (this.props.play || this.props.on !== oldProps.on || this.props.children.length !== oldProps.children.length) {
        return this.calculatePositionForAnimation();
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          as = _this$props2.as,
          play = _this$props2.play,
          on = _this$props2.on,
          onStartAnimation = _this$props2.onStartAnimation,
          onEndAnimation = _this$props2.onEndAnimation,
          rest = _objectWithoutProperties(_this$props2, ["children", "as", "play", "on", "onStartAnimation", "onEndAnimation"]);

      var result = React__default.Children.count(children) ? children : React__default.createElement("div", {
        style: {
          display: 'none'
        }
      });

      if (as) {
        var RenderAs = as;
        return React__default.createElement(RenderAs, rest, result);
      }

      return result;
    }
  }]);

  return FlipList;
}(React__default.Component);
FlipList.defaultProps = {
  timing: defaultAnimationMaker,
  animation: utils.oneWayAnimation("transform: scale(1); transform-origin: center; opacity: 1;", "transform: scale(0); transform-origin: center; opacity: 0;")
};

var _React$createContext = React__default.createContext({}),
    Provider = _React$createContext.Provider,
    Consumer = _React$createContext.Consumer;

var DropPosition = styled__default.div.withConfig({
  displayName: "Draggable__DropPosition",
  componentId: "sc-1g7nmwq-0"
})(["border:2px dashed rgba(0,0,0,0.1);background-color:rgba(0,0,0,0.025);border-radius:8px;position:absolute;top:0;bottom:0;right:0;left:0;visibility:visible;display:block;", ""], function (props) {
  return props.rounded && "\n    border-radius: 1000rem;\n  ";
});
var EmptyPlaceholder = styled__default.div.withConfig({
  displayName: "Draggable__EmptyPlaceholder",
  componentId: "sc-1g7nmwq-1"
})(["position:absolute;"]);
var HORIZONTAL_DIMENSIONS = {
  min: 'left',
  max: 'right',
  axis: 'x',
  size: 'Width'
};
var VERTICAL_DIMENSIONS = {
  min: 'top',
  max: 'bottom',
  axis: 'y',
  size: 'Height'
};
var AUTO_SCROLL_BORDER_SIZE = 30;
var AUTO_SCROLL_MAX_VELOCITY = 20;
var AUTO_SCROLL_OVERFLOW_BUFFER = 100;

function easeInCubic(t) {
  return Math.ceil(t * t * t / (AUTO_SCROLL_MAX_VELOCITY * AUTO_SCROLL_MAX_VELOCITY));
}

var disableWillChange = function disableWillChange(el) {
  var willChange = el === null || el === void 0 ? void 0 : el.closest(".JS-has-wc");

  if (willChange) {
    willChange.classList.add('JS-wc-off');
    disableWillChange(willChange.parentNode);
  }
};

var reenableWillChange = function reenableWillChange(el) {
  var willChange = el === null || el === void 0 ? void 0 : el.closest(".JS-has-wc");

  if (willChange) {
    willChange.classList.remove('JS-wc-off');
    reenableWillChange(willChange.parentNode);
  }
};

var shouldPreventDrag = function shouldPreventDrag(e) {
  return !e.target.closest('body,.drag-drop-item,[data-drag="false"],input,textarea,button').matches('body,.drag-drop-item,[data-drag="true"]');
};

var DraggableItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DraggableItem, _React$Component);

  function DraggableItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DraggableItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DraggableItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.events = _this.props.eventHandlers(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(DraggableItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          DragTag = _this$props.DragTag,
          _this$props$as = _this$props.as,
          as = _this$props$as === void 0 ? 'div' : _this$props$as,
          eventHandlers = _this$props.eventHandlers,
          className = _this$props.className,
          isDragging = _this$props.isDragging,
          droppable = _this$props.droppable,
          dragIndex = _this$props.dragIndex,
          roundedPlaceholder = _this$props.roundedPlaceholder,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["DragTag", "as", "eventHandlers", "className", "isDragging", "droppable", "dragIndex", "roundedPlaceholder", "children"]);

      var Wrapper = DragTag || as;
      var extraClassName = (isDragging ? ' drag-drop-placeholder' : '') + ' drag-drop-item';
      return typeof children === 'function' ? children(_objectSpread({
        className: extraClassName
      }, this.events, {
        children: isDragging && React__default.createElement(DropPosition, {
          rounded: roundedPlaceholder
        })
      })) : React__default.createElement(Wrapper, _extends({
        className: className + extraClassName,
        isDragging: isDragging
      }, props, this.events), children, isDragging && React__default.createElement(DropPosition, {
        rounded: roundedPlaceholder
      }));
    }
  }]);

  return DraggableItem;
}(React__default.Component);

DraggableItem.a = function (props) {
  return React__default.createElement(DraggableItem, _extends({}, props, {
    DragTag: "a"
  }));
};

var DroppableContainer = function DroppableContainer(props) {
  return React__default.createElement(Consumer, null, function (dragProps) {
    return React__default.createElement(DroppableContainerComponent, _extends({}, props, dragProps));
  });
};

var DroppableContainerComponent =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(DroppableContainerComponent, _React$Component2);

  function DroppableContainerComponent() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, DroppableContainerComponent);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(DroppableContainerComponent)).call.apply(_getPrototypeOf3, [this].concat(args)));
    _this2.draggables = [];
    _this2.emptyPlaceholder = void 0;

    _this2.addProps = function (children, eventHandlers, activeIndex, extraProps) {
      return children.map(function (c, index) {
        return c.type === DraggableItem ? React__default.cloneElement(c, {
          isDragging: activeIndex === index,
          dragIndex: index,
          droppable: _assertThisInitialized(_assertThisInitialized(_this2)),
          ref: function ref(el) {
            return _this2.draggables[index] = el;
          },
          eventHandlers: eventHandlers
        }) : c;
      });
    };

    _this2.toPosition = function (parentRect, _ref) {
      var scrollTop = _ref.scrollTop,
          scrollLeft = _ref.scrollLeft;
      return function (el, i) {
        if (el) {
          var domNode = ReactDOM.findDOMNode(el);

          var _domNode$getBoundingC = domNode.getBoundingClientRect(),
              width = _domNode$getBoundingC.width,
              height = _domNode$getBoundingC.height;

          return {
            droppable: _assertThisInitialized(_assertThisInitialized(_this2)),
            index: i,
            width: width,
            height: height,
            y: parentRect.top + domNode.offsetTop + height / 2 + (scrollTop || 0),
            x: parentRect.left + domNode.offsetLeft + width / 2 + (scrollLeft || 0)
          };
        }
      };
    };

    _this2.getPosition = function (i, scrollXY) {
      var el = _this2.draggables[i];

      if (el) {
        var parent = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this2))).offsetParent;
        var parentRect = parent.getBoundingClientRect();
        return _this2.toPosition(parentRect, 0)(el, i);
      }
    };

    _this2.getPositions = function (scrollXY, dragInfo) {
      if (_this2.props.allowDrop && !_this2.props.allowDrop(_map(dragInfo, function (v) {
        return v && v.props ? v.props.id : v;
      }))) {
        return [];
      }

      var parent = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this2))).offsetParent;

      if (!parent) {
        return [];
      }

      var parentRect = parent.getBoundingClientRect();

      var toPosition = _this2.toPosition(parentRect, scrollXY);

      var existing = _this2.draggables.map(toPosition).filter(function (_) {
        return _;
      });

      if (existing.length || !_this2.props.placeholder) return existing;
      return [ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this2)))].map(toPosition).filter(function (_) {
        return _;
      });
    };

    _this2.repositionDragged = function (array, _ref2, getActiveElement) {
      var active = _ref2.active,
          startIndex = _ref2.startIndex,
          startDroppable = _ref2.startDroppable,
          activeIndex = _ref2.activeIndex,
          activeDroppable = _ref2.activeDroppable;

      if (activeDroppable && (activeDroppable === _assertThisInitialized(_assertThisInitialized(_this2)) || startDroppable === _assertThisInitialized(_assertThisInitialized(_this2)))) {
        // remove
        var removedOrInserted = _pullAt(startDroppable === _assertThisInitialized(_assertThisInitialized(_this2)) ? startIndex : [], array);

        if (activeDroppable === _assertThisInitialized(_assertThisInitialized(_this2))) {
          // insert
          removedOrInserted.splice(activeIndex, 0, getActiveElement());
        }

        return removedOrInserted;
      }

      return array;
    };

    _this2.getPlaceholder = function (childArray, dragInfo) {
      return childArray.find(function (_) {
        return _.props.droppable;
      }) || dragInfo.startDroppable.props.children[dragInfo.startIndex];
    };

    _this2.getDragged = function (childArray, dragInfo) {
      return dragInfo.startDroppable === _assertThisInitialized(_assertThisInitialized(_this2)) ? childArray[dragInfo.startIndex] : React__default.cloneElement(_this2.getPlaceholder(childArray, dragInfo), {
        key: childArray[0].key + 'si' + dragInfo.startIndex
      });
    };

    _this2.childrenToarray = function (_ref3) {
      var children = _ref3.children,
          list = _ref3.list,
          dragInfo = _ref3.dragInfo;
      var startDroppable = dragInfo.startDroppable,
          startIndex = dragInfo.startIndex;

      if (list) {
        return React__default.Children.toArray(children(_this2.repositionDragged(list, dragInfo, function () {
          return startDroppable.props.list[startIndex];
        })));
      } else {
        var childArray = React__default.Children.toArray(children);
        return _this2.repositionDragged(childArray, dragInfo, function () {
          return _this2.getDragged(childArray, dragInfo);
        });
      }
    };

    return _this2;
  }

  _createClass(DroppableContainerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.addDroppable(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.removeDroppable(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          group = _this$props2.group,
          placeholder = _this$props2.placeholder,
          dragInfo = _this$props2.dragInfo,
          animation = _this$props2.animation,
          timing = _this$props2.timing,
          eventHandlers = _this$props2.eventHandlers;
      var active = dragInfo.active,
          activeIndex = dragInfo.activeIndex,
          activeDroppable = dragInfo.activeDroppable;
      var childArray = this.childrenToarray(this.props);

      if (!childArray.length && placeholder) {
        return placeholder();
      }

      return React__default.createElement(FlipList, {
        animation: animation,
        timing: timing,
        play: active
      }, this.addProps(childArray, eventHandlers, active && activeDroppable === this && activeIndex));
    }
  }]);

  return DroppableContainerComponent;
}(React__default.Component);

DroppableContainerComponent.defaultProps = {
  placeholder: function placeholder() {
    return React__default.createElement(EmptyPlaceholder, null);
  }
};
var DraggableContainer =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(DraggableContainer, _React$Component3);

  function DraggableContainer() {
    var _getPrototypeOf4;

    var _this3;

    _classCallCheck(this, DraggableContainer);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf4 = _getPrototypeOf(DraggableContainer)).call.apply(_getPrototypeOf4, [this].concat(args)));
    _this3.props = void 0;
    _this3.ghost = void 0;
    _this3.positions = {};
    _this3.passedResistance = false;
    _this3.pressedEnough = false;
    _this3.holdTouchTimer = void 0;
    _this3.preventScroll = void 0;
    _this3.state = {
      dragInfo: {}
    };
    _this3.droppables = {};
    _this3.offsetParent = void 0;
    _this3.parent = void 0;
    _this3.ghostDimensions = void 0;
    _this3.itemsPositions = void 0;
    _this3.scrollContainer = void 0;
    _this3.lastScrollTop = void 0;
    _this3.lastScrollLeft = void 0;
    _this3.settedDragRef = false;

    _this3.preventDefault = function (e) {
      if (!shouldPreventDrag(e) && _this3.preventScroll) e.preventDefault();
    };

    _this3.getScrollContainer = function () {
      return _this3.scrollContainer = _this3.scrollContainer || (_this3.props.scrollContainer ? _this3.props.scrollContainer : utils.getScrollParent(ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this3)))));
    };

    _this3.removeItem = function (el) {
      _this3.domItems = _this3.domItems.filter(function (e) {
        return e !== el;
      });
    };

    _this3.setOffsetParent = function (e) {
      _this3.parent = e;
      _this3.offsetParent = e && (window.getComputedStyle(e).position !== 'static' ? e : e.offsetParent);
    };

    _this3.getConstraintDimensions = function () {
      if (!_this3.offsetParent) return {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        width: 0,
        height: 0
      };
      return _this3.offsetParent.getBoundingClientRect();
    };

    _this3.dragStart = function (draggable) {
      return function (e, _ref4) {
        var pageX = _ref4.pageX,
            pageY = _ref4.pageY,
            clientX = _ref4.clientX,
            clientY = _ref4.clientY;
        _this3.dragHasEnded = false;
        var currentTarget = e.currentTarget;

        if (shouldPreventDrag(e) || _this3.props.disabled) {
          return;
        }

        if (e.type === 'mousedown' && e.button !== 0) {
          return;
        }

        e.stopPropagation();
        _this3.passedResistance = false;
        var holdTouchTimer = _this3.props.holdTouchTimer;
        _this3.pressedEnough = !holdTouchTimer;

        if (holdTouchTimer) {
          e.persist();
          _this3.holdTouchTimer = setTimeout(function () {
            _this3.pressedEnough = true;
            if (window.navigator.vibrate) window.navigator.vibrate([65]);

            if (!_this3.state.dragInfo.active) {
              _this3.dragMove(e, {
                pageX: pageX,
                pageY: pageY,
                clientX: clientX,
                clientY: clientY
              });
            }
          }, holdTouchTimer);
        }

        var _currentTarget$getBou = currentTarget.getBoundingClientRect(),
            width = _currentTarget$getBou.width,
            height = _currentTarget$getBou.height,
            top = _currentTarget$getBou.top,
            left = _currentTarget$getBou.left;

        var targetStyle = window.getComputedStyle(currentTarget);

        var _this3$getConstraintD = _this3.getConstraintDimensions(),
            parentTop = _this3$getConstraintD.top,
            parentLeft = _this3$getConstraintD.left;

        var offsetTop = parentTop + pageY - top + parseInt(targetStyle['margin-top'], 10);
        var offsetLeft = parentLeft + pageX - left + parseInt(targetStyle['margin-left'], 10);

        var _this3$getScrollConta = _this3.getScrollContainer(),
            scrollTop = _this3$getScrollConta.scrollTop,
            scrollLeft = _this3$getScrollConta.scrollLeft,
            scrollY = _this3$getScrollConta.scrollY,
            scrollX = _this3$getScrollConta.scrollX;

        _this3.positions = {
          originalX: pageX,
          originalY: pageY,
          offsetTop: offsetTop,
          offsetLeft: offsetLeft,
          ghostHeight: height,
          ghostWidth: width,
          ghostMarginTop: parseInt(targetStyle['margin-top'], 10),
          ghostMarginLeft: parseInt(targetStyle['margin-left'], 10),
          scrollLeft: scrollLeft || 0,
          scrollTop: scrollTop || 0,
          scrollY: scrollY || 0,
          scrollX: scrollX || 0
        };
        var ghost = currentTarget.cloneNode(true);
        ghost.className += ' dragging';
        Object.assign(ghost.style, {
          transition: '',
          position: 'fixed',
          display: 'none',
          zIndex: '10',
          width: width + 'px',
          height: height + 'px',
          margin: '0',
          top: top - clientY + 'px',
          left: left - clientX + 'px'
        });

        _this3.setupMove(ghost, currentTarget.offsetParent, draggable, {
          width: width,
          height: height,
          offsetX: pageX - left,
          offsetY: pageY - top
        });

        window.addEventListener('mousemove', _this3.mouseMove);
        window.addEventListener('touchmove', _this3.touchMove, {
          passive: false
        });
        window.addEventListener('mouseup', _this3.dragEnd);
        window.addEventListener('touchend', _this3.dragEnd);
        window.addEventListener('visibilitychange', _this3.dragEnd);
        window.addEventListener('blur', _this3.dragEnd, false);
        window.addEventListener('selectstart', _this3.disableSelect);
      };
    };

    _this3.setupMove = function (el, parent, item, ghostDimensions) {
      _this3.ghostDimensions = ghostDimensions;
      parent.click(); // close popups

      _this3.ghost = el;
      parent.appendChild(_this3.ghost);
      disableWillChange(_this3.ghost);

      _this3.setState({
        dragInfo: {
          active: false,
          startIndex: item.props.dragIndex,
          activeGroup: item.props.droppable.props.group,
          startDroppable: item.props.droppable
        }
      });

      _this3.settedDragRef = false;
    };

    _this3.getScrollPosition = function () {
      var _this3$getScrollConta2 = _this3.getScrollContainer(),
          scrollY = _this3$getScrollConta2.scrollY,
          scrollX = _this3$getScrollConta2.scrollX,
          scrollLeft = _this3$getScrollConta2.scrollLeft,
          scrollTop = _this3$getScrollConta2.scrollTop;

      var left = (scrollX || 0 + scrollLeft || 0) - _this3.positions.scrollX - _this3.positions.scrollLeft;
      var top = (scrollY || 0 + scrollTop || 0) - _this3.positions.scrollY - _this3.positions.scrollTop;
      return {
        scrollLeft: left,
        scrollTop: top
      };
    };

    _this3.resetPositions = function () {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.state.dragInfo.activeGroup;
      _this3.itemsPositions = _this3.droppables[group].reduce(function (acc, _) {
        return acc.concat(_.getPositions(_this3.getScrollPosition(), _this3.state.dragInfo));
      }, []).sort(function (a, b) {
        return a.y - b.y || a.x - b.x;
      });
    };

    _this3.move = function (x, y) {
      if (!_this3.settedDragRef && _this3.props.setDragRef) {
        _this3.props.setDragRef(_this3.ghost);

        _this3.settedDragRef = true;
      }

      var _this3$getScrollPosit = _this3.getScrollPosition(),
          scrollTop = _this3$getScrollPosit.scrollTop,
          scrollLeft = _this3$getScrollPosit.scrollLeft;

      _this3.preventScroll = true;

      var item = _this3.findGhostIndex(x - _this3.ghostDimensions.offsetX + (scrollLeft || 0), y - _this3.ghostDimensions.offsetY + (scrollTop || 0), _this3.ghostDimensions.width, _this3.ghostDimensions.height);

      if (!item) {
        return;
      }

      var dragInfo = _this3.state.dragInfo;

      if (item.index !== dragInfo.activeIndex || item.droppable !== dragInfo.activeDroppable) {
        _this3.setState({
          dragInfo: _assign(dragInfo, {
            active: true,
            activePosition: item,
            activeIndex: item.index,
            activeDroppable: item.droppable
          })
        });
      }
    };

    _this3.findGhostIndex = function (ghostX1, ghostY1, ghostWidth, ghostHeight) {
      var ghostY2 = ghostY1 + ghostHeight;
      var ghostX2 = ghostX1 + ghostWidth;

      var centerInsideGhost = _this3.itemsPositions.filter(function (position) {
        return position.y >= ghostY1 && position.x >= ghostX1 && position.y <= ghostY2 && position.x <= ghostX2;
      });

      var ghostX = ghostX1 + ghostWidth / 2;
      var ghostY = ghostY1 + ghostHeight / 2;

      var rectanglesIntersection = function rectanglesIntersection(a, b) {
        return Math.max(0, Math.min(a.x2, b.x2) - Math.max(a.x1, b.x1)) * Math.max(0, Math.min(a.y2, b.y2) - Math.max(a.y1, b.y1));
      };

      var closestIndex = centerInsideGhost.map(function (item) {
        var x = item.x,
            y = item.y,
            width = item.width,
            height = item.height;
        var area = width * height;
        var intersectionArea = rectanglesIntersection( //at least 1px wide
        {
          x1: x - Math.max(1, width) / 2,
          x2: x + width / 2,
          y1: y - Math.max(1, height) / 2,
          y2: y + height / 2
        }, {
          x1: ghostX1,
          x2: ghostX2,
          y1: ghostY1,
          y2: ghostY2
        });
        var distance = Math.sqrt(Math.pow(x - ghostX, 2) + Math.pow(y - ghostY, 2));
        return {
          area: intersectionArea / area,
          distance: distance
        };
      }).reduce(function (iMax, _ref5, i, arr) {
        var area = _ref5.area,
            distance = _ref5.distance;
        return area > arr[iMax].area || area === arr[iMax].area && distance < arr[iMax].distance ? i : iMax;
      }, 0);
      return centerInsideGhost[closestIndex];
    };

    _this3.stopMoving = function () {
      if (_this3.dragHasEnded) {
        return;
      }

      _this3.dragHasEnded = true;
      var dragInfo = _this3.state.dragInfo;
      var activeIndex = dragInfo.activeIndex,
          startIndex = dragInfo.startIndex,
          activeGroup = dragInfo.activeGroup,
          activeDroppable = dragInfo.activeDroppable,
          startDroppable = dragInfo.startDroppable;

      if (_this3.endTimeout) {
        clearTimeout(_this3.endTimeout);
        _this3.endTimeout = null;
      }

      _this3.setState({
        saving: {
          list: _this3.props.list,
          children: _this3.props.children,
          dragInfo: _set('active', false, dragInfo)
        }
      }, function () {
        var _this3$ghost;

        _this3.preventScroll = false;

        _this3.props.setDragRef(null);

        _this3.settedDragRef = false;

        if ((_this3$ghost = _this3.ghost) === null || _this3$ghost === void 0 ? void 0 : _this3$ghost.parentNode) {
          reenableWillChange(_this3.ghost);

          _this3.ghost.parentNode.removeChild(_this3.ghost);
        }

        if (activeIndex !== startIndex && activeIndex !== undefined || activeDroppable !== startDroppable && activeDroppable !== undefined) {
          var promise = _this3.props.setItemOrder(startIndex, activeIndex, startDroppable.props.id, activeDroppable.props.id, activeGroup);

          if (promise && promise.then) {
            promise.then(_this3.clearChangedOrder, _this3.clearChangedOrder);
          } else {
            _this3.clearChangedOrder();
          }
        } else {
          _this3.clearChangedOrder();
        }
      });
    };

    _this3.clearChangedOrder = function () {
      _this3.setState({
        dragInfo: {},
        saving: false
      });
    };

    _this3.dragMove = function (e, _ref6) {
      var pageX = _ref6.pageX,
          pageY = _ref6.pageY,
          clientX = _ref6.clientX,
          clientY = _ref6.clientY;
      var distance = Math.sqrt(Math.pow(_this3.positions.originalX - pageX, 2) + Math.pow(_this3.positions.originalY - pageY, 2));

      if (e.type === 'mousemove') {
        // get touchstart and touchmove
        if (!_this3.passedResistance && !_this3.props.noResistance && distance < 5) {
          return;
        }
      } else {
        if (!_this3.pressedEnough) {
          if (distance > 5) {
            _this3.dragEnd();
          }

          return;
        }

        e.preventDefault();
      }

      _this3.passedResistance = true;

      _this3.processAutoScroll(pageX, pageY, clientX, clientY);
    };

    _this3.completeMove = function (pageX, pageY) {
      var _this3$getScrollConta3 = _this3.getScrollContainer(),
          scrollTop = _this3$getScrollConta3.scrollTop,
          scrollLeft = _this3$getScrollConta3.scrollLeft;

      var scrollYDelta = _this3.positions.scrollTop - (scrollTop || 0);
      var scrollXDelta = _this3.positions.scrollLeft - (scrollLeft || 0);
      var ghostLeft = pageX - _this3.positions.offsetLeft;
      var ghostTop = pageY - _this3.positions.offsetTop;

      var _this3$getConstraintD2 = _this3.getConstraintDimensions(),
          parentHeight = _this3$getConstraintD2.height,
          parentWidth = _this3$getConstraintD2.width;

      var normalizedLeft = Math.max(Math.min(ghostLeft, parentWidth - _this3.positions.ghostWidth - _this3.positions.ghostMarginLeft + scrollXDelta), 0 - _this3.positions.ghostMarginLeft + scrollXDelta);
      var normalizedTop = Math.max(Math.min(ghostTop, parentHeight - _this3.positions.ghostHeight - _this3.positions.ghostMarginTop + scrollYDelta), 0 - _this3.positions.ghostMarginTop + scrollYDelta);
      var x = normalizedLeft - ghostLeft + pageX - window.scrollX;
      var y = normalizedTop - ghostTop + pageY - window.scrollY;

      if (_this3.ghost) {
        _this3.ghost.style.transform = "translate(".concat(x, "px,").concat(y, "px)") + (_this3.props.ghostScale ? ' scale(' + _this3.props.ghostScale + ')' : '');
        _this3.ghost.style.display = '';
      }

      _this3.move(pageX - (ghostLeft - normalizedLeft), pageY - (ghostTop - normalizedTop));

      if (!_this3.state.dragInfo.active) {
        _this3.setState({
          dragInfo: _assign(_this3.state.dragInfo, {
            activeIndex: _this3.state.dragInfo.startIndex,
            activeDroppable: _this3.state.dragInfo.startDroppable,
            active: true
          })
        });
      }
    };

    _this3.autoScrollAnimation = void 0;
    _this3.autoScrollX = void 0;
    _this3.autoScrollY = void 0;

    _this3.getFixedParentRect = function (node, not) {
      if (node) {
        if (window.getComputedStyle(node)['position'].toLowerCase() === 'fixed' && not !== node) return node.getBoundingClientRect();else return _this3.getFixedParentRect(node.offsetParent, not);
      } else {
        return {};
      }
    };

    _this3.calculateDistanceFromBorder = function (ghost, position, getElementBeforeBorder, scrollContainer, parentRect, keys) {
      var fixedUnderMouse = scrollContainer === window ? _this3.getFixedParentRect(getElementBeforeBorder(+AUTO_SCROLL_BORDER_SIZE), ghost) : {};
      var min = scrollContainer !== window ? scrollContainer.getBoundingClientRect()[keys.min] : fixedUnderMouse[keys.max] || _this3.getFixedParentRect(getElementBeforeBorder(-AUTO_SCROLL_BORDER_SIZE), ghost)[keys.max] || 0;
      var max = scrollContainer !== window ? scrollContainer.getBoundingClientRect()[keys.max] : fixedUnderMouse[keys.min] || _this3.getFixedParentRect(getElementBeforeBorder(+AUTO_SCROLL_BORDER_SIZE), ghost)[keys.min] || window['inner' + keys.size];
      var distanceMin = position - AUTO_SCROLL_BORDER_SIZE - min;
      var distanceMax = position + AUTO_SCROLL_BORDER_SIZE - max;
      var containerMin = scrollContainer === window ? 0 : Math.max(scrollContainer.getBoundingClientRect()[keys.min], 0);
      var containerMax = scrollContainer === window ? window['inner' + keys.size] : Math.min(scrollContainer.getBoundingClientRect()[keys.max], window['inner' + keys.size]);
      var afterCenter = (position - containerMin) * 2 / (containerMax - containerMin) > 1;
      if (distanceMin < 0 && !afterCenter) return distanceMin;
      if (distanceMax > 0) return distanceMax;
      return 0;
    };

    _this3.processAutoScroll = function (pageX, pageY, clientX, clientY) {
      var scrollContainer = _this3.getScrollContainer();

      var parentRect = _this3.getConstraintDimensions();

      _this3.autoScrollY = _this3.calculateDistanceFromBorder(_this3.ghost, clientY, function (diff) {
        return document.elementFromPoint(clientX, clientY + diff);
      }, scrollContainer, parentRect, VERTICAL_DIMENSIONS); // this.autoScrollX = this.calculateDistanceFromBorder(clientX, (diff) => document.elementFromPoint(clientX + diff, clientY), scrollContainer, parentRect, HORIZONTAL_DIMENSIONS)

      _this3.autoScrollX = 0; // noinspection JSSuspiciousNameCombination

      var keepY = _this3.autoScrollX === 0 || _this3.autoScrollY !== 0 && Math.abs(_this3.autoScrollY) < Math.abs(_this3.autoScrollX);
      _this3.autoScrollY = _this3.props.scrollOnDrag && keepY ? _this3.autoScrollY : 0;
      _this3.autoScrollX = _this3.props.scrollOnDrag && !keepY ? _this3.autoScrollX : 0;

      if (_this3.autoScrollX || _this3.autoScrollY) {
        _this3.startAutoScroll(pageX, pageY, scrollContainer);
      } else {
        if (_this3.autoScrollAnimation) {
          _this3.stopAutoScroll();
        }

        _this3.completeMove(pageX, pageY);
      }
    };

    _this3.checkLimits = function (delta, boundRect, constraintRect, scrollRect, keys) {
      if (delta > 0) {
        if (constraintRect[keys.max] + AUTO_SCROLL_OVERFLOW_BUFFER < scrollRect[keys.max]) {
          return 0;
        }
      }

      if (delta < 0) {
        if (constraintRect[keys.min] - AUTO_SCROLL_OVERFLOW_BUFFER > scrollRect[keys.min]) {
          return 0;
        }
      }

      return delta;
    };

    _this3.startAutoScroll = function (pageX, pageY, scrollContainer) {
      if (!_this3.autoScrollAnimation) {
        _this3.autoScrollAnimation = window.requestAnimationFrame(function (timestamp) {
          var ghostRect = _this3.ghost.getBoundingClientRect();

          var parentRect = _this3.getConstraintDimensions();

          var scrollRect = scrollContainer === window ? {
            top: 0,
            bottom: window.innerHeight,
            left: 0,
            right: window.innerWidth
          } : scrollContainer.getBoundingClientRect();
          var deltaScrollX = easeInCubic(_this3.checkLimits(_this3.autoScrollX < 0 ? Math.max(_this3.autoScrollX, -AUTO_SCROLL_MAX_VELOCITY) : Math.min(_this3.autoScrollX, AUTO_SCROLL_MAX_VELOCITY), ghostRect, parentRect, scrollRect, HORIZONTAL_DIMENSIONS));
          var deltaScrollY = easeInCubic(_this3.checkLimits(_this3.autoScrollY < 0 ? Math.max(_this3.autoScrollY, -AUTO_SCROLL_MAX_VELOCITY) : Math.min(_this3.autoScrollY, AUTO_SCROLL_MAX_VELOCITY), ghostRect, parentRect, scrollRect, VERTICAL_DIMENSIONS));
          var willScroll = deltaScrollX !== 0 || deltaScrollY !== 0;

          if (willScroll) {
            scrollContainer.scroll((isNaN(scrollContainer.scrollLeft) ? scrollContainer.pageXOffset : scrollContainer.scrollLeft) + deltaScrollX, (isNaN(scrollContainer.scrollTop) ? scrollContainer.pageYOffset : scrollContainer.scrollTop) + deltaScrollY);
          }

          _this3.autoScrollAnimation = 0;

          _this3.completeMove(pageX, pageY);

          if (willScroll) {
            _this3.startAutoScroll(pageX + (scrollContainer === window ? deltaScrollX : 0), pageY + (scrollContainer === window ? deltaScrollY : 0), scrollContainer);
          }
        });
      } else {
        _this3.completeMove(pageX, pageY);
      }
    };

    _this3.stopAutoScroll = function () {
      window.cancelAnimationFrame(_this3.autoScrollAnimation);
      _this3.autoScrollAnimation = 0;
    };

    _this3.dragEnd = function () {
      window.removeEventListener('touchmove', _this3.touchMove);
      window.removeEventListener('mousemove', _this3.mouseMove);
      window.removeEventListener('mouseup', _this3.dragEnd);
      window.removeEventListener('touchend', _this3.dragEnd);
      window.removeEventListener('visibilitychange', _this3.dragEnd);
      window.removeEventListener('blur', _this3.dragEnd);
      window.removeEventListener('selectstart', _this3.disableSelect);

      _this3.stopAutoScroll();

      _this3.props.setDragRef && _this3.props.setDragRef(null);
      clearTimeout(_this3.holdTouchTimer);
      var _this3$state$dragInfo = _this3.state.dragInfo,
          activeDroppable = _this3$state$dragInfo.activeDroppable,
          activeIndex = _this3$state$dragInfo.activeIndex;

      if (activeDroppable) {
        var finalPosition = activeDroppable.getPosition(activeIndex, _this3.getScrollPosition());

        var _window$getComputedSt = window.getComputedStyle(_this3.ghost),
            marginTop = _window$getComputedSt.marginTop,
            marginLeft = _window$getComputedSt.marginLeft,
            left = _window$getComputedSt.left,
            top = _window$getComputedSt.top;

        var finalLeft = finalPosition.x - Math.max(1, finalPosition.width) / 2 - parseInt(left) - parseInt(marginLeft);
        var finalTop = finalPosition.y - Math.max(1, finalPosition.height) / 2 - parseInt(top) - parseInt(marginTop);
        _this3.ghost.style.transition = "transform 300ms ease-in-out 0ms, opacity 300ms ease-in-out 0ms";
        var newTransform = "translate(".concat(finalLeft, "px,").concat(finalTop, "px)");

        if ((_this3.ghost.style.transform || "").replace(/\s/g, '') === newTransform) {
          _this3.stopMoving();
        } else {
          _this3.ghost.style.transform = newTransform;

          _this3.ghost.addEventListener('transitionend', _this3.stopMoving);

          _this3.endTimeout = setTimeout(_this3.stopMoving, 300);
        }
      } else {
        _this3.stopMoving();
      }
    };

    _this3.addDroppable = function (el) {
      _this3.droppables[el.props.group] = (_this3.droppables[el.props.group] || []).concat(el);
    };

    _this3.remoevDroppable = function (el) {
      _this3.droppables[el.props.group] = _this3.droppables[el.props.group].filter(function (_) {
        return _ !== el;
      });
    };

    _this3.mouseDown = function (draggable) {
      return utils.normalizeMouse(_this3.dragStart(draggable), _this3.dragEnd);
    };

    _this3.mouseMove = utils.normalizeMouse(_this3.dragMove, _this3.dragEnd);

    _this3.touchStart = function (draggable) {
      return utils.normalizeTouch(_this3.dragStart(draggable), _this3.dragEnd);
    };

    _this3.touchMove = utils.normalizeTouch(_this3.dragMove, _this3.dragEnd);
    _this3.providerValue = {};

    _this3.providerEvents = function (draggable) {
      return {
        onMouseDown: _this3.mouseDown(draggable),
        onTouchStart: _this3.touchStart(draggable)
      };
    };

    return _this3;
  }

  _createClass(DraggableContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.parent.addEventListener('touchmove', this.preventDefault);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.parent.removeEventListener('touchmove', this.preventDefault);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (!isNaN(this.lastScrollTop) || !isNaN(this.lastScrollLeft)) {
        this.getScrollContainer().scroll(this.lastScrollLeft, this.lastScrollTop);
        this.lastScrollLeft = this.lastScrollTop = undefined;
      }

      if (this.ghost && this.ghost.parentNode) {
        this.ghost.parentNode.appendChild(this.ghost);
      }

      if (this.state.dragInfo !== prevState.dragInfo) {
        this.resetPositions();
      }
    }
  }, {
    key: "disableSelect",
    value: function disableSelect(event) {
      event.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          setItemOrder = _this$props3.setItemOrder,
          noResistance = _this$props3.noResistance,
          animation = _this$props3.animation,
          timing = _this$props3.timing,
          disabled = _this$props3.disabled,
          list = _this$props3.list,
          ghostScale = _this$props3.ghostScale,
          setDragRef = _this$props3.setDragRef,
          scrollOnDrag = _this$props3.scrollOnDrag,
          holdTouchTimer = _this$props3.holdTouchTimer,
          children = _this$props3.children,
          rest = _objectWithoutProperties(_this$props3, ["setItemOrder", "noResistance", "animation", "timing", "disabled", "list", "ghostScale", "setDragRef", "scrollOnDrag", "holdTouchTimer", "children"]);

      var _this$state = this.state,
          saving = _this$state.saving,
          dragInfo = _this$state.dragInfo;
      this.providerValue = _assign(this.providerValue, {
        addDroppable: this.addDroppable,
        removeDroppable: this.remoevDroppable,
        dragInfo: saving ? saving.dragInfo : dragInfo,
        eventHandlers: this.providerEvents
      });

      if (this.scrollContainer) {
        var scrollContainer = this.getScrollContainer();
        this.lastScrollTop = (isNaN(scrollContainer['scrollTop']) ? scrollContainer['pageYOffset'] : scrollContainer['scrollTop']) || undefined;
        this.lastScrollLeft = (isNaN(scrollContainer['scrollLeft']) ? scrollContainer['pageXOffset'] : scrollContainer['scrollLeft']) || undefined;
      }

      return React__default.createElement(Provider, {
        value: this.providerValue
      }, React__default.createElement("div", _extends({}, rest, {
        ref: this.setOffsetParent
      }), React__default.createElement(DroppableContainer, {
        animation: animation,
        timing: timing,
        list: saving ? saving.list : list,
        placeholder: false
      }, saving ? saving.children : children)));
    }
  }]);

  return DraggableContainer;
}(React__default.Component); // type GhostDimensions = { offsetX: number, offsetY: number, width: number, height: number }

DraggableContainer.defaultProps = {
  holdTouchTimer: 300,
  scrollOnDrag: true,
  setDragRef: function setDragRef() {}
};

var _twoWayAnimation$2 = utils.twoWayAnimation("opacity:0;", "opacity:1;"),
    _twoWayAnimation2$2 = _slicedToArray(_twoWayAnimation$2, 2),
    fadeIn = _twoWayAnimation2$2[0],
    fadeOut = _twoWayAnimation2$2[1];

var PopupDiv = styled__default.div.withConfig({
  displayName: "Popup__PopupDiv",
  componentId: "sq2sfn-0"
})(["position:absolute;background-color:#FFF;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 3px 10px -2px rgba(0,0,0,0.15),0 0px 2px 0px rgba(0,0,0,0.2);border-radius:8px;padding:1rem;text-align:initial;line-height:140%;font-size:14px;z-index:999;", " ", " ", ""], function (props) {
  return props.atTop && styled.css(["margin-top:-0.25rem;"]);
}, function (props) {
  return props.atBottom && styled.css(["margin-top:0.25rem;"]);
}, utils.customTheme('Popup'));
var Popup = React__default.forwardRef(function (_ref, ref) {
  var _ref$slot = _ref.slot,
      slot = _ref$slot === void 0 ? 'Popup' : _ref$slot,
      skipPortal = _ref.skipPortal,
      _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? fadeIn : _ref$animation,
      animationOptions = _ref.animationOptions,
      arrowRef = _ref.arrowRef,
      className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["slot", "skipPortal", "animation", "animationOptions", "arrowRef", "className", "onClick", "children"]);

  var popupRef = core.useEnsureRef(ref);

  var _usePositioning = usePositioning(popupRef, rest, arrowRef),
      _usePositioning2 = _slicedToArray(_usePositioning, 3),
      positionInfo = _usePositioning2[0],
      placeholder = _usePositioning2[1],
      arrow = _usePositioning2[2];

  useFlipAnimation(popupRef, animation, true, animationOptions);
  var slotName = React.useMemo(function () {
    return getDialogLayersSize() === 0 ? slot : slot + '-' + (getDialogLayersSize() - 1);
  }, []);
  var popupContainer = React__default.createElement(PopupDiv, _extends({}, positionInfo, {
    onClick: onClick,
    className: className,
    ref: popupRef
  }), arrow, children);
  return skipPortal ? popupContainer : React__default.createElement(React__default.Fragment, null, placeholder, React__default.createElement(core.Fill, {
    name: slotName
  }, popupContainer));
});

var TooltipContainer = styled__default.div.withConfig({
  displayName: "Tooltip__TooltipContainer",
  componentId: "hhprhj-0"
})(["display:inline-block;", "   "], function (props) {
  return props.isWrapper ? "position:relative;" : styled.css(["position:absolute;top:0;left:0;bottom:0;right:0;", ""], function (props) {
    return props.isOpen && 'pointer-events: none;';
  });
});
var TooltipPopup = styled__default(Popup).withConfig({
  displayName: "Tooltip__TooltipPopup",
  componentId: "hhprhj-1"
})(["font-size:12px;pointer-events:none;background-color:rgba(0,0,0,0.6);box-shadow:none;color:white;padding:0.25rem 1rem;border-radius:100px;", ""], utils.customTheme('Tooltip'));

var _twoWayAnimation$3 = utils.twoWayAnimation("opacity:0;", "opacity:1;"),
    _twoWayAnimation2$3 = _slicedToArray(_twoWayAnimation$3, 2),
    fadeIn$1 = _twoWayAnimation2$3[0],
    fadeOut$1 = _twoWayAnimation2$3[1];

var isEllipsis = function isEllipsis(event) {
  return event.currentTarget.firstChild && event.currentTarget.firstChild.offsetWidth < event.currentTarget.firstChild.scrollWidth;
};

var RECENTLY_CLOSED_TIMEOUT = 200;
var recentlyClosed = false;
var openRef = {
  current: null
};
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 400 : _ref$delay,
      instant = _ref.instant,
      whenEllipsis = _ref.whenEllipsis,
      content = _ref.content,
      rest = _objectWithoutProperties(_ref, ["children", "delay", "instant", "whenEllipsis", "content"]);

  var tooltip = core.useToggle();
  var timeout = core.useRefState(-1);

  var mouseEnter = function mouseEnter(e) {
    if (!whenEllipsis || (_isFunction(whenEllipsis) ? whenEllipsis : isEllipsis)(e)) {
      timeout.set(setTimeout(function () {
        tooltip.open();

        if (recentlyClosed && openRef.current) {
          openRef.current.remove();
        }
      }, instant || recentlyClosed ? 0 : delay));
      !children && e.currentTarget.parentNode.addEventListener('mouseleave', onMouseLeave);
    }
  };

  var onMouseLeave = function onMouseLeave(e) {
    clearTimeout(timeout.get());

    if (tooltip.get()) {
      timeout.set(false);
      !children && e.currentTarget.removeEventListener('mouseleave', onMouseLeave);
      var currentlyClosed = recentlyClosed = setTimeout(function () {
        recentlyClosed = recentlyClosed === currentlyClosed ? false : recentlyClosed;
      }, RECENTLY_CLOSED_TIMEOUT);
      tooltip.close();
    }
  };

  var getAnimation = function getAnimation() {
    if (recentlyClosed && timeout.get() !== false) {
      return '';
    } else {
      return fadeIn$1;
    }
  };

  return React__default.createElement(TooltipContainer, {
    isOpen: tooltip.isOpen,
    isWrapper: !!children,
    onMouseUp: onMouseLeave,
    onMouseLeave: children ? onMouseLeave : undefined,
    onMouseEnter: mouseEnter
  }, tooltip.isOpen && content && React__default.createElement(TooltipPopup, _extends({
    animation: getAnimation,
    animationOptions: {
      ref: openRef
    },
    top: !(rest.bottom || rest.left || rest.right || rest.at || rest.my)
  }, rest), content), children);
};

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3rem;\n  text-align: center;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n        padding: 13px 1.25rem;\n      "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    & > * {\n      padding-top: 15px;\n      padding-bottom: 15px;\n    }\n    ", ", .icon {\n      font-size: 25px;\n    }\n  "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var fadeIn$2 = utils.oneWayAnimation('opacity: 0', 'opacity: 1');
var slideDown = utils.oneWayAnimation('transform: translateY(-10px); pointer-events: none', 'transform: translateY(0); pointer-events: none');
var slideUpOnTop = utils.oneWayAnimation('transform: translateY(10px); pointer-events: none', 'transform: translateY(0); pointer-events: none');
var slideRight = utils.oneWayAnimation('transform: translateX(-10px)', 'transform: none;');
var slideLeftOnLeft = utils.oneWayAnimation('transform: translateX(10px); pointer-events: none', 'transform: translateX(0px); pointer-events: none');
var popupAnimation = utils.animationTiming('0.2s ease-out');

var areComponentsEqual = function areComponentsEqual(a, b) {
  return a === b;
};

var ListItem = styled__default.li.withConfig({
  displayName: "ContextMenu__ListItem",
  componentId: "sc-13y1vvt-0"
})(["position:relative;font-size:13px;& > *{padding:11px 1.5rem 11px 3.5rem;display:block;}", " ", ",.icon{font-size:23px;position:absolute;padding-left:0.25rem;left:0;top:50%;transform:translateY(-50%);width:3.5rem;text-align:center;}", " & > a{color:inherit;font-weight:inherit;text-decoration:inherit;}& > a,& > label{cursor:pointer;}", " ", " input[type=\"radio\"]{display:none;}", " ", " ", " ", ""], function (props) {
  return props.hasSubmenu && "\n    & > * {\n      padding-right: 3rem;\n    }\n  ";
}, Icon, utils.media.mobile(_templateObject$6(), Icon), utils.ifProp('hover', styled.css(["& > a,& > label{background:", ";color:", ";color:", ";}"], function (props) {
  return polished.lighten(0.53, utils.getColor("main")(props));
}, utils.getColor('main'), function (props) {
  return polished.darken(0.03, utils.getColor("main")(props));
})), utils.ifProp('highlight', styled.css(["color:", ";"], utils.getColor('main'))), utils.ifProp('noActions', "\n    max-width: 17rem;\n    color: rgba(0,0,0,0.4);\n    pointer-events: none;\n    text-align: center;\n    white-space: normal;\n  "), utils.ifProp('withButton', styled.css(["padding:0.25rem 1rem;", "{width:100%;color:white;font-weight:500;padding:10px 1.25rem;", "}"], Button, utils.media.mobile(_templateObject2$4()))), utils.ifProp('smallPaddingRight', styled.css(["& > *{padding-right:1.5rem;}"])), utils.customTheme('ListItem'));
var ListItemDescText = styled__default.div.withConfig({
  displayName: "ContextMenu__ListItemDescText",
  componentId: "sc-13y1vvt-1"
})(["font-size:11px;margin-top:0.25rem;opacity:0.6;", ""], utils.media.mobile(_templateObject3$2()));
var ListItemHelpText = styled__default.span.withConfig({
  displayName: "ContextMenu__ListItemHelpText",
  componentId: "sc-13y1vvt-2"
})(["opacity:0.5;"]);
var ListMenu = styled__default.ul.withConfig({
  displayName: "ContextMenu__ListMenu",
  componentId: "sc-13y1vvt-3"
})(["padding:0.5rem 0;cursor:default;overflowY:auto;text-align:left;color:inherit;user-select:none;"]);
var ContextListMenu = styled__default(ListMenu).withConfig({
  displayName: "ContextMenu__ContextListMenu",
  componentId: "sc-13y1vvt-4"
})(["position:absolute;z-index:999;background-color:white;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 3px 10px -2px rgba(0,0,0,0.15),0 0px 2px 0px rgba(0,0,0,0.2);border-radius:10px;margin-bottom:0.5rem;overflow:auto;max-height:100vh;", " ", " ", ""], function (props) {
  return props.withoutIcons && "\n    ".concat(ListItem, " > * {\n      padding-left: 1.5rem;\n    }\n  ");
}, utils.ifProp('sub', styled.css(["", " ", ""], function (props) {
  return props.fullHeight ? '' : props.atTop ? 'margin-top: -0.5rem;' : 'margin-top: 0.5rem;';
}, utils.ifProp('atRight', "\n      margin-left: -4px;\n      ", "\n      margin-left: 4px;\n    "))), utils.customTheme('ContextMenu'));
var StickyContainer = styled__default.div.withConfig({
  displayName: "ContextMenu__StickyContainer",
  componentId: "sc-13y1vvt-5"
})(["position:sticky;background:white;", " ", ""], function (props) {
  return props.atBottom && "\n    bottom: -0.5rem;\n    padding-bottom: 0.5rem;\n    margin-bottom: -0.5rem;\n  ";
}, function (props) {
  return props.atTop && "\n    top: -0.5rem;\n    padding-top: 0.5rem;\n    margin-top: -0.5rem;\n  ";
});
var ListSeparator = styled__default.li.withConfig({
  displayName: "ContextMenu__ListSeparator",
  componentId: "sc-13y1vvt-6"
})(["border-bottom:1px solid rgba(0,0,0,0.1);margin-top:0.5rem;margin-bottom:0.5rem;cursor:default;height:0;", ""], utils.ifProp('lighten', styled.css(["border-color:rgba(255,255,255,0.15);"])));
var ListHeading = styled__default.li.withConfig({
  displayName: "ContextMenu__ListHeading",
  componentId: "sc-13y1vvt-7"
})(["display:flex;align-items:center;padding:.5rem 1.25rem .25rem;span{flex-shrink:0;margin-right:.5rem;color:", ";font-size:10px;text-transform:uppercase;font-weight:600;}:after{content:'';flex-grow:1;height:1px;background:", ";}"], utils.getColor('gray180'), utils.getColor('gray240'));
var SubmenuArrowIcon = utils.styledExtend(Icon)(_templateObject4$1());
var SimpleLi =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SimpleLi, _React$Component);

  function SimpleLi() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SimpleLi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SimpleLi)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.scrollToVisibility = function () {
      var el = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
      var list = el.parentNode;

      if (el.offsetTop < list.scrollTop) {
        list.scrollTop = el.offsetTop;
      } else if (el.offsetTop + el.offsetHeight > list.scrollTop + list.offsetHeight) {
        list.scrollTop = el.offsetTop + el.offsetHeight - list.offsetHeight;
      }
    };

    _this.confirm = function () {
      if (_this.props.hover) {
        var node = ReactDOM.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
        node.click();
      }
    };

    _this.onMouseEnter = function () {
      return _this.props.setCursorOnHover && _this.props.setCursorOnHover(_this.props.index);
    };

    _this.onMouseOut = function () {
      return _this.props.setCursorOnHover && _this.props.setCursorOnHover(-1);
    };

    _this.touchEnd = function (e) {
      if (_this.props.children) {
        e.preventDefault();
        if (!_this.props.hover) _this.onMouseEnter();
      }
    };

    _this.onClick = function (e) {
      _this.props.onClick && _this.props.onClick();
    };

    return _this;
  }

  _createClass(SimpleLi, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.emitter.off('confirm', this.confirm);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.hover) {
        this.scrollToVisibility();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.emitter.on('confirm', this.confirm);

      if (this.props.selected && this.props.setCursorOnHover) {
        this.props.setCursorOnHover(this.props.index);
        var el = ReactDOM.findDOMNode(this);
        var list = el.parentNode;
        list.scrollTop = el.offsetTop + el.offsetHeight / 2 - list.offsetHeight / 2;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          layerIndex = _this$props.layerIndex,
          href = _this$props.href,
          linkTo = _this$props.linkTo,
          prefixWith = _this$props.prefixWith,
          subMenu = _this$props.subMenu,
          icon = _this$props.icon,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["label", "layerIndex", "href", "linkTo", "prefixWith", "subMenu", "icon", "children"]);

      var Tag = linkTo ? Link : 'a';
      return React__default.createElement(ListItem, _extends({}, rest, {
        onClick: this.onClick,
        onMouseLeave: this.onMouseOut,
        onMouseEnter: this.onMouseEnter,
        onTouchEnd: this.touchEnd
      }), React__default.createElement(Tag, {
        href: href,
        to: linkTo
      }, prefixWith, icon && React__default.createElement(Icon, {
        icon: icon
      }), label));
    }
  }]);

  return SimpleLi;
}(React__default.Component);
SimpleLi.isKeyboardNavigable = true;
SimpleLi.defaultProps = {
  emitter: mitt()
};
var Li = function Li(_ref) {
  var _ref$emitter = _ref.emitter,
      emitter = _ref$emitter === void 0 ? mitt() : _ref$emitter,
      index = _ref.index,
      menuSlot = _ref.menuSlot,
      keepOpen = _ref.keepOpen,
      hover = _ref.hover,
      layerIndex = _ref.layerIndex,
      hoverCursor = _ref.hoverCursor,
      passTouchThrough = _ref.passTouchThrough,
      children = _ref.children,
      setCursorOnHover = _ref.setCursorOnHover,
      onClick = _ref.onClick,
      prefixWith = _ref.prefixWith,
      linkTo = _ref.linkTo,
      icon = _ref.icon,
      label = _ref.label,
      descText = _ref.descText,
      helpText = _ref.helpText,
      target = _ref.target,
      href = _ref.href,
      rest = _objectWithoutProperties(_ref, ["emitter", "index", "menuSlot", "keepOpen", "hover", "layerIndex", "hoverCursor", "passTouchThrough", "children", "setCursorOnHover", "onClick", "prefixWith", "linkTo", "icon", "label", "descText", "helpText", "target", "href"]);

  var nodeRef = React.useRef();
  var tagRef = React.useRef();
  var subMenu = core.useToggle();
  var subPrevented = core.useRefState(false);

  var onOpenSub = function onOpenSub() {
    subPrevented.set(false);

    if (hover && children) {
      subMenu.open();
    }
  };

  var onPreventSub = function onPreventSub(subIndex) {
    if (index !== subIndex) subMenu.close();
    subPrevented.set(true);
  };

  var confirm = function confirm() {
    if (hover) {
      nodeRef.current.click();
    }
  };

  React.useEffect(function () {
    if (hover) {
      try {
        var el = nodeRef.current;
        var parent = el.parentElement;
        var stickyContainer = parent.lastChild;
        var stickyContainerHeight = stickyContainer && stickyContainer.tagName === "DIV" && stickyContainer.offsetTop - parent.scrollTop < parent.offsetHeight ? stickyContainer.offsetHeight : 0;

        if (el.offsetTop > parent.offsetHeight + parent.scrollTop - stickyContainerHeight - el.offsetHeight) {
          parent.scroll(0, el.offsetTop - parent.offsetHeight + el.offsetHeight + stickyContainerHeight);
        } else if (el.offsetTop < parent.scrollTop) {
          parent.scroll(0, el.offsetTop);
        }
      } catch (e) {}
    }

    emitter.on('confirm', confirm);
    emitter.on('preventSub', onPreventSub);
    emitter.on('openSub', onOpenSub);
    return function () {
      emitter.off('confirm', confirm);
      emitter.off('preventSub', onPreventSub);
      emitter.off('openSub', onOpenSub);
    };
  }, [hover]);
  React.useEffect(function () {
    return function () {
      return subMenu.close();
    };
  }, []);
  React.useEffect(function () {
    if (children && !utils.isMobile()) {
      if (hover) {
        if (!subMenu.isOpen || subMenu.closing || !subPrevented.get()) {
          subMenu.open();
        }
      } else {
        if (subMenu.isOpen) {
          subMenu.closeAfter(200);
          emitter.emit('preventSub', index);
        }
      }
    }
  }, [hoverCursor]);

  var onMouseMove = function onMouseMove(e) {
    if (!hover) {
      utils.callIfFunction(setCursorOnHover, index);
    }

    e === null || e === void 0 ? void 0 : e.stopPropagation();
  };

  var onMouseOut = function onMouseOut(e) {
    utils.callIfFunction(setCursorOnHover, -1);
    e === null || e === void 0 ? void 0 : e.stopPropagation();
  };

  var onClickHandler = function onClickHandler(e) {
    if (children || keepOpen) {
      e.stopPropagation();
    }

    if (children) {
      if (hover) {
        subMenu.toggle();
      } else {
        onMouseMove();
      }
    } else {
      utils.callIfFunction(onClick, e);
    }
  };

  var onCloseSub = function onCloseSub() {
    return emitter.emit('openSub');
  };

  var addProps = function addProps(children) {
    return React__default.Children.map(children, function (c) {
      return React__default.cloneElement(c, {
        closing: subMenu.closing,
        onMouseMove: subMenu.open,
        onClose: onCloseSub,
        sub: true,
        slot: c.props.slot || menuSlot
      });
    });
  };

  var content = React__default.createElement(React__default.Fragment, null, prefixWith, icon && React__default.createElement(Icon, {
    icon: icon
  }), label, " ", helpText && React__default.createElement(ListItemHelpText, null, "(", helpText, ")"), descText && React__default.createElement(ListItemDescText, null, descText), children && React__default.createElement(SubmenuArrowIcon, {
    icon: "arrow-right"
  }));
  var Tag = linkTo ? Link : 'a';
  return React__default.createElement(ListItem, _extends({
    ref: nodeRef
  }, rest, {
    hover: hover,
    onClick: onClickHandler,
    onMouseLeave: onMouseOut,
    onMouseMove: onMouseMove,
    hasSubmenu: children
  }), rest.withButton || rest.noActions ? content : React__default.createElement(Tag, {
    href: href,
    target: target,
    to: linkTo,
    ref: tagRef,
    onMouseEnter: onMouseMove
  }, content), subMenu.isOpen && addProps(children));
};
Li.Simple = SimpleLi;

var _willUseLayers$1 = core.willUseLayers(),
    _willUseLayers2$1 = _slicedToArray(_willUseLayers$1, 2),
    useContextMenuLayers = _willUseLayers2$1[0],
    contextMenuLayersSize = _willUseLayers2$1[1];

var contextMenuLayersQuantity = contextMenuLayersSize;

var _willUseSharedState$3 = core.willUseSharedState(),
    _willUseSharedState2$3 = _slicedToArray(_willUseSharedState$3, 1),
    useContextMenuSharedState = _willUseSharedState2$3[0];

var ContextMenuComponent = React.forwardRef(function (_ref2, unesuredRef) {
  var children = _ref2.children,
      sub = _ref2.sub,
      hoverIndex = _ref2.hoverIndex,
      autoHover = _ref2.autoHover,
      menuSlot = _ref2.menuSlot,
      withoutIcons = _ref2.withoutIcons,
      onClose = _ref2.onClose,
      _ref2$onHover = _ref2.onHover,
      onHover = _ref2$onHover === void 0 ? function () {
    return 0;
  } : _ref2$onHover,
      fill = _ref2.fill,
      onClick = _ref2.onClick,
      props = _objectWithoutProperties(_ref2, ["children", "sub", "hoverIndex", "autoHover", "menuSlot", "withoutIcons", "onClose", "onHover", "fill", "onClick"]);

  var ref = core.useEnsureRef(unesuredRef);

  var _useState = React.useState(autoHover || sub ? 0 : -1),
      _useState2 = _slicedToArray(_useState, 2),
      hoverCursor = _useState2[0],
      setHoverCursor = _useState2[1];

  var _useContextMenuShared = useContextMenuSharedState(0),
      _useContextMenuShared2 = _slicedToArray(_useContextMenuShared, 2),
      layerCursor = _useContextMenuShared2[0],
      setLayerCursor = _useContextMenuShared2[1];

  var _useContextMenuLayers = useContextMenuLayers(),
      _useContextMenuLayers2 = _slicedToArray(_useContextMenuLayers, 2),
      layerIndex = _useContextMenuLayers2[0],
      getSize = _useContextMenuLayers2[1].getSize;

  var itemsEmitter = React.useMemo(function () {
    return mitt();
  }, []);
  React.useEffect(function () {
    window.addEventListener('keydown', keydown);
    return function () {
      utils.callIfFunction(onClose);
      window.removeEventListener('keydown', keydown);
    };
  }, [layerIndex, layerCursor, hoverCursor]);
  React.useEffect(function () {
    if (hoverIndex !== undefined) {
      setHoverCursor(Math.min(Math.max(hoverIndex, -1), getTotalKeyboardItems(children) + 1));
    }
  }, [hoverIndex !== hoverCursor]);

  var keydown = function keydown(e) {
    if (e.keyCode === 37 || e.keyCode === 39) {
      if (!e.defaultPrevented) {
        var layers = getSize();
        var direction = e.keyCode - 38;
        setLayerCursor((layerCursor + direction + layers) % layers);
      }

      e.preventDefault();
    }

    if (layerIndex !== layerCursor) return;

    if (e.keyCode === 27 && ref.current) {
      ref.current.click();
    }

    if (e.keyCode === 13 || e.keyCode === 32 && hoverCursor >= 0) {
      // enter
      e.preventDefault();
      itemsEmitter.emit('confirm');
    }

    if (e.keyCode === 38 || e.keyCode === 40) {
      // up down
      e.preventDefault();

      var _direction = e.keyCode - 39;

      var max = getTotalKeyboardItems(children);
      var newIndex = (hoverCursor + _direction + max) % max;
      setHoverCursor(newIndex);
      onHover(newIndex);
    }
  };

  var getTotalKeyboardItems = function getTotalKeyboardItems(children) {
    var sum = 0;
    React__default.Children.forEach(children, function (child) {
      if (child && !child.props.disabled && !child.props.readOnly) {
        if (!styled.isStyledComponent(child.type) && child.type === Li || child.type.isKeyboardNavigable) {
          sum += 1;
        }

        if (areComponentsEqual(child.type, StickyContainer) || child.props.nested) {
          sum += getTotalKeyboardItems(child.props.children);
        }
      }
    });
    return sum;
  };

  var setCursorOnHover = function setCursorOnHover(index) {
    setLayerCursor(layerIndex);
    setHoverCursor(index);
    onHover(index);
  };

  var formatChildren = function formatChildren(children) {
    var indexRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      current: 0
    };
    return React__default.Children.map(children, function (child, j) {
      return child && !child.props.disabled && !child.props.readOnly ? child.props.nested ? React__default.cloneElement(child, child.props, formatChildren(child.props.children, indexRef)) : !styled.isStyledComponent(child.type) && !reactIs.isMemo(child.type) && areComponentsEqual(child.type, Li) || child.type.isKeyboardNavigable ? React__default.cloneElement(child, {
        hover: hoverCursor === indexRef.current && layerIndex === layerCursor,
        hoverCursor: hoverCursor,
        index: indexRef.current++,
        setCursorOnHover: setCursorOnHover,
        emitter: itemsEmitter,
        layerIndex: layerIndex,
        menuSlot: menuSlot
      }) : areComponentsEqual(child.type, StickyContainer) ? React__default.cloneElement(child, _objectSpread({}, child.props, {
        children: formatChildren(child.props.children, indexRef)
      })) : child : child;
    });
  };

  var touchStart = utils.createPressAndMoveEvent(function (e, prevPos) {
    // e.preventDefault()
    e.stopPropagation();
    e.target.dispatchEvent(new MouseEvent('mousemove', {
      bubbles: true
    }));
    return function (e, nextPos) {
      var delta = prevPos.clientY - nextPos.clientY;

      if (Math.abs(delta) > 10) {
        setCursorOnHover(-1);
      }
    };
  });
  return React__default.createElement(ContextListMenu, _extends({
    "data-drag": false,
    ref: ref,
    sub: sub,
    onWheel: function onWheel(e) {
      return e.stopPropagation();
    },
    onTouchStart: touchStart,
    withoutIcons: withoutIcons,
    onMouseDown: utils.stopPropagation()
  }, props), formatChildren(children));
});
var ContextMenu = React.forwardRef(function (_ref3, ref) {
  var _ref3$slot = _ref3.slot,
      slot = _ref3$slot === void 0 ? 'Popup' : _ref3$slot,
      sub = _ref3.sub,
      withoutIcons = _ref3.withoutIcons,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["slot", "sub", "withoutIcons", "children"]);

  var contextMenuRef = core.useEnsureRef(ref);

  var _usePositioning = usePositioning(contextMenuRef, rest),
      _usePositioning2 = _slicedToArray(_usePositioning, 3),
      positionInfo = _usePositioning2[0],
      placeholder = _usePositioning2[1],
      arrow = _usePositioning2[2];

  var _positionInfo = _objectSpread({}, positionInfo),
      atRight = _positionInfo.atRight,
      atBottom = _positionInfo.atBottom;

  var slotName = React.useMemo(function () {
    return getDialogLayersSize() === 0 ? slot : slot + '-' + (getDialogLayersSize() - 1);
  }, []);
  var enterAnimation = React.useMemo(function () {
    return [fadeIn$2, sub ? atRight ? slideRight : slideLeftOnLeft : atBottom ? slideDown : slideUpOnTop];
  }, [atRight, atBottom]);
  useFlipEnter(contextMenuRef, !!positionInfo && enterAnimation);
  useFlipLeave(contextMenuRef, !!positionInfo && enterAnimation, sub && {
    events: {
      mouseover: rest.onMouseMove
    }
  });
  return React__default.createElement(React__default.Fragment, null, placeholder, React__default.createElement(core.Fill, {
    name: slotName
  }, React__default.createElement(ContextMenuComponent, _extends({}, rest, {
    menuSlot: slot,
    sub: sub
  }, positionInfo, {
    ref: contextMenuRef,
    withoutIcons: withoutIcons
  }), arrow, children)));
});
ContextMenu.ListItem = ListItem;

var scrollWidth = function () {
  if (!window.document) return 0;
  var html = document.documentElement;
  var oldOverflow = html.style.overflowY;
  html.style.overflowY = 'scroll';
  var width = window.innerWidth - html.clientWidth;
  html.style.overflowY = oldOverflow;
  return width;
}();

var callIfFunction = function callIfFunction(prop) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }

  return typeof prop === "function" ? prop.apply(void 0, args) : prop;
};

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  ", ""]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var checkCustomScreenWidth = function checkCustomScreenWidth(sizeParis, customWidth) {
  var currentWidth = callIfFunction(customWidth);
  return !sizeParis.find(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        size = _ref6[0],
        type = _ref6[1];

    if (type === "min-width") {
      return currentWidth < size;
    }

    if (type === "max-width") {
      return currentWidth > size;
    }
  });
};

var media = function media() {
  for (var _len3 = arguments.length, sizePairs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    sizePairs[_key3] = arguments[_key3];
  }

  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return styled.css(["", ""], function (props) {
      var _props$theme, _props$theme2;

      return ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.overrideMediaWidth) ? checkCustomScreenWidth(sizePairs, (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.overrideMediaWidth) ? styled.css.apply(void 0, args) : "" : styled.css(["@media ", "{", "}"], sizePairs.map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            size = _ref8[0],
            type = _ref8[1];

        return "(".concat(type, ": ").concat(size + scrollWidth, "px)");
      }).join(' and '), styled.css.apply(void 0, args));
    });
  };
};
media.mobile = media([600, 'max-width']);

media.between = function (min, max) {
  return media([min, 'min-width'], [max, 'max-width']);
};

media.max = function (n) {
  return media([n, 'max-width']);
};

media.min = function (n) {
  return media([n, 'min-width']);
};

media.desktop = media([601, 'min-width']);

var getFrameOffset = function getFrameOffset(i, total) {
  return Math.round(i * 100 / (total - 1));
};

var emotion = createEmotion({
  nonce: __webpack_nonce__
});
var oneWayAnimation = function oneWayAnimation() {
  for (var _len5 = arguments.length, frames = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    frames[_key5] = arguments[_key5];
  }

  return emotion.keyframes(_templateObject$7(), frames.map(function (frame, i) {
    return !frame ? '' : "".concat(getFrameOffset(i, frames.length), "% {\n      ").concat(frame, "\n    }");
  }));
};
var animationTiming = function animationTiming(props) {
  return function () {
    for (var _len7 = arguments.length, animations = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      animations[_key7] = arguments[_key7];
    }

    return animations.filter(function (_) {
      return _;
    }).map(function (_) {
      return _ + ' ' + props;
    }).join(',');
  };
};
var identityTranslateFrames = oneWayAnimation('transform: translateY(0);', 'transform: translateY(0);');
var identityOpacityFrames = oneWayAnimation('opacity: 1;', 'opacity:1;');

var LoadingBar = styled__default.div.withConfig({
  displayName: "PageLoader__LoadingBar",
  componentId: "sc-96jeob-0"
})(["width:100%;border-radius:0 1px 1px 0;height:4px;position:fixed;background:", ";transform:translateX(-100%);", " left:0;z-index:99999;box-shadow:", ";", " ", ""], function (props) {
  return props.bottom ? styled.css(["", ""], utils.getColor('main')) : "#84D359";
}, function (props) {
  return props.bottom ? "bottom:55px;" : "top: 0;";
}, function (props) {
  return props.bottom ? "0 0 1px 1px rgba(0,132,214,0.2);" : "0 0 2px 0 rgba(0,0,0,0.5);";
}, function (props) {
  return props.loading && "\n    transform: translateX(-30%);\n    transition: transform 1.5s ease;\n  ";
}, function (props) {
  return props.closing && "\n    transform: translateX(0);\n    transition: transform 0.3s ease-in;\n  ";
});
var PageLoader = function PageLoader(_ref) {
  var isLoading = _ref.isLoading;
  var loader = core.useToggle();
  React.useEffect(function () {
    if (isLoading) {
      loader.open();
    } else {
      loader.closeAfter(500);
    }
  }, [isLoading]);
  return React__default.createElement(LoadingBar, {
    loading: loader.isOpen,
    closing: loader.closing
  });
};
var animation$2 = utils.oneWayAnimation('transform:translateX(-30%);', 'transform:translateX(0);');
var SuspenseLoadingBar = function SuspenseLoadingBar() {
  var ref = React__default.useRef();
  useFlipLeave(ref, animation$2, {
    reverse: false,
    timing: animationTiming('0.3s ease-in')
  });
  return React__default.createElement(LoadingBar, {
    ref: ref,
    loading: true
  });
};

var isNodeJunction = function isNodeJunction(nextNode) {
  return nextNode && !nextNode.hasChangedLine && nextNode.words[0] !== '';
};

var calculateCanvasFillWidth = function calculateCanvasFillWidth(nodes, maxWidth, ctx) {
  var lineCount = 0;
  var currentNodeLine = [];
  var biggestWidth = 0;
  var previousNodesLineWidth = 0;
  var currentMultiNodeWordWidth = 0;
  nodes.forEach(function (_ref, nodeIndex) {
    var font = _ref.font,
        hasChangedLine = _ref.hasChangedLine,
        words = _ref.words;
    ctx.font = font;
    var nextNode = nodes[nodeIndex + 1];
    words.forEach(function (word, wordIndex) {
      var _ctx$measureText = ctx.measureText(currentNodeLine.concat(word || (currentNodeLine.length ? '' : ' ')).join(' ')),
          width = _ctx$measureText.width;

      var realizedWidth = width + previousNodesLineWidth;
      var overflowed = realizedWidth >= maxWidth;
      var lastWord = wordIndex === words.length - 1;

      if (!overflowed) {
        if (lastWord && nextNode && !nextNode.hasChangedLine) {
          previousNodesLineWidth = realizedWidth;
          currentNodeLine = [];

          if (word !== '' && isNodeJunction(nextNode)) {
            currentMultiNodeWordWidth += ctx.measureText(word || ' ').width;
          }
        } else {
          currentNodeLine.push(word);
          currentMultiNodeWordWidth = 0;
          biggestWidth = biggestWidth > realizedWidth ? biggestWidth : realizedWidth;
        }
      } else {
        lineCount++;

        if (lastWord) {
          currentMultiNodeWordWidth += ctx.measureText(word || ' ').width;
          previousNodesLineWidth = currentMultiNodeWordWidth;
          currentNodeLine = [];
        } else {
          previousNodesLineWidth = currentMultiNodeWordWidth;
          currentMultiNodeWordWidth = 0;
          currentNodeLine = [word];
        }
      }

      if (lastWord && (!nextNode || (nextNode === null || nextNode === void 0 ? void 0 : nextNode.hasChangedLine))) {
        lineCount++;
        currentMultiNodeWordWidth = 0;
        currentNodeLine = [];
        previousNodesLineWidth = 0;
      }
    });
  });
  return {
    max: biggestWidth,
    lines: lineCount
  };
};

var getCanvasFillWidth = function getCanvasFillWidth(nodes, maxWidth, ctx, maxLines) {
  var _calculateCanvasFillW = calculateCanvasFillWidth(nodes, maxWidth - 1, ctx),
      max = _calculateCanvasFillW.max,
      lines = _calculateCanvasFillW.lines;

  if (lines > maxLines) {
    return null;
  } else {
    var smallerResult = getCanvasFillWidth(nodes, max - 1, ctx, lines);

    if (smallerResult === null || max === smallerResult) {
      return maxLines === undefined ? maxWidth : Math.ceil(max);
    } else {
      return smallerResult;
    }
  }
};

var FillLastLineResizer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FillLastLineResizer, _React$Component);

  function FillLastLineResizer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FillLastLineResizer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FillLastLineResizer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.fontIsLoaded = false;

    _this.setRef = function (el) {
      _this.el = el;

      if (el && parseInt(_this.el.style.maxWidth, 10) !== parseInt(_this.lastMaxWidth, 10)) {
        _this.resizeEvent();
      }
    };

    _this.resizeEvent = function (fontLoadedOrEvent) {
      var fromDialog = _typeof(fontLoadedOrEvent) === 'object' ? fontLoadedOrEvent.detail && fontLoadedOrEvent.detail.dialog : false;
      if (fromDialog) return;
      var fontAlreadyLoaded = window.getComputedStyle(_this.el).fontWeight === '500' && window.getComputedStyle(_this.el).fontFamily.indexOf('Roboto') > 0;

      if (fontAlreadyLoaded) {
        _this.el.style.fontFamily = 'Roboto, sans-serif';
        _this.fontIsLoaded = true;
      }

      if (_this.fontIsLoaded || _this.props.resizeOnMount || fontLoadedOrEvent === true || document.readyState === 'complete') {
        _this.fontIsLoaded = true;
      } else {
        return;
      }

      _this.el.style.removeProperty('max-width');

      if (_this.props.shouldCancelResize === true || typeof _this.props.shouldCancelResize === 'function' && _this.props.shouldCancelResize()) {
        return;
      }

      if (utils.isMobile() && _this.el.firstElementChild) {
        return;
      }

      var _this$el = _this.el,
          offsetWidth = _this$el.offsetWidth,
          offsetHeight = _this$el.offsetHeight;

      if (offsetWidth && offsetHeight) {
        var range = document.createRange();
        range.setStart(_this.el, 0);
        range.setEnd(_this.el, _this.el.childNodes.length);

        if (range.getClientRects().length <= 1) {
          return;
        }

        var newMaxWidth = 0;

        if (_this.props.withoutCanvas) {
          newMaxWidth = _this.getMaxWidth(_this.el, offsetHeight, offsetWidth, 256, offsetWidth);
        } else {
          try {
            var canvasCtx = document.createElement("canvas").getContext("2d");
            var nodeIterator = document.createNodeIterator(_this.el, NodeFilter.SHOW_TEXT);
            var text = _this.el.innerText;
            var lastIndex = -1;
            var node;
            var nodes = [];

            while (node = nodeIterator.nextNode()) {
              var currentText = node.textContent.replace(/ +/g, ' ');
              var currentIndex = text.indexOf(currentText, lastIndex + 1);
              nodes.push({
                font: window.getComputedStyle(node.parentElement).font,
                hasChangedLine: text[currentIndex - 1] === '\n',
                words: currentText.split(' ')
              });
              lastIndex = currentIndex;
            }

            newMaxWidth = getCanvasFillWidth(nodes, offsetWidth, canvasCtx);
          } catch (e) {
            console.log(e);
            newMaxWidth = offsetWidth;
          }
        }

        _this.el.style.maxWidth = newMaxWidth + 'px';
        var newOffsetHeight = _this.el.offsetHeight; // confere se o maxWidth antigo ainda serve, garantir que não haja influencia de um ou outro pixel

        if (_this.lastMaxWidth) {
          _this.el.style.maxWidth = _this.lastMaxWidth + 'px';
          var lastOffsetHeight = _this.el.offsetHeight;

          if (newOffsetHeight !== lastOffsetHeight || _this.lastMaxWidth >= _this.el.offsetWidth) {
            // if (this.el.tagName.toLowerCase()==='ul') {
            // console.log(newMaxWidth)
            // }
            _this.lastMaxWidth = newMaxWidth;
            _this.el.style.maxWidth = _this.lastMaxWidth + 'px';
          }
        } else {
          _this.lastMaxWidth = newMaxWidth;
        }
      }
    };

    _this.getMaxWidth = function (element, prevHeight, prevWidth, window, originalWidth) {
      var newWidth = Math.max(1, prevWidth - window);
      element.style.maxWidth = newWidth + 'px';

      if (element.offsetHeight === prevHeight && prevWidth > 10) {
        return _this.getMaxWidth(element, prevHeight, newWidth, window, originalWidth);
      } else if (window > 1) {
        return _this.getMaxWidth(element, prevHeight, prevWidth, window / 2, originalWidth);
      } else if (prevWidth < 10) {
        return originalWidth > prevWidth ? originalWidth : 10;
      } else {
        return prevWidth + 1;
      }
    };

    return _this;
  }

  _createClass(FillLastLineResizer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('stepResize', this.resizeEvent);

      if (document.readyState === 'complete') {
        this.resizeEvent();
      } else {
        window.addEventListener('load', this.resizeEvent);

        if (window.document.fonts && window.document.fonts.ready && window.document.fonts.ready.catch) {
          window.document.fonts.ready.catch(function (_) {
            return _;
          }).then(function () {
            window.removeEventListener('load', _this2.resizeEvent);

            _this2.resizeEvent(true);
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('stepResize', this.resizeEvent);
      window.removeEventListener('load', this.resizeEvent);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.resizeEvent();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this3 = this;

      var ignoreHtml = nextProps.dangerouslySetInnerHTML && this.props.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html === this.props.dangerouslySetInnerHTML.__html;
      var isShallowEqual = Object.keys(nextProps).every(function (key) {
        return _this3.props[key] === nextProps[key] || ignoreHtml && key === "dangerouslySetInnerHTML";
      });
      return !isShallowEqual;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          Tag = _this$props.Tag,
          linkColor = _this$props.linkColor,
          resizeOnMount = _this$props.resizeOnMount,
          shouldCancelResize = _this$props.shouldCancelResize,
          rest = _objectWithoutProperties(_this$props, ["Tag", "linkColor", "resizeOnMount", "shouldCancelResize"]);

      return React__default.createElement(Tag, _extends({
        ref: this.setRef
      }, rest));
    }
  }]);

  return FillLastLineResizer;
}(React__default.Component);
FillLastLineResizer.defaultProps = {
  Tag: 'div'
};

FillLastLineResizer.ul = function (props) {
  return React__default.createElement(FillLastLineResizer, _extends({
    Tag: "ul"
  }, props));
};

FillLastLineResizer.h2 = function (props) {
  return React__default.createElement(FillLastLineResizer, _extends({
    Tag: "h2"
  }, props));
};

var DEFAULT_ANIMATION = utils.oneWayAnimation("opacity: 1;", "opacity: 0;");
var AnimationBlockContainer = styled__default.div.withConfig({
  displayName: "TransitionDiv__AnimationBlockContainer",
  componentId: "sc-1sh2xah-0"
})(["", " position:relative;"], function (props) {
  return props.inline ? 'display: inline-block; ' : '';
});
var TransitionDiv = function TransitionDiv(_ref) {
  var children = _ref.children,
      animation = _ref.animation,
      skipChromeFix = _ref.skipChromeFix,
      className = _ref.className,
      block = _ref.block,
      inline = _ref.inline,
      rest = _objectWithoutProperties(_ref, ["children", "animation", "skipChromeFix", "className", "block", "inline"]);

  var blockRef = React.useRef();

  var overflowEffect = function overflowEffect() {
    if (blockRef.current) {
      var prevOverflow = blockRef.current.style.overflow;
      blockRef.current.style.overflow = 'hidden';
      return function () {
        blockRef.current.style.overflow = prevOverflow;
      };
    }
  };

  var content = children ? React__default.createElement(FlipList, _extends({
    smallJumpFix: inline && -3,
    effect: overflowEffect,
    skipChromeFix: skipChromeFix,
    animation: animation || DEFAULT_ANIMATION
  }, rest), [React__default.createElement("div", {
    className: block || inline ? "" : className,
    key: "first"
  }, children)]) : React__default.createElement(FlipList, _extends({
    smallJumpFix: inline && -3,
    effect: overflowEffect,
    skipChromeFix: skipChromeFix,
    animation: animation || DEFAULT_ANIMATION
  }, rest), []);
  return block || inline ? React__default.createElement(AnimationBlockContainer, {
    inline: inline,
    ref: blockRef,
    className: className
  }, content) : content;
};

var BlockContainer$1 = styled__default.div.withConfig({
  displayName: "SwitchDiv__BlockContainer",
  componentId: "htfwpl-0"
})(["position:relative;"]);

var _twoWayAnimation$4 = utils.twoWayAnimation('opacity: 0;', 'opacity: 0;', 'opacity: 1;'),
    _twoWayAnimation2$4 = _slicedToArray(_twoWayAnimation$4, 2),
    fadeIn$3 = _twoWayAnimation2$4[0],
    relativeFadeout = _twoWayAnimation2$4[1];

var absoluteOnLeave = utils.oneWayAnimation('position: absolute;', 'position: absolute;');
var fadeOut$2 = [absoluteOnLeave, relativeFadeout];
var SwitchDiv = function SwitchDiv(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$enterAnimation = _ref.enterAnimation,
      enterAnimation = _ref$enterAnimation === void 0 ? fadeIn$3 : _ref$enterAnimation,
      effect = _ref.effect,
      _ref$leaveAnimation = _ref.leaveAnimation,
      leaveAnimation = _ref$leaveAnimation === void 0 ? fadeOut$2 : _ref$leaveAnimation,
      skipChromeFix = _ref.skipChromeFix,
      on = _ref.on,
      rest = _objectWithoutProperties(_ref, ["children", "className", "enterAnimation", "effect", "leaveAnimation", "skipChromeFix", "on"]);

  var switchAnimation = core.useLazyConstant(willUseFlipSwitch);
  return React__default.createElement(SwitchContainer, {
    enterAnimation: enterAnimation,
    effect: effect,
    className: className,
    leaveAnimation: leaveAnimation,
    key: on + "",
    switchAnimation: switchAnimation,
    children: children
  });
};

var SwitchContainer = function SwitchContainer(_ref2) {
  var children = _ref2.children,
      switchAnimation = _ref2.switchAnimation,
      className = _ref2.className,
      effect = _ref2.effect,
      enterAnimation = _ref2.enterAnimation,
      leaveAnimation = _ref2.leaveAnimation;
  var contentRef = React.useRef();
  switchAnimation(contentRef, enterAnimation, leaveAnimation, {
    effect: effect
  });
  return React__default.createElement(BlockContainer$1, {
    ref: contentRef,
    className: className
  }, utils.callIfFunction(children));
};

var FormatDate = function FormatDate(_ref) {
  var date = _ref.date,
      format = _ref.format,
      noUTC = _ref.noUTC,
      children = _ref.children;
  return React__default.createElement(core.StartlibsConsumer, null, function (_ref2) {
    var dateMessages = _ref2.dateMessages;

    if (!date) {
      return null;
    }

    var formatted = utils.formatDate(new Date(date), format, dateMessages, noUTC);
    return children ? children(formatted) : formatted;
  });
};

var Image = React.forwardRef(function (_ref, ref) {
  var dom = _ref.dom,
      src = _ref.src,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, ["dom", "src", "style"]);

  var _useState = React.useState(typeof src === 'string' ? src : src && URL.createObjectURL(src)),
      _useState2 = _slicedToArray(_useState, 2),
      image = _useState2[0],
      setImage = _useState2[1];

  React.useEffect(function () {
    if (src) {
      var imageStr = typeof src === 'string' ? src : URL.createObjectURL(src);
      var img = document.createElement('img');

      img.onload = function () {
        setImage(imageStr);
      };

      img.src = imageStr;
    } else {
      setImage("");
    }
  }, [src]);
  return dom ? React__default.createElement("img", _extends({}, rest, {
    src: image,
    ref: ref
  })) : React__default.createElement("div", _extends({}, rest, {
    style: _objectSpread({}, style, {
      backgroundImage: "url(\"".concat(image, "\")")
    }),
    ref: ref
  }));
});

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n      @supports (position: sticky) {\n        top: 0;\n        margin-right: -0.75rem;\n      }\n    "]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var DialogWithImageHeader = styled__default(Dialog).withConfig({
  displayName: "DialogWithImageHeader",
  componentId: "sc-1f1ry4g-0"
})(["max-width:51rem;", "{background:", ";text-shadow:none;color:rgba(120,120,120,1);font-size:20px;box-shadow:rgba(0,0,0,0.2) 0px 1px 3px 0px,rgba(0,0,0,0.05) 0px 0px 0px 1px;width:36px;height:36px;line-height:36px;transition:0.1s ease-out;:hover{background-color:rgb(230,230,230);}:active{background-color:rgb(220,220,220);transition:0s ease-out;}@supports (position:sticky){position:sticky;top:-2.5rem;right:0rem;float:right;margin-right:-1.25rem;margin-top:0.75rem;}", "}"], CloseIcon, utils.getColor('gray240'), utils.media.mobile(_templateObject$8()));

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n    min-height: 100%;\n    overflow: hidden;\n  "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n      font-size: 16px;\n    "]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n    display:block;\n    position:fixed;\n    top:0;\n    left:0;\n    bottom:0;\n    z-index:1000;\n    transition: 0.25s transform ease-out;\n    background-color: ", ";\n    box-shadow: -5px 0 20px 5px rgba(0,0,0,0.4);\n    border-radius: 0;\n    ", "\n  "]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var SideMenu = styled__default.div.withConfig({
  displayName: "DialogWithSidebar__SideMenu",
  componentId: "suvg9r-0"
})(["background-color:", ";border-top-left-radius:10px;border-bottom-left-radius:10px;width:19rem;flex-shrink:0;padding:1.25rem 0;", " ", ""], utils.getColor('gray240'), function (props) {
  return !props.visibleOnDesktop && 'display:none;';
}, utils.media.mobile(_templateObject$9(), utils.getColor('gray240'), function (props) {
  return !props.isOpen && "\n      transform: translateX(-100%);\n      box-shadow: none;\n    ";
}));
var DialogTabMenu = styled__default.ul.withConfig({
  displayName: "DialogWithSidebar__DialogTabMenu",
  componentId: "suvg9r-1"
})(["cursor:default;overflow:auto;text-align:left;color:inherit;user-select:none;li{position:relative;padding:1rem 2rem 1rem 4.1rem;font-size:14px;", ":hover{background-color:rgba(0,0,0,0.1);cursor:pointer;}&.selected{color:", ";background:rgba(0,132,214,0.125);pointer-events:none;}}.icon{position:absolute;left:1rem;top:50%;transform:translateY(-50%);width:3rem;text-align:center;line-height:0;font-size:26px;}", ""], utils.media.mobile(_templateObject2$5()), utils.getColor('main'), function (props) {
  return props.menuTabIsOpen && "\n    li {\n      padding: 1.25rem 2rem 1.25rem 3.25rem;\n      border-radius: 6px\n    }\n    .icon{\n      left: 0;\n    }\n  ";
});

var _twoWayAnimation$5 = utils.twoWayAnimation('opacity: 0;', 'opacity: 0;', 'opacity: 1;'),
    _twoWayAnimation2$5 = _slicedToArray(_twoWayAnimation$5, 2),
    fadeIn$4 = _twoWayAnimation2$5[0],
    relativeFadeout$1 = _twoWayAnimation2$5[1];

var absoluteOnLeave$1 = utils.oneWayAnimation('position: absolute;', 'position: absolute;');
var fadeOut$3 = [absoluteOnLeave$1, relativeFadeout$1];
var MENU_TAB = '$menu$';
var DialogWithSidebarPresentation = function DialogWithSidebarPresentation(_ref) {
  var className = _ref.className,
      tabIsOpen = _ref.tabIsOpen,
      menuIsOpen = _ref.menuIsOpen,
      sidebar = _ref.sidebar,
      Content = _ref.Content,
      openTab = _ref.openTab,
      footer = _ref.footer,
      children = _ref.children,
      title = _ref.title,
      auxiliarActions = _ref.auxiliarActions,
      props = _objectWithoutProperties(_ref, ["className", "tabIsOpen", "menuIsOpen", "sidebar", "Content", "openTab", "footer", "children", "title", "auxiliarActions"]);

  var tab = core.useToggle(tabIsOpen);
  var sideMenu = core.usePopupToggle(menuIsOpen);
  var ref = React.useRef();
  var switchAnimation = core.useLazyConstant(willUseFlipSwitch);
  var menuTabIsOpen = tab.isOpen === MENU_TAB;
  return React__default.createElement(DialogContainer, _extends({}, props, {
    ref: ref
  }), function (_ref2) {
    var confirmCloseDialog = _ref2.confirmCloseDialog;
    return React__default.createElement("div", {
      className: className + " JS-has-wc",
      ref: ref
    }, props.closeDialog && React__default.createElement(CloseIcon, {
      onClick: confirmCloseDialog
    }), React__default.createElement(SideMenu, {
      isOpen: sideMenu.isOpen,
      visibleOnDesktop: true
    }, sidebar(tab)), React__default.createElement("div", {
      className: (menuTabIsOpen ? "menuTabIsOpen " : "") + "main-container"
    }, React__default.createElement("h2", null, menuTabIsOpen ? "Configurações gerais" : React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
      className: "icon icon-menu mobile-only",
      onClick: sideMenu.open
    }), title(tab))), React__default.createElement(React__default.Suspense, {
      fallback: React__default.createElement(TabContent, {
        key: "loading",
        switchAnimation: switchAnimation,
        tab: tab,
        children: React__default.createElement(Loading, {
          absolute: true
        })
      })
    }, React__default.createElement(TabContent, {
      key: tab.isOpen,
      switchAnimation: switchAnimation,
      tab: tab,
      Content: Content,
      children: children
    })), footer && React__default.createElement(DialogFooter, null, auxiliarActions && React__default.createElement(FooterAuxiliaryContainer, null, utils.callIfFunction(auxiliarActions)), utils.callIfFunction(footer, tab))));
  });
};

var TabContent = function TabContent(_ref3) {
  var Content = _ref3.Content,
      children = _ref3.children,
      tab = _ref3.tab,
      switchAnimation = _ref3.switchAnimation;
  var contentRef = React.useRef();
  switchAnimation(contentRef, fadeIn$4, fadeOut$3);
  return React__default.createElement("div", {
    ref: contentRef,
    className: "dialog-content"
  }, utils.callIfFunction(Content, tab), utils.callIfFunction(children, tab));
};

var DialogWithSidebar = styled__default(function (props) {
  return React__default.createElement(Dialog, _extends({
    fullscreenOnMobile: true,
    as: DialogWithSidebarPresentation
  }, props));
}).withConfig({
  displayName: "DialogWithSidebar",
  componentId: "suvg9r-2"
})(["max-width:59rem;display:flex;padding:0;flex-direction:row;", ""], utils.media.mobile(_templateObject3$3()));

var MobileBubbleDialogFooter = styled__default.div.withConfig({
  displayName: "MobileBubbleDialog__MobileBubbleDialogFooter",
  componentId: "riqrem-0"
})(["background-color:", ";min-height:5rem;color:", ";font-size:13px;font-weight:500;text-transform:uppercase;padding:1rem;user-select:none;display:flex;align-items:center;justify-content:center;cursor:pointer;border-bottom-left-radius:10px;border-bottom-right-radius:10px;:active{background:rgb(232,232,232);}"], utils.getColor('gray240'), utils.getColor('main'));
var MobileBubbleDialog = styled__default(function (_ref) {
  var className = _ref.className,
      footer = _ref.footer,
      Content = _ref.Content,
      children = _ref.children,
      title = _ref.title,
      illustration = _ref.illustration,
      icon = _ref.icon,
      auxiliarActions = _ref.auxiliarActions,
      props = _objectWithoutProperties(_ref, ["className", "footer", "Content", "children", "title", "illustration", "icon", "auxiliarActions"]);

  var ref = React.useRef();
  return React__default.createElement(DialogContainer, _extends({}, props, {
    closeOnClick: true,
    ref: ref,
    DialogErrorContent: DialogErrorContent,
    title: title
  }), function (_ref2) {
    var confirmCloseDialog = _ref2.confirmCloseDialog;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      className: className,
      ref: ref
    }, children && utils.callIfFunction(children), React__default.createElement(MobileBubbleDialogFooter, {
      onClick: confirmCloseDialog
    }, "Fechar")));
  });
}).withConfig({
  displayName: "MobileBubbleDialog",
  componentId: "riqrem-1"
})(["border-radius:10px;background-color:white;width:100%;margin:auto;position:relative;align-self:baseline;overflow:hidden;@supports (flex-wrap:wrap){display:flex;flex-direction:column;}"]);

exports.AnimatedModal = AnimatedModal;
exports.AnimationBlockContainer = AnimationBlockContainer;
exports.Button = Button;
exports.CloseIcon = CloseIcon;
exports.ConfirmDialog = ConfirmDialog;
exports.ContextListMenu = ContextListMenu;
exports.ContextMenu = ContextMenu;
exports.ContextMenuComponent = ContextMenuComponent;
exports.DefaultArrow = DefaultArrow;
exports.DefaultConfirmDialog = DefaultConfirmDialog;
exports.DefaultWarningDialog = DefaultWarningDialog;
exports.Dialog = Dialog;
exports.DialogContainer = DialogContainer;
exports.DialogContent = DialogContent;
exports.DialogContentWrapper = DialogContentWrapper;
exports.DialogError = DialogError;
exports.DialogErrorContent = DialogErrorContent;
exports.DialogFooter = DialogFooter;
exports.DialogIcon = DialogIcon;
exports.DialogTabMenu = DialogTabMenu;
exports.DialogTitle = DialogTitle;
exports.DialogWithImageHeader = DialogWithImageHeader;
exports.DialogWithSidebar = DialogWithSidebar;
exports.DialogWithSidebarPresentation = DialogWithSidebarPresentation;
exports.DraggableContainer = DraggableContainer;
exports.DraggableItem = DraggableItem;
exports.DropdownIcon = DropdownIcon;
exports.DroppableContainer = DroppableContainer;
exports.ErrorBoundary = ErrorBoundary;
exports.FillLastLineResizer = FillLastLineResizer;
exports.FlipList = FlipList;
exports.FooterAuxiliaryContainer = FooterAuxiliaryContainer;
exports.FormatDate = FormatDate;
exports.Icon = Icon;
exports.Image = Image;
exports.Li = Li;
exports.Link = Link;
exports.ListHeading = ListHeading;
exports.ListItem = ListItem;
exports.ListMenu = ListMenu;
exports.ListSeparator = ListSeparator;
exports.Loading = Loading;
exports.LoadingBar = LoadingBar;
exports.LoadingDiv = LoadingDiv;
exports.MENU_TAB = MENU_TAB;
exports.MobileBubbleDialog = MobileBubbleDialog;
exports.Modal = Modal;
exports.ModalContainer = ModalContainer;
exports.Notifications = Notifications;
exports.OnClickLoadingButton = OnClickLoadingButton;
exports.PageLoader = PageLoader;
exports.PersistentNotifications = PersistentNotifications;
exports.Popup = Popup;
exports.Reposition = Reposition;
exports.SideMenu = SideMenu;
exports.SimpleLi = SimpleLi;
exports.SplitColumnsContainer = SplitColumnsContainer;
exports.StickyContainer = StickyContainer;
exports.SuspenseLoadingBar = SuspenseLoadingBar;
exports.SwitchDiv = SwitchDiv;
exports.TextButton = TextButton;
exports.Tooltip = Tooltip;
exports.TransitionDiv = TransitionDiv;
exports.WarningDialog = WarningDialog;
exports.WarningDialogIcon = WarningDialogIcon;
exports.WarningDialogTitle = WarningDialogTitle;
exports.addPositioningBound = addPositioningBound;
exports.contextMenuLayersQuantity = contextMenuLayersQuantity;
exports.defaultAnimationMaker = defaultAnimationMaker;
exports.dialogFadeInDown = dialogFadeInDown;
exports.dialogModalIn = dialogModalIn;
exports.dialogModalOut = dialogModalOut;
exports.fixDoubledLastMarginBottom = fixDoubledLastMarginBottom;
exports.formatAnimation = formatAnimation;
exports.getClientRectAnimation = getClientRectAnimation;
exports.getDialogLayersSize = getDialogLayersSize;
exports.hidePersistentNotifications = hidePersistentNotifications;
exports.isFakeScrolled = isFakeScrolled;
exports.morph = morph;
exports.openPersistentNotification = openPersistentNotification;
exports.preventDialogPop = preventDialogPop;
exports.removeWindowScroll = removeWindowScroll;
exports.setNotification = setNotification;
exports.setWarningDialog = setWarningDialog;
exports.toPosition = toPosition;
exports.useDialog = useDialog;
exports.useDialogLayers = useDialogLayers;
exports.useDialogWithToggle = useDialogWithToggle;
exports.useFlip = useFlip;
exports.useFlipAnimation = useFlipAnimation;
exports.useFlipEnter = useFlipEnter;
exports.useFlipLeave = useFlipLeave;
exports.useIsHiddenPersistentNotifications = useIsHiddenPersistentNotifications;
exports.useNotification = useNotification;
exports.useNotificationRef = useNotificationRef;
exports.usePositioning = usePositioning;
exports.useWarningDialog = useWarningDialog;
exports.waitForPop = waitForPop;
exports.willSetNotification = willSetNotification;
exports.willUseFlip = willUseFlip;
exports.willUseFlipSwitch = willUseFlipSwitch;
exports.willUseIsSticky = willUseIsSticky;
